export default {
    "AI 员工": "AI 員工",
    "18 位 AI 员工": "18 位 AI 員工",
    "最忙的是拉流量那几位": "最忙的是拉流量那幾位",
    "商品有人采、图片有人翻、订单有人盯——这些都不难。真正决定一间店活不活得下去的，是": "商品有人採、圖片有人翻、訂單有人盯——這些都不難。真正決定一間店活不活得下去的，是",
    "有没有人来": "有沒有人來",
    "。所以增长组的 5 位员工，天天在做的就是这件事：先把店修到能接住流量，再把流量一处一处引过来。": "。所以增長組的 5 位員工，天天在做的就是這件事：先把店修到能接住流量，再把流量一處一處引過來。",
    "免费开店，让 AI 员工先体检一遍": "免費開店，讓 AI 員工先體檢一遍",
    "看自动营销怎么跑": "看自動行銷怎麼跑",
    "18 位员工，四组分工": "18 位員工，四組分工",
    "9 个内容渠道": "9 個內容渠道",
    "12 项店铺体检": "12 項店鋪體檢",
    "4 条自动序列": "4 條自動序列",
    "这页分两半。前半说": "這頁分兩半。前半說",
    "流量是怎么被拉进来的": "流量是怎麼被拉進來的",
    "，后半是 18 位员工分别管什么。赶时间就直接往下翻到「30 天」。": "，後半是 18 位員工分別管什麼。趕時間就直接往下翻到「30 天」。",
    "位 AI 员工，分四组": "位 AI 員工，分四組",
    "个内容渠道一件商品全铺": "個內容渠道一件商品全鋪",
    "项店铺体检，按浪费钱排序": "項店鋪體檢，按浪費錢排序",
    "条自动营销序列": "條自動行銷序列",
    "先找堵点": "先找堵點",
    "流量不是没来，是被挡住了": "流量不是沒來，是被擋住了",
    "很多店花了力气发内容，还是没单。问题常常不在内容，而在「页面接不住」——标题是中文、没主图、没描述、价格离谱。这些不修，来多少人都一样。": "很多店花了力氣發內容，還是沒單。問題常常不在內容，而在「頁面接不住」——標題是中文、沒主圖、沒描述、價格離譜。這些不修，來多少人都一樣。",
    "12 项体检，按「会不会浪费钱」排序": "12 項體檢，按「會不會浪費錢」排序",
    "先花三分钟，把店过一遍": "先花三分鐘，把店過一遍",
    "「推广总控」打开就跑一次体检：不是给你一张漂亮的分数表，而是直接告诉你哪几项": "「推廣總控」打開就跑一次體檢：不是給你一張漂亮的分數表，而是直接告訴你哪幾項",
    "现在推就等于扔钱": "現在推就等於扔錢",
    "，该修的先修，能放的最后再说。": "，該修的先修，能放的最後再說。",
    "阻塞项 / 建议修 / 已通过，三档分清": "阻塞項 / 建議修 / 已通過，三檔分清",
    "每一项都写清楚「不修的后果」，不是打分了事": "每一項都寫清楚「不修的後果」，不是打分了事",
    "体检完直接收敛到 15 个商品，不让你 65 个一起推": "體檢完直接收斂到 15 個商品，不讓你 65 個一起推",
    "体检用的是你店里的真实数据：商品数、SEO 地址、主图、描述、分类、价格分布、买家数。": "體檢用的是你店裡的真實數據：商品數、SEO 地址、主圖、描述、分類、價格分布、買家數。",
    "不是模板打分": "不是模板評分",
    "。": "。",
    "店铺体检": "店鋪體檢",
    "刚刚 · 65 个在售商品": "剛剛 · 65 個在售商品",
    "3 项待修": "3 項待修",
    "商品标题语言": "商品標題語言",
    "阻塞": "阻塞",
    "52 / 65 个标题疑似中文，而站点语言是 Deutsch": "52 / 65 個標題疑似中文，而站點語言是 Deutsch",
    "先改主推那 10 个，不用 65 个一起改 →": "先改主推那 10 個，不用 65 個一起改 →",
    "商品主图": "商品主圖",
    "只有 41 / 65 个商品有主图": "只有 41 / 65 個商品有主圖",
    "没图的既进不了 Merchant Feed，也做不了 Pinterest": "沒圖的既進不了 Merchant Feed，也做不了 Pinterest",
    "价格合理性": "價格合理性",
    "建议修": "建議修",
    "2 个价格明显异常（最高 ¥38,600）": "2 個價格明顯異常（最高 ¥38,600）",
    "大概率是导入时汇率算错，逐个改回合理价": "大概率是導入時匯率算錯，逐個改回合理價",
    "品类归属": "品類歸屬",
    "通过": "通過",
    "品类集中在 3 个类目": "品類集中在 3 個類目",
    "体检项": "體檢項",
    "卡住会怎样": "卡住會怎樣",
    "谁来修": "誰來修",
    "在售商品": "在售商品",
    "可正常打开的商品不到 5 个，投多少流量都白搭": "可正常打開的商品不到 5 個，投多少流量都白搭",
    "你上架，巡检官列缺项": "你上架，巡檢官列缺項",
    "站点是德语、标题还是中文，当地人根本搜不到": "站點是德語、標題還是中文，當地人根本搜不到",
    "翻译本地化官": "翻譯本地化官",
    "SEO 描述": "SEO 描述",
    "搜索结果里没摘要，收录会慢上好几周": "搜索結果裡沒摘要，收錄會慢上好幾周",
    "SEO 优化师": "SEO 優化師",
    "进不了 Merchant Feed，也做不了 Pinterest": "進不了 Merchant Feed，也做不了 Pinterest",
    "图片处理官": "圖片處理官",
    "分不清卖什么，就选不了渠道和人群": "分不清賣什麼，就選不了渠道和人群",
    "你归类，AI 给建议": "你歸類，AI 給建議",
    "汇率算错留个「¥38,600」的杯子，来人也转化不了": "匯率算錯留個「¥38,600」的杯子，來人也轉化不了",
    "定价策略官": "定價策略官",
    "库存": "庫存",
    "推爆了发现没货，等于白推一轮": "推爆了發現沒貨，等於白推一輪",
    "订单管家": "訂單管家",
    "SEO 地基": "SEO 地基",
    "没有 sitemap，搜索引擎不知道你有多少页": "沒有 sitemap，搜索引擎不知道你有多少頁",
    "平台自动生成": "平台自動生成",
    "另外还有合规页面、已发内容、站内文章、已成交买家四项，一起算在 12 项里。": "另外還有合規頁面、已發內容、站內文章、已成交買家四項，一起算在 12 項裡。",
    "最实在的一步": "最實在的一步",
    "30 天，每天做什么已经写好了": "30 天，每天做什麼已經寫好了",
    "体检完点一下「生成 30 天方案」，出来的不是一份「建议加强内容运营」的空话，而是 30 条具体任务：哪天做什么、为什么做、点开能直接跳到该改的页面。": "體檢完點一下「生成 30 天方案」，出來的不是一份「建議加強內容運營」的空話，而是 30 條具體任務：哪天做什麼、為什麼做、點開能直接跳到該改的頁面。",
    "第 1 周 · 修地基": "第 1 週 · 修地基",
    "这周": "這周",
    "故意不产出任何对外内容": "故意不產出任何對外內容",
    "。页面接不住流量，发了也是白花。先把 sitemap 交上去、异常价格改掉、商品归类、选出主推。": "。頁面接不住流量，發了也是白花。先把 sitemap 交上去、異常價格改掉、商品歸類、選出主推。",
    "提交 sitemap 与 Merchant Feed": "提交 sitemap 與 Merchant Feed",
    "改掉汇率算错的价格": "改掉匯率算錯的價格",
    "主推的 10 个商品改本地语言": "主推的 10 個商品改本地語言",
    "第 2 周 · 铺图钉": "第 2 週 · 鋪圖釘",
    "Pinterest 每天 2 个，一直排到第 14 天。商品主图现成，竖版 2:3 就是内容，不需要另外拍。": "Pinterest 每天 2 個，一直排到第 14 天。商品主圖現成，豎版 2:3 就是內容，不需要另外拍。",
    "零授权、零成本": "零授權、零成本",
    "描述里带商品链接": "描述裡帶商品連結",
    "有买家的话加一封新品通知": "有買家的話加一封新品通知",
    "第 3 周 · 写长尾": "第 3 週 · 寫長尾",
    "站内博客 3 篇，每篇围绕一个真实搜索词，正文 800 字，中间内链到商品页。发出去会进 sitemap，慢慢带收录。": "站內博客 3 篇，每篇圍繞一個真實搜索詞，正文 800 字，中間內鏈到商品頁。發出去會進 sitemap，慢慢帶收錄。",
    "「XX おすすめ」这种词": "「XX おすすめ」這種詞",
    "一键发成站内文章": "一鍵發成站內文章",
    "比广告便宜，比广告久": "比廣告便宜，比廣告久",
    "第 4 周 · 复盘加码": "第 4 週 · 復盤加碼",
    "看四个数：收录页数、站外访问、加购、订单。哪个渠道有访问就挪 70% 精力过去，其他的先停。": "看四個數：收錄頁數、站外訪問、加購、訂單。哪個渠道有訪問就挪 70% 精力過去，其他的先停。",
    "收录没动 → 查抓取错误": "收錄沒動 → 查抓取錯誤",
    "有点击没加购 → 补商品页细节": "有點擊沒加購 → 補商品頁細節",
    "有加购没下单 → 查运费和支付": "有加購沒下單 → 查運費和支付",
    "第 1 周的实际任务": "第 1 週的實際任務",
    "来自一份真实生成的方案 · 节奏和顺序都由店铺数据决定": "來自一份真實生成的方案 · 节奏和順序都由店鋪數據決定",
    "把站点地图提交给 Google": "把站點地圖提交給 Google",
    "打开 Search Console 提交 sitemap.xml；顺手在 Merchant Center 添加 feed/google.xml。这两步不花时间，但是后面所有流量的入口。": "打開 Search Console 提交 sitemap.xml；順手在 Merchant Center 添加 feed/google.xml。這兩步不花時間，但是後面所有流量的入口。",
    "第 1 天 · 不花钱": "第 1 天 · 不花錢",
    "改掉异常价格": "改掉異常價格",
    "这些商品价格明显不对，多半是导入时汇率算错。价格离谱的页面，投多少流量都转化不了。": "這些商品價格明顯不對，多半是導入時匯率算錯。價格離譜的頁面，投多少流量都轉化不了。",
    "第 1 天 · 点开就到商品列表": "第 1 天 · 點開就到商品列表",
    "选出这次主推的 10 个商品": "選出這次主推的 10 個商品",
    "系统按「有图、有详情、有 SEO 地址、价格正常、有库存」排过序。这 30 天只推这批，其余先不动。": "系統按「有圖、有詳情、有 SEO 地址、價格正常、有庫存」排過序。這 30 天只推這批，其餘先不動。",
    "第 3 天": "第 3 天",
    "主推商品的标题改成 Deutsche": "主推商品的標題改成 Deutsche",
    "只改主推那 10 个，不要 65 个一起改。标题里带上「是什么 + 给谁用 + 关键属性」——当地用户搜的是这个词，不是中文直译。": "只改主推那 10 個，不要 65 個一起改。標題裡帶上「是什麼 + 給誰用 + 關鍵屬性」——當地用戶搜的是這個詞，不是中文直譯。",
    "第 4 天 · 调翻译本地化官出稿": "第 4 天 · 調翻譯本地化官出稿",
    "补主推商品的 SEO 描述": "補主推商品的 SEO 描述",
    "每个 80~120 字，写清楚谁会买、解决什么问题、有什么细节。这段话会直接出现在搜索结果里，比广告文案还重要。": "每個 80~120 字，寫清楚誰會買、解決什麼問題、有什麼細節。這段話會直接出現在搜索結果裡，比廣告文案還重要。",
    "第 5 天 · 调 SEO 优化师出稿": "第 5 天 · 調 SEO 優化師出稿",
    "全站体检一遍": "全站體檢一遍",
    "缺主图、缺描述、零库存、断链全部列出来，能当场修的就修掉。": "缺主圖、缺描述、零庫存、斷鏈全部列出來，能當場修的就修掉。",
    "第 6 天 · 调店铺巡检官": "第 6 天 · 調店鋪巡檢官",
    "方案里的预期指标都标了推算依据，": "方案裡的預期指標都標了推算依據，",
    "我们不承诺效果": "我們不承諾效果",
    "。0 基础的站，30 天内 0 单是正常的——这句话写在方案里，不是藏在条款里。": "。0 基礎的站，30 天內 0 單是正常的——這句話寫在方案裡，不是藏在條款裡。",
    "内容产能": "內容產能",
    "一件商品，铺到 9 个渠道": "一件商品，鋪到 9 個渠道",
    "不是把同一段话复制九遍。Pinterest 要图钉描述，TikTok 要口播脚本，X 要短句，Google 商家要本地化措辞，站内博客要 800 字长文——这些是同一条卖点的九种写法。": "不是把同一段話複製九遍。Pinterest 要圖釘描述，TikTok 要口播腳本，X 要短句，Google 商家要本地化措辭，站內博客要 800 字長文——這些是同一條賣點的九種寫法。",
    "手冲咖啡滤杯 · 陶瓷": "手沖咖啡濾杯 · 陶瓷",
    "¥168 · 库存 42 · 已本地化": "¥168 · 庫存 42 · 已本地化",
    "选一件主推商品": "選一件主推商品",
    "图钉描述": "圖釘描述",
    "配图短文": "配圖短文",
    "帖子": "帖子",
    "短句": "短句",
    "口播脚本": "口播腳本",
    "私域话术": "私域話術",
    "频道稿": "頻道稿",
    "本地文案": "本地文案",
    "站内博客": "站內博客",
    "800 字长文": "800 字長文",
    "品牌名和固定标签带进每一篇": "品牌名和固定標籤帶進每一篇",
    "设一次，之后每一条都自动带上，不用每次重新交代语气。": "設一次，之後每一條都自動帶上，不用每次重新交代語氣。",
    "今天建议发哪个渠道": "今天建議發哪個渠道",
    "投递箱顶部直接给当天的排期，不用自己记 30 天日历。": "投遞箱頂部直接給當天的排程，不用自己記 30 天日曆。",
    "博客可以一键发成站内文章": "博客可以一鍵發成站內文章",
    "发布后进文章列表，被 sitemap 收录，成为长期的自然流量入口。": "發布後進文章列表，被 sitemap 收錄，成為長期的自然流量入口。",
    "说实话：文案是生成好的，发帖要你自己发。": "說實話：文案是生成好的，發帖要你自己發。",
    "平台不碰你的社媒账号，也不会拿你的账号去群发——所以不需要把 FB / IG 授权给我们。需要自动发的只有站内博客和营销邮件，这两条走的是你自己的系统。": "平台不碰你的社媒帳號，也不會拿你的帳號去群發——所以不需要把 FB / IG 授權給我們。需要自動發的只有站內博客和行銷郵件，這兩條走的是你自己的系統。",
    "这一页最重要的一段": "這頁最重要的一段",
    "自动营销：开了开关，它自己发": "自動行銷：開了開關，它自己發",
    "拉新是靠内容和渠道，一单一单攒的。但已经买过的人，不用再花钱去拉——他们就在你的订单里。自动营销干的就是这件不花广告费的事：按规则挑人、按场景写信、按额度慢慢发。": "拉新是靠內容和渠道，一單一單攢的。但已經買過的人，不用再花錢去拉——他們就在你的訂單裡。自動行銷幹的就是這件不花廣告費的事：按規則挑人、按場景寫信、按額度慢慢發。",
    "自动": "自動",
    "新品通知": "新品通知",
    "近": "近",
    "180 天": "180 天",
    "买过的人，告诉他们刚上架的新品。上新了没人知道，等于没上。": "買過的人，告訴他們剛上架的新品。上新了沒人知道，等於沒上。",
    "圈人依据：已付款订单 + 最近购买时间": "圈人依據：已付款訂單 + 最近購買時間",
    "弃购召回": "棄購召回",
    "加了购物车": "加了購物車",
    "2 小时": "2 小時",
    "还没下单，提醒回来结账；超过 7 天就不再发了——再久就没意义。": "還沒下單，提醒回來結帳；超過 7 天就不再發了——再久就沒意義。",
    "圈人依据：加车时间，2 小时 ~ 7 天之间": "圈人依據：加車時間，2 小時 ~ 7 天之間",
    "老客唤醒": "老客喚醒",
    "最后一单已经超过": "最後一單已經超過",
    "45 天": "45 天",
    "，请他们回来看看。老客回购的成本，比拉新低得多。": "，請他們回來看看。老客回購的成本，比拉新低得多。",
    "圈人依据：最后一单时间超过 45 天": "圈人依據：最後一單時間超過 45 天",
    "手动": "手動",
    "促销群发": "促銷群發",
    "所有下过单的顾客，按最近购买时间倒序。做活动时用，不适合天天发。": "所有下過單的顧客，按最近購買時間倒序。做活動時用，不適合天天發。",
    "圈人依据：全部已付款买家": "圈人依據：全部已付款買家",
    "怕打扰？三个上限替你守住": "怕打擾？三個上限替你守住",
    "宁可少发一封，也别被退订": "寧可少發一封，也別被退訂",
    "营销邮件发烂了比不发更糟——域名信誉一掉，连发货通知都进垃圾箱。所以这套系统的默认值偏保守，而且是": "行銷郵件發爛了比不發更糟——域名信譽一掉，連發貨通知都進垃圾箱。所以這套系統的預設值偏保守，而且是",
    "你自己能改的": "你自己能改的",
    "每天最多发多少封，自己定（默认 200）": "每天最多發多少封，自己定（預設 200）",
    "同一个人最少间隔多少天（默认 15 天）": "同一個人最少間隔多少天（預設 15 天）",
    "同一条序列 7 天内不重复跑": "同一條序列 7 天內不重複跑",
    "退订的、最近刚发过的，自动排除": "退訂的、最近剛發過的，自動排除",
    "只圈付过款的人，不碰注册未下单的": "只圈付過款的人，不碰註冊未下單的",
    "自动营销": "自動行銷",
    "每天最多发": "每天最多發",
    "封": "封",
    "同一人最少间隔": "同一人最少間隔",
    "天": "天",
    "自动跑哪些序列": "自動跑哪些序列",
    "累计送达": "累計送達",
    "队列待发": "隊列待發",
    "退订率": "退訂率",
    "定时任务每 10 分钟推一批。走你自己配的发信账号，退订链接自动带上。": "定時任務每 10 分鐘推一批。走你自己配的發信帳號，退訂連結自動帶上。",
    "自动营销不消耗 AI 积分": "自動行銷不消耗 AI 積分",
    "自动跑的是内置模板，只有你点「AI 写一版」时才计费。所以就算每天发满，也不会偷偷烧额度。": "自動跑的是內置模板，只有你點「AI 寫一版」時才計費。所以就算每天發滿，也不會偷偷燒額度。",
    "看订阅怎么算": "看訂閱怎麼算",
    "别什么都做": "別什麼都做",
    "先做哪个，先别做哪个": "先做哪個，先別做哪個",
    "新店最容易犯的错，是五个平台一起开、每周都发、每条都没人看。系统会按你的店况直接排出优先级——包括明确告诉你「这个月先别做」。": "新店最容易犯的錯，是五個平台一起開、每週都發、每條都沒人看。系統會按你的店況直接排出優先級——包括明確告訴你「這個月先別做」。",
    "渠道": "渠道",
    "优先级": "優先級",
    "为什么": "為什麼",
    "什么时候开始": "什麼時候開始",
    "站点地图 / Merchant Feed": "站點地圖 / Merchant Feed",
    "主力": "主力",
    "零授权、零成本，一次配好长期有效": "零授權、零成本，一次設定長期有效",
    "立刻": "立即",
    "站内 SEO（商品页）": "站內 SEO（商品頁）",
    "有复利，越早做越好": "有複利，越早做越好",
    "第 1 周": "第 1 週",
    "商品主图就是内容，零授权、可长期带访问": "商品主圖就是內容，零授權、可長期帶訪問",
    "第 2 周": "第 2 週",
    "营销邮件（EDM）": "行銷郵件（EDM）",
    "唯一能全自动的渠道，但要有买家才有收件人": "唯一能全自動的渠道，但要有買家才有收件人",
    "辅助": "輔助",
    "见效慢，但长尾关键词能一直带流量": "見效慢，但長尾關鍵詞能一直帶流量",
    "第 3 周": "第 3 週",
    "暂不做": "暫不做",
    "要账号授权，新号容易限流，性价比低于 Pinterest": "要帳號授權，新號容易限流，性價比低於 Pinterest",
    "后面再评估": "後面再評估",
    "要拍视频、API 需审核，这 30 天不划算": "要拍影片、API 需審核，這 30 天不划算",
    "付费广告": "付費廣告",
    "不建议": "不建議",
    "页面还没准备好，投了也转化不了": "頁面還沒準備好，投了也轉化不了",
    "先不花这个钱": "先不花這個錢",
    "这张表是按「有没有主图、描述铺没铺满、有没有买家」实时算的。你的店况不同，排出来的顺序也不同。": "這張表是按「有沒有主圖、描述鋪沒鋪滿、有沒有買家」即時計算的。你的店況不同，排出的順序也不同。",
    "花名册": "花名冊",
    "前面讲的是「拉流量」这一条线。剩下的日常——采货、翻译、盯单、对账——也都有人在管。按位订阅，也可以买组合包。": "前面講的是「拉流量」這一條線。剩下的日常——採貨、翻譯、盯單、對帳——也都有人在管。按位訂閱，也可以買組合包。",
    "商品组": "商品組",
    "5 位": "5 位",
    "把外面看到的东西，变成你店里能卖的东西。": "把外面看到的東西，變成你店裡能賣的東西。",
    "商品采集官": "商品採集官",
    "从货源链接批量抓标题、属性、SKU 与图片，直接进已选商品，不用一条条复制。": "從貨源連結批量抓標題、屬性、SKU 與圖片，直接進已選商品，不用一條條複製。",
    "已接入": "已接入",
    "标题、属性、详情按目标市场语言本地化，不是逐字直译，保持当地习惯用词。": "標題、屬性、詳情按目標市場語言本地化，不是逐字直譯，保持當地習慣用詞。",
    "按目标市场搜索习惯写标题、关键词、描述，写完直接入库。可以批量跑。": "按目標市場搜索習慣寫標題、關鍵詞、描述，寫完直接入庫。可以批量跑。",
    "主图上的外文一键换成本地语言，基础处理一起做，不用开设计软件。": "主圖上的外文一鍵換成本地語言，基礎處理一起做，不用開設計軟體。",
    "按采购价、运费、平台佣金与竞品价位算建议售价，避免拍脑袋定价。": "按採購價、運費、平台佣金與競品價位算建議售價，避免拍腦袋定價。",
    "接入中": "接入中",
    "订单组": "訂單組",
    "4 位": "4 位",
    "有人下单以后，别让人等、别让件丢。": "有人下單以後，別讓人等、別讓件丟。",
    "盯住待支付、待采购、待发货各环节，异常订单主动挑出来提醒处理。": "盯住待支付、待採購、待發貨各環節，異常訂單主動挑出來提醒處理。",
    "物流追踪官": "物流追蹤官",
    "批量跟进运单状态，卡在中转、清关超时、派送失败的件单独列出。": "批量跟進運單狀態，卡在中轉、清關超時、派送失敗的件單獨列出。",
    "客服应答官": "客服應答官",
    "按本店真实发货时效、支付方式与物流商，写一套买家常见问题话术，复制到你的客服渠道就能用。": "根據店鋪實際發貨時效、支付方式與物流商，撰寫一套買家常見問題話術，複製到您的客服渠道就能使用。",
    "评论运营官": "評論運營官",
    "汇总商品评价，差评归因、话术建议，好评提炼成卖点。": "彙總商品評價，差評歸因、話術建議，好評提煉成賣點。",
    "增长组": "增長組",
    "负责「有人来」。前面三段讲的就是这一组。": "負責「有人來」。前面三段講的就是這一組。",
    "推广总控": "推廣總控",
    "先体检找出真正卡住的地方，再给一份 30 天每天做什么的方案，点一下就调其他员工出稿。": "先體檢找出真正卡住的地方，再給一份 30 天每天要做什麼的方案，點一下就調其他員工出稿。",
    "社媒内容官": "社媒內容官",
    "把一件商品改写成 9 个渠道的成品，从 Pinterest 图钉到 TikTok 口播脚本。": "把一件商品改寫成 9 個渠道的成品，從 Pinterest 圖釘到 TikTok 口播腳本。",
    "客户维系官": "客戶維繫官",
    "按人群圈选买家：新品通知、弃购召回、老客唤醒、促销群发，营销邮件自动分批触达。": "按人群圈選買家：新品通知、棄購召回、老客喚醒、促銷群發，行銷郵件自動分批觸達。",
    "选品侦察兵": "選品偵察兵",
    "顺着你现在卖的品提相邻品类，用货源真实行情验证，每周给一份能落地的清单。": "順著您現在賣的商品提出相鄰品類，用貨源真實行情驗證，每周給一份能落地的清單。",
    "促销策划官": "促銷策劃官",
    "按节令和积压库存给活动方案，方案确认后可以直接建券。": "按照節令和積壓庫存提供活動方案，方案確認後可以直接建券。",
    "经营组": "經營組",
    "每天有人替你看数、对账、挑问题。": "每天有人替你看數、對帳、挑問題。",
    "数据播报员": "數據播報員",
    "每天把访客、订单、转化、客单价整理成一段人话播报，不用自己拉表。": "每天把訪客、訂單、轉化、客單價整理成一段人話播報，不用自己拉表。",
    "财务对账官": "財務對帳官",
    "订单收入和提成支出逐笔核对，找出漏记、重复扣款与异常提成。": "訂單收入和提成支出逐筆核對，找出漏記、重複扣款與異常提成。",
    "店铺巡检官": "店鋪巡檢官",
    "定期体检店铺：缺主图、缺描述、零库存、断链，一次性列出待修清单。": "定期體檢店鋪：缺主圖、缺描述、零庫存、斷鏈，一次性列出待修清單。",
    "合规审查官": "合規審查官",
    "商品文案与图片过一遍违禁词、侵权与平台规则，降低下架封店风险。": "商品文案與圖片過一遍違禁詞、侵權與平台規則，降低下架封店風險。",
    "标「接入中」的几位，平台侧能力已经就绪、店主端页面还在接。我们不在官网上把它们写成「马上能用」。": "標「接入中」的幾位，平台側能力已經就緒、店主端頁面還在接。我們不在官網上把它們寫成「馬上能用」。",
    "怎么买": "怎麼買",
    "按位买，或者一次买一组": "按位買，或者一次買一組",
    "每一位员工可以单独订阅，也可以买组合包——组合包覆盖多位员工，折算下来单价更低。开通后到期时间按订阅算，快到期会提醒，不会突然停掉。": "每一位員工可以單獨訂閱，也可以買組合包——組合包覆蓋多位員工，折算下來單價更低。開通後到期時間按訂閱算，快到期會提醒，不會突然停掉。",
    "先用哪几位就开哪几位，不必一次全开": "先用哪幾位就開哪幾位，不必一次全開",
    "组合包覆盖的员工在服务市场里写清楚，不会含糊": "組合包覆蓋的員工在服務市場裡寫清楚，不會含糊",
    "到期前提醒；过期后是「续费」，不用重新找入口": "到期前提醒；過期後是「續費」，不用重新找入口",
    "看订阅和佣金怎么算": "看訂閱和佣金怎麼算",
    "增长组合包": "增長組合包",
    "覆盖 5 位员工": "覆蓋 5 位員工",
    "比单买省": "比單買省",
    "去服务市场": "去服務市場",
    "接上你自己的 AI": "接上你自己的 AI",
    "豆包、ChatGPT、Claude 也能读这间店": "豆包、ChatGPT、Claude 也能讀這間店",
    "平台提供数据接口：AI 能查商品、价格、库存和推广方案，也能把写好的文案存回投递箱。": "平台提供數據接口：AI 能查商品、價格、庫存和推廣方案，也能把寫好的文案存回投遞箱。",
    "不用把账号密码交给任何插件": "不用把帳號密碼交給任何插件",
    "，也不用授权社媒账号。": "，也不用授權社媒帳號。",
    "读：商品、价格、库存、体检结果、30 天方案": "讀：商品、價格、庫存、體檢結果、30 天方案",
    "写：把文案按渠道存回投递箱": "寫：把文案按渠道存回投遞箱",
    "不发：发帖这一步始终由你决定": "不發：發帖這一步始終由你決定",
    "先开哪位？": "先開哪位？",
    "如果只开一位，开": "如果只開一位，開",
    "——它会体检、会排 30 天、还会叫其他员工干活。等订单多起来，再加客户维系官做自动营销。": "——它會體檢、會排 30 天、還會叫其他員工幹活。等訂單多起來，再加客戶維繫官做自動行銷。",
    "看要花多少钱": "看要花多少錢",
    "先让 AI 员工体检一遍你的店": "先讓 AI 員工體檢一遍你的店",
    "免费开店就能跑体检。先看堵点在哪，再决定花不花钱。": "免費開店就能跑體檢。先看堵點在哪，再決定花不花錢。",
    "免费开店": "免費開店",
    "看全部功能": "看全部功能",
    "卖家案例": "賣家案例",
    "他们也在做同一件事，": "他們也在做同一件事，",
    "只是起点不一样": "只是起點不一樣",
    "有人在义乌档口，有人在深圳写字楼，有人在德国的小公寓。": "有人在義烏檔口，有人在深圳寫字樓，有人在德國的小公寓。",
    "难处不一样，解法是同一套。": "難處不一樣，解法是同一套。",
    "我也开一间试试": "我也開一間試試",
    "先看他们怎么做的": "先看他們怎麼做的",
    "这几位都不算「大神」。": "這幾位都不算「大神」。",
    "他们的共同点是先开了店，": "他們的共同點是先開了店，",
    "而不是先把一切都想明白。": "而不是先把一切都想明白。",
    "个不同起点的卖家": "個不同起點的賣家",
    "天，最慢的一个开出第一单": "天，最慢的一個開出第一單",
    "个语言站点，最多的一个": "個語言站點，最多的一個",
    "月订单，最高的一个": "月訂單，最高的一個",
    "六个故事": "六個故事",
    "从左到右，是三种「卖出去」的路": "從左到右，是三種「賣出去」的路",
    "前三个在中国，后三个在海外。": "前三個在中國，後三個在海外。",
    "陈": "陳",
    "陈女士": "陳女士",
    "义乌 · 饰品档口": "義烏 · 飾品檔口",
    "「档口一天来不了几个老外，但网上的老外一天能来几百个。」": "「檔口一天來不了幾個老外，但網上的老外一天能來幾百個。」",
    "原来只做批发，客户是本地贸易商。用模板做了英文和西班牙语两个站，把档口最常卖的 60 款拍了图上架，价格自己定。": "原來只做批發，客戶是本地貿易商。用模板做了英文和西班牙語兩個站，把檔口最常賣的 60 款拍了圖上架，價格自己定。",
    "月订单": "月訂單",
    "语言站点": "語言站點",
    "9 天": "9 天",
    "开出第一单": "開出第一單",
    "林": "林",
    "林先生": "林先生",
    "深圳 · 3C 配件": "深圳 · 3C 配件",
    "「在平台卖，客户是平台的。在自己的站卖，客户才是我的。」": "「在平台上賣，客戶是平台的。在自己的站賣，客戶才是我的。」",
    "原来在第三方平台做了三年，佣金加广告费吃掉三成。把爆款挪到独立站，用同一批货，客单价反而高了——因为能卖套装。": "原來在第三方平台做了三年，佣金加廣告費吃掉三成。把爆款挪到獨立站，用同一批貨，客單價反而高了——因為能賣套裝。",
    "客单价": "客單價",
    "渠道成本": "渠道成本",
    "王": "王",
    "王小姐": "王小姐",
    "广州 · 女装": "廣州 · 女裝",
    "「我不碰国际物流。货发到国内仓，后面的事不归我管。」": "「我不碰國際物流。貨發到國內倉，後面的事不歸我管。」",
    "用代购模式起步：客户在她店里看到的是美元价，下单后平台买手去采购、合箱、出国际单。她只负责选款和在国内发货。": "用代購模式起步：客戶在她店裡看到的是美元價，下單後平台買手去採購、合箱、出國際單。她只負責選款和在國內發貨。",
    "压货成本": "壓貨成本",
    "人小团队": "人小團隊",
    "12 天": "12 天",
    "回本周期": "回本期",
    "德国 · 户外装备": "德國 · 戶外裝備",
    "「我不会中文，也没去过中国。但我能找到货源。」": "「我不會中文，也沒去過中國。但我能找到貨源。」",
    "在德国做户外小众品类。通过平台直接对接国内工厂，一件代发，不压库存。页面用德语和英语，AI 员工处理夜间的英文询盘。": "在德國做戶外小眾品類。通過平台直接對接國內工廠，一件代發，不壓庫存。頁面用德語和英語，AI 員工處理夜間的英文詢盤。",
    "6–9 天": "6–9 天",
    "到货时效": "到貨時效",
    "库存占用": "庫存佔用",
    "美国 · 手工材料": "美國 · 手工材料",
    "「利润不在货上，在搭配上。中国供应链让我敢试新组合。」": "「利潤不在貨上，在搭配上。中國供應鏈讓我敢試新組合。」",
    "卖手工材料包，按主题搭配。因为能小批量补货，她敢每周上一个新主题，卖不动就换，不用清库存。": "賣手工材料包，按主題搭配。因為能小批量補貨，她敢每週上一個新主題，賣不動就換，不用清庫存。",
    "每周": "每週",
    "上新频率": "上新頻率",
    "复购率": "複購率",
    "1 人": "1 人",
    "团队规模": "團隊規模",
    "法国 · 家居饰品": "法國 · 家居飾品",
    "「我不懂投放。AI 给了我一整个月要发什么。」": "「我不懂投放。AI 給了我一整個月要發什麼。」",
    "靠 Instagram 起量。用 AI 营销生成 30 天内容和投放计划，先小预算试，哪个帖子有反应就加钱。": "靠 Instagram 起量。用 AI 行銷生成 30 天內容和投放計劃，先小預算試，哪個帖子有反應就加錢。",
    "渠道同时发": "渠道同時發",
    "帖子点击率": "帖子點擊率",
    "14 天": "14 天",
    "首单": "首單",
    "拆一个给你看": "拆一個給你看",
    "陈女士的头 90 天，做对了三件事": "陳女士的頭 90 天，做對了三件事",
    "她没投过广告，也没请运营。三件很朴素的事，按顺序做完，单量就起来了。": "她沒投過廣告，也沒請運營。三件很樸素的事，按順序做完，單量就起來了。",
    "先只上 60 款，不贪多": "先只上 60 款，不貪多",
    "档口卖得最好的款，实拍图上架。款式少，页面反而干净，客户挑得快。": "檔口賣得最好的款，實拍照上架。款式少，頁面反而乾淨，客戶挑得快。",
    "只开两个语言，做透": "只開兩個語言，做透",
    "英文和西班牙语。没有一上来开 20 种，先把这两个市场的标题和描述改顺。": "英文和西班牙語。沒有第一時間開 20 種，先把這兩個市場的標題和描述改順。",
    "把运费写清楚": "把運費寫清楚",
    "多少钱、几天到、能不能退，写在商品页顶上。询盘少了一半，转化高了一截。": "多少錢、幾天到、能不能退，寫在商品頁頂上。詢盤少了一半，轉化高了一截。",
    "第 90 天": "第 90 天",
    "月订单稳定在 480 上下，开始备第二个语言站": "月訂單穩定在 480 上下，開始備第二個語言站",
    "稳定期": "穩定期",
    "第 32 天": "第 32 天",
    "改了运费说明，商品页跳出率下降，开始有复购": "改了運費說明，商品頁跳出率下降，開始有複購",
    "优化期": "優化期",
    "第 9 天": "第 9 天",
    "第一单来自西班牙，两件饰品，客单 $34": "第一單來自西班牙，兩件飾品，客單 $34",
    "第 1 天": "第 1 天",
    "选了模板，填店铺名，上传 60 款商品": "選了模板，填店鋪名，上傳 60 款商品",
    "开店": "開店",
    "关于这些案例：": "關於這些案例：",
    "人物姓名与店铺信息已做脱敏，数据为区间示意，用于说明做法而非承诺结果。每个人的品类、资金和执行力不同，结果会有差异。": "人物姓名與店鋪信息已做脫敏，數據為區間示意，用於說明做法而非承諾結果。每個人的品類、資金和執行力不同，結果會有差異。",
    "这几个人你都不认识": "這幾個人你都不認識",
    "但他们踩的坑，你大概率会踩。重点不是看他们赚了多少，而是": "但他們踩的坑，你大概率會踩。重點不是看他們賺了多少，而是",
    "看他们在哪个环节换了做法。": "看他們在哪個環節換了做法。",
    "你的起点，可能比他们还好一点": "你的起點，可能比他們還好一點",
    "先开一间免费的，把第一个款上架。剩下的边做边改。": "先開一間免費的，把第一個款上架。剩下的邊做邊改。",
    "我该走哪条路": "我該走哪條路",
    "平台功能": "平台功能",
    "开店要用的东西，这一页全有": "開店要用的東西，這頁全有",
    "建站、翻译、上架、发货、收款、拉客户——": "建站、翻譯、上架、發貨、收款、拉客戶——",
    "15 个模块都在一个后台": "15 個模組都在一個後台",
    "，不用再去外面拼七八个工具，也不用为了一个功能换一次服务商。": "，不用再去外面拼七八個工具，也不用為了某個功能換一次服務商。",
    "免费开店，10 分钟看到你的店": "免費開店，10 分鐘看到你的店",
    "先看有哪些模块": "先看有哪些模組",
    "15 个内置模块": "15 個內置模組",
    "20 种语言": "20 種語言",
    "佣金 3% 起": "佣金 3% 起",
    "第一次开店最怕的是“还差一样东西”。我把常用的都摆在这一页了，": "第一次開店最怕的是「還差一樣東西」。我把常用的都擺在這頁了，",
    "从上往下看就行": "從上往下看就行",
    "内置模块，一个后台": "內置模組，一個後台",
    "种语言，覆盖全球买家": "多種語言，覆蓋全球買家",
    "获客渠道可自动投放": "獲客渠道可自動投放",
    "交易佣金阶梯": "交易佣金階梯",
    "模块总览": "模組總覽",
    "八个方向，撑起一间店": "八個方向，撐起一間店",
    "每个方向下面都有几个具体功能，往下翻能看到怎么用。": "每個方向下面都有幾個具體功能，往下翻能看到怎麼用。",
    "建站与装修": "建站與裝修",
    "选模板、拖组件，改完立刻生效。": "選模板、拖組件，改完立刻生效。",
    "6 套主题": "6 套主題",
    "手机端自动适配": "手機端自動適配",
    "20 种语言一次配好，买家进来就是他的母语。": "20 種語言一次配好，買家進來就是他的母語。",
    "自动翻译": "自動翻譯",
    "可人工改": "可人工改",
    "商品与供应链": "商品與供應鏈",
    "粘个链接就能上架，卖出去再采购。": "粘個連結就能上架，賣出去再採購。",
    "1688 / 淘宝采集": "1688 / 淘寶採集",
    "库存同步": "庫存同步",
    "客服、标题、描述，都能交给它。": "客服、標題、描述，都能交給它。",
    "24 小时在线": "24 小時在線",
    "多语言回复": "多語言回覆",
    "AI 营销": "AI 行銷",
    "诊断店铺，给 30 天计划，自动发帖。": "診斷店鋪，給 30 天計劃，自動發帖。",
    "5 个渠道": "5 個渠道",
    "内容日历": "內容日曆",
    "代购与集运": "代購與集運",
    "客户付外币，平台代买代发。": "客戶付外幣，平台代買代發。",
    "外币收款": "外幣收款",
    "合箱省运费": "合箱省運費",
    "订单与物流": "訂單與物流",
    "批量打面单，轨迹一处看完。": "批量打面單，軌跡一處看完。",
    "云途 / 燕文 / 4PX": "雲途 / 燕文 / 4PX",
    "异常提醒": "異常提醒",
    "收款与结算": "收款與結算",
    "PayPal、Stripe、支付宝接上即用。": "PayPal、Stripe、支付寶接上即用。",
    "T+7 结算": "T+7 結算",
    "多币种提现": "多幣種提現",
    "01 · 建站": "01 · 建站",
    "不用会代码，也能把店弄得像样": "不用會代碼，也能把店弄得像樣",
    "选一套模板，改文字和图片，手机上就是成品。想调结构就拖组件——左边挑、中间摆，改完点保存，前台立刻变。": "選一套模板，改文字和圖片，手機上就是成品。想調結構就拖組件——左邊挑、中間擺，改完點保存，前台立刻變。",
    "首页、商品页、文章页都能可视化编辑": "首頁、商品頁、文章頁都能可視化編輯",
    "手机和桌面两套排版分开调，不用互相将就": "手機和桌面兩套排版分開調，不用互相將就",
    "改坏了能撤回上一版，不怕点错": "改壞了能撤回上一版，不怕點錯",
    "编辑 · 首页": "編輯 · 首頁",
    "组件": "組件",
    "标题": "標題",
    "商品列表": "商品列表",
    "图片": "圖片",
    "优惠券": "優惠券",
    "视频": "視頻",
    "评价": "評價",
    "主视觉 banner": "主視覺 banner",
    "拖动": "拖動",
    "四列商品": "四列商品",
    "选中": "選中",
    "买家评价": "買家評價",
    "02 · 多语言": "02 · 多語言",
    "20 种语言，一次上完": "20 種語言，一次上完",
    "后台的语言列表和店铺前台是同一套，开一个语言，商品标题、描述、政策页都会自动翻。翻得不顺手的句子，可以自己改，改完只影响这一句。": "後台的語言列表和店鋪前台是同一套，開一個語言，商品標題、描述、政策頁都會自動翻。翻得不順手的句子，可以自己改，改完只影響這一句。",
    "英、日、韩、德、法、西、葡、意、俄、阿……共 20 种": "英、日、韓、德、法、西、葡、意、俄、阿……共 20 種",
    "机翻打底 + 人工修正，术语不会被翻歪": "機翻打底 + 人工修正，術語不會被翻歪",
    "每种语言有独立的标题和描述，搜索结果不打架": "每種語言有獨立的標題和描述，搜索結果不打架",
    "中文": "中文",
    "繁體中文": "繁體中文",
    "日本語": "日本語",
    "店里开的每个语言都在这个列表里，": "店裡開的每個語言都在這個列表裡，",
    "两边一一对应": "兩邊一一對應",
    "，不会出现后台开了前台没有的情况。": "，不會出現後台開了前台沒有的情況。",
    "03 · 商品": "03 · 商品",
    "选品不用来回切十个网站": "選品不用來回切十個網站",
    "从 1688、淘宝粘个链接，商品就采到自己店里，价格、规格、图片一起过来。卖出去再去采购，不用先压一批货在仓库。": "從 1688、淘寶粘個連結，商品就採到自己店裡，價格、規格、圖片一起過來。賣出去再去採購，不用先壓一批貨在倉庫。",
    "采集后自动换成店铺币种，加价规则自己定": "採集後自動換成店鋪幣種，加價規則自己定",
    "库存和价格变动会同步，减少超卖": "庫存和價格變動會同步，減少超賣",
    "支持一件代发，也可以批量导出到自己的仓": "支持一件代發，也可以批量導出到自己的倉",
    "商品": "商品",
    "采购价": "採購價",
    "店铺售价": "店鋪售價",
    "纯棉圆领 T 恤": "純棉圓領 T 恤",
    "帆布托特包": "帆布托特包",
    "无线蓝牙耳机": "無線藍牙耳機",
    "极简石英手表": "極簡石英手錶",
    "显示的是": "顯示的是",
    "你的进价和你的售价": "你的進價和你的售價",
    "，中间差多少，一眼看得清。": "，中間差多少，一眼看得清。",
    "04 · AI 员工": "04 · AI 員工",
    "半夜的询盘，也有人回": "半夜的詢盤，也有人回",
    "客户问发货要几天、尺码怎么选、能不能退——AI 员工按你定的规则答，答不了的转人工。写标题、翻描述、改商品图，也能一起交给它。": "客戶問發貨要幾天、尺寸怎麼選、能不能退——AI 員工按你定的規則答，答不了的轉人工。寫標題、翻描述、改商品圖，也能一起交給它。",
    "24 小时在线，时差不用你熬夜补": "24 小時在線，時差不用你熬夜補",
    "用你的语气和退换规则，不乱承诺": "用你的語氣和退換規則，不亂承諾",
    "中英日韩等语言来回切，客户说什么它听什么": "中英日韓等語言來回切，客戶說什麼它聽什麼",
    "买家 · 02:14": "買家 · 02:14",
    "AI 员工 · 02:14": "AI 員工 · 02:14",
    "已自动回复 · 用时 3 秒": "已自動回覆 · 用時 3 秒",
    "买家 · 02:15": "買家 · 02:15",
    "转人工 · 02:15": "轉人工 · 02:15",
    "退换属于承诺类问题，已转给你，附上了订单号。": "退換屬於承諾類問題，已轉給你，附上了訂單號。",
    "05 · AI 营销": "05 · AI 行銷",
    "不会投广告，也能让客户找上门": "不會投廣告，也能讓客戶找上門",
    "接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的内容和投放计划。Facebook、Instagram、TikTok 的帖子可以自动生成、定时发。": "接上豆包這類 AI，先診斷你的店哪裡不對勁，再給一份 30 天能照著做的內容和投放計劃。Facebook、Instagram、TikTok 的帖子可以自动生成、定時發。",
    "店铺诊断：标题、图片、价格、转化，逐项说问题": "店鋪診斷：標題、圖片、價格、轉化，逐項說問題",
    "30 天内容日历，哪天发什么直接排好": "30 天內容日曆，哪天發什麼直接排好",
    "一件商品铺到 9 个渠道，博客和邮件能自动发": "一件商品鋪到 9 個渠道，博客和郵件能自動發",
    "AI 给的是初稿。": "AI 給的是初稿。",
    "涉及价格和承诺的内容，建议人工过一眼再发": "涉及價格和承諾的內容，建議人工再確認一下",
    "，这一步我们不会替你做主。": "，這一步我們不會替你做主。",
    "看 18 位 AI 员工的分工": "看 18 位 AI 員工的分工",
    "诊断你的店": "診斷你的店",
    "抓取首页和 20 个商品页，找出转化流失的位置。": "抓取首頁和 20 個商品頁，找出轉化流失的位置。",
    "给出 30 天计划": "給出 30 天計劃",
    "每天发什么、配什么图、投多少预算，写成清单。": "每天發什麼、配什麼圖、投多少預算，寫成清單。",
    "九个渠道一次铺完": "九個渠道一次鋪完",
    "Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google 商家、站内博客。": "Pinterest、IG、FB、X、TikTok、WhatsApp、Telegram、Google 商家、站內博客。",
    "每周回收数据": "每周回收數據",
    "哪些帖子带来点击，下一周把预算挪过去。": "哪些帖子帶來點擊，下一周把預算挪過去。",
    "06 · 代购 / BuyLink": "06 · 代購 / BuyLink",
    "客户付外币，你只发国内快递": "客戶付外幣，你只發國內快遞",
    "客户在你店里看到的是外币价，点「代购下单」跳到平台，链接已经预填好。平台买手替你采购、合箱、出国际单。你负责把货送到国内仓，剩下的跨境段平台接走。": "客戶在你店裡看到的是外幣價，點「代購下單」跳到平台，連結已經預填好。平台買手替你採購、合箱、出國際單。你負責把貨送到國內倉，剩下的跨境段平台接走。",
    "收外币、付人民币，中间不用自己换汇": "收外幣、付人民幣，中間不用自己換匯",
    "多件合箱，运费比一件一件发便宜": "多件合箱，運費比一件一件發便宜",
    "国际段轨迹可查，客户催单时有话说": "國際段軌跡可查，客戶催單時有話說",
    "看跨境物流怎么走": "看跨境物流怎麼走",
    "客户在你的店下单": "客戶在你的店下單",
    "看到的是你的价格、你的币种、你的品牌。": "看到的是你的價格、你的幣種、你的品牌。",
    "点「代购下单」": "點「代購下單」",
    "跳到平台，商品链接和规格已预填，客户只需确认。": "跳到平台，商品連結和規格已預填，客戶只需確認。",
    "平台采购并合箱": "平台採購並合箱",
    "买手收货、验货、去掉多余包装，几单并一箱。": "買手收貨、驗貨、去掉多餘包裝，幾單併一箱。",
    "出国际单，轨迹回传": "出國際單，軌跡回傳",
    "单号自动回到你的订单里，客户也能看到。": "單號自動回到你的訂單裡，客戶也能看到。",
    "后台日常": "後台日常",
    "订单、客户、权限，一个地方管完": "訂單、客戶、權限，一個地方管完",
    "店里跑起来以后，每天真正要看的就这三块。": "店裡跑起來以後，每天真正要看的就這三塊。",
    "订单看板": "訂單看板",
    "今天几单、待发货几单、哪单卡在海关，打开就看见。": "今天幾單、待發貨幾單、哪單卡在海關，打開就看見。",
    "批量打面单，一次几十张": "批量打面單，一次幾十張",
    "异常件单独列出来": "異常件單獨列出來",
    "客户资产": "客戶資產",
    "邮箱、订单、复购记录都在你的后台，不是平台的。": "郵箱、訂單、複購記錄都在你的後台，不是平台的。",
    "一键导出 CSV": "一鍵匯出 CSV",
    "按购买次数分组": "按購買次數分組",
    "权限与协作": "權限與協作",
    "谁能看什么，按角色分好，不用共享一个账号。": "誰能看什麼，按角色分好，不用共享一個帳號。",
    "客服 / 运营 / 老板三档": "客服 / 運營 / 老闆三檔",
    "操作日志可追溯": "操作日誌可追溯",
    "这一页东西多，不用全看完": "這頁東西多，不用全看完",
    "你只要记住一句：": "你只要記住一句：",
    "开店要用的六件事，这里都有对应的人": "開店要用的六件事，這裡都有對應的人",
    "。建站、翻译、上架、发货、收款、拉客户——缺哪一块，直接跳到那一块看。": "。建站、翻譯、上架、發貨、收款、拉客戶——缺哪一塊，直接跳到那一塊看。",
    "先看要花多少钱": "先看要花多少錢",
    "看完了，直接开一间试试": "看完了，直接開一間試試",
    "免费开店，不绑卡、不签合同。店铺先跑起来，觉得有用再谈套餐。": "免費開店，不綁卡、不簽合同。店鋪先跑起來，覺得有用再談套餐。",
    "看价格": "看價格",
    "给中国卖家": "給中國賣家",
    "你只管选品和定价，": "你只管選品和定價，",
    "其余我们办": "其餘我們辦",
    "建站、翻译、运费、打面单、答客户——": "建站、翻譯、運費、打面單、答客戶——",
    "中间这些麻烦事，平台替你做了。": "中間這些麻煩事，平台替你做了。",
    "先看看别人在卖什么": "先看看別人在賣什麼",
    "佣金低至 3% · 模板和翻译按套餐含 · 店铺和客户数据都归你": "佣金低至 3% · 模板和翻譯按套餐含 · 店鋪和客戶數據都歸你",
    "Taoify 商家工作台 · 数据看板界面": "Taoify 商家工作台 · 數據看板界面",
    "已上线 20 种语言站点": "已上線 20 種語言站點",
    "日本語 · Deutsch · Español …": "日本語 · Deutsch · Español …",
    "下面这六件事，你大概率会遇到其中三四件。": "下面這六件事，你大概率會遇到其中三四件。",
    "遇到了再解决": "遇到了再解決",
    "，不用现在全想明白。": "，不用現在全想明白。",
    "开店前后，绕不开的六个问题": "開店前後，繞不開的六個問題",
    "每一件都有现成的解法": "每一件都有現成的解法",
    "上面是你会问的问题，中间是我们怎么接，下面是你最后得到什么。": "上面是你會問的問題，中間是我們怎麼接，下面是妳最後得到什麼。",
    "没有技术团队，建站要外包？": "沒有技術團隊，建站要外包？",
    "选一个模板，填店铺名和邮箱，十分钟就开了。想改哪里点哪里，不用发需求等排期。": "選一個模板，填店鋪名和郵箱，十分鐘就開了。想改哪裡點哪裡，不用發需求等排期。",
    "10 分钟上线，改版不用排队": "10 分鐘上線，改版不用排隊",
    "不会外语，商品描述怎么写？": "不會外語，商品描述怎麼寫？",
    "20 种语言自动翻，翻得不顺的句子可以自己改。术语不会被翻歪，尺码表也是对的。": "20 種語言自動翻，翻得不順的句子可以自己改。術語不會被翻歪，尺碼表也是對的。",
    "日本客户看日文，德国客户看德文": "日本客戶看日文，德國客戶看德文",
    "运费到底收多少，才不亏？": "運費到底收多少，才不虧？",
    "按重量和地区设好模板，客户下单时系统自动算。偏远地区单独加价，不用你手算。": "按重量和地區設好模板，客戶下單時系統自動算。偏遠地區單獨加價，不用你手算。",
    "不再出现「运费比货贵」": "不再出現「運費比貨貴」",
    "客户想刷卡，我只收过微信？": "客戶想刷卡，我只收過微信？",
    "PayPal、Stripe、支付宝接上即用，外币直接进你的账户，平台不代收货款。": "PayPal、Stripe、支付寶接上即用，外幣直接進你的賬戶，平台不代收款。",
    "结账页多三种付法，少一次流失": "結帳頁多三種付法，少一次流失",
    "国际快递怎么发，单号怎么回传？": "國際快遞怎麼發，單號怎麼回傳？",
    "云途、燕文、4PX 实时比价，选一条就出单。面单批量打完，轨迹自动回到订单里。": "雲途、燕文、4PX 實時比價，選一條就出單。面單批量打完，軌跡自動回到訂單裡。",
    "一张面单贴完，客户自己查轨迹": "一張面單貼完，客戶自己查軌跡",
    "客户半夜问东问西，谁来回？": "客戶半夜問東問西，誰來回？",
    "AI 员工按你定的规则答，答不了的转给你。时差不用熬，第二天看记录就行。": "AI 員工按你定的規則答，答不了的轉給你。時差不用熬，第二天看記錄就行。",
    "询盘不隔夜，退换不乱承诺": "詢盤不隔夜，退換不亂承諾",
    "全链路": "全鏈路",
    "你的活到「交给快递」为止": "你的活到「交給快遞」為止",
    "后面这一段，是大多数人卡住的地方。我们把它接走。": "後面這一段，是大多數人卡住的地方。我們把它接走。",
    "你的货": "你的貨",
    "工厂或仓库里": "工廠或倉庫裡",
    "现成的那批货": "現成的那批貨",
    "上架": "上架",
    "一键铺货": "一鍵鋪貨",
    "20 语种自动翻译": "20 語種自動翻譯",
    "收款": "收款",
    "外币进账": "外幣進賬",
    "不经过平台": "不經過平台",
    "国内仓": "國內倉",
    "你发到仓": "你發到倉",
    "验货合箱": "驗貨合箱",
    "出境派送": "出境派送",
    "报关、干线": "報關、幹線",
    "末端签收": "末端簽收",
    "紫色：平台负责": "紫色：平台負責",
    "灰色：你负责": "灰色：你負責",
    "看物流怎么走": "看物流怎麼走",
    "获客": "獲客",
    "店开好了，客户从哪来": "店開好了，客戶從哪來",
    "这是第二道坎。Taoify 接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的计划，然后自动发到五个渠道。": "這是第二道坎。Taoify 接上豆包這類 AI，先診斷你的店哪裡不對勁，再給一份 30 天能照著做的計劃，然後自動發到五個渠道。",
    "Facebook、Instagram、TikTok 等 5 个渠道自动发": "Facebook、Instagram、TikTok 等 5 個渠道自動發",
    "每周回收数据，把预算挪到有反应的那条": "每周回收數據，把預算挪到有反應的那條",
    "看 AI 营销怎么用": "看 AI 行銷怎麼用",
    "多平台内容分发": "多平台內容分發",
    "更轻的起步方式": "更輕的起步方式",
    "不想压货？先走代购": "不想壓貨？先走代購",
    "客户付外币，你只发国内快递。采购、集运、国际段都由平台办。": "客戶付外幣，你只發國內快遞。採購、集運、國際段都由平台辦。",
    "第一档 · 起步用这个": "第一檔 · 起步用這個",
    "代购模式": "代購模式",
    "不用备货、不用垫钱。客户下单后平台去买，你连货都不用碰。": "不用備貨、不用墊錢。客戶下單後平台去買，你連貨都不用碰。",
    "零压货，卖什么买什么": "零壓貨，賣什麼買什麼",
    "外币收款由平台处理": "外幣收款由平台處理",
    "适合刚起步、试品类": "適合剛起步、試品類",
    "跑通之后": "跑通之後",
    "第二档 · 放量用这个": "第二檔 · 放量用這個",
    "模式": "模式",
    "店铺直接收外币，采购、集运、出国际单都由平台办。你只负责选品和发国内快递。": "店鋪直接收外幣，採購、集運、出國際單都由平台辦。你只負責選品和發國內快遞。",
    "利润归你，价格自己定": "利潤歸你，價格自己定",
    "多件合箱，运费更省": "多件合箱，運費更省",
    "适合已有稳定货源": "適合已有穩定貨源",
    "客户那一端看到的是这样": "客戶那一端看到的是這樣",
    "在你的店铺看到商品，价格是你定的": "在你的店鋪看到商品，價格是你定的",
    "点「代购下单」，跳到代购平台，链接已预填": "點「代購下單」，跳到代購平台，連結已預填",
    "平台买手回你的店下普通国内订单": "平台買手回你的店下普通國內訂單",
    "你发国内快递到平台仓，国际段平台负责": "你發國內快遞到平台倉，國際段平台負責",
    "跑通了想自己赚利润，再切成 BuyLink 模式：店铺直接收外币，采购、集运、出国际单都由平台办。": "跑通了想自己賺利潤，再切成 BuyLink 模式：店鋪直接收外幣，採購、集運、出國際單都由平台辦。",
    "三条路": "三條路",
    "自己搭、找外包、用 Taoify": "自己搭建、找外包、使用 Taoify",
    "不比参数，比的是「多久能开卖」和「出问题谁管」。": "不比參數，比的是「多久能開賣」和「出問題誰管」。",
    "对比项": "對比項",
    "自己搭": "自己搭建",
    "找外包": "找外包",
    "上线时间": "上線時間",
    "1–2 个月": "1–2 個月",
    "2–4 周，改一次再等一周": "2–4 週，改一次再等一週",
    "当天": "當天",
    "前期投入": "前期投入",
    "服务器、插件、维护，几千起": "伺服器、外掛、維護，幾千起",
    "几万起": "幾萬起",
    "佣金 3%–6%，按月成交额阶梯": "佣金 3%–6%，按月成交額階梯",
    "改一次样式": "改一次樣式",
    "找人重做": "找人重做",
    "再付一次钱": "再付一次錢",
    "自己点两下，或跟 AI 说一句": "自己點兩下，或跟 AI 說一句",
    "多语言": "多語言",
    "装插件，翻译另买": "裝外掛，翻譯另買",
    "加钱，通常只做一两种": "加錢，通常只做一兩種",
    "20 种语言内置，自动切换": "20 種語言內建，自動切換",
    "自己申请，被拒就卡住": "自己申請，被拒就卡住",
    "自己申请": "自己申請",
    "PayPal、Stripe、支付宝接上即用": "PayPal、Stripe、支付寶接上即用",
    "国际物流": "國際物流",
    "自己找货代、自己算价": "自己找貨代、自己算價",
    "不在服务范围": "不在服務範圍",
    "云途、燕文、4PX 已接，自动比价出单": "雲途、燕文、4PX 已接，自動比價出單",
    "自己摸索": "自己摸索",
    "AI 诊断 + 30 天方案 + 五渠道": "AI 診斷 + 30 天方案 + 五渠道",
    "客户归属": "客戶歸屬",
    "你的": "你的",
    "你的，邮箱和订单数据都在你后台": "你的，電子郵件和訂單數據都在你後台",
    "对比基于常见方案的平均情况，不代表任何具体服务商。": "對比基於常見方案的平均情況，不代表任何具體服務商。",
    "怎么开始": "怎麼開始",
    "三步，今天就能走完第一步": "三步，今天就能走完第一步",
    "填店铺名和邮箱，选一个模板。不用绑卡，不签合同。": "填店鋪名和電子郵件，選一個模板。不用綁卡，不簽合同。",
    "约 10 分钟": "約 10 分鐘",
    "粘 1688 或淘宝链接，或用 Excel 批量导入。价格自己定。": "粘貼 1688 或淘寶連結，或用 Excel 批量導入。價格自己定。",
    "约 1 小时": "約 1 小時",
    "出第一单": "出第一單",
    "把链接发到你已有的群或朋友圈，或者让 AI 帮你发到海外渠道。": "把連結發到你已有的群或朋友圈，或者讓 AI 幫你發到海外渠道。",
    "看你自己": "看你自己的",
    "不用一次全准备好": "不用一次全準備好",
    "很多人以为要先把货备齐、把公司注册好、把英文练好。其实": "很多人以為要先把貨備齊、把公司註冊好、把英文練好。其實",
    "先上十个商品试一个月": "先上十個商品試一個月",
    "，你会发现问题根本不在这些地方。": "，你會發現問題根本不在這些地方。",
    "先开一间，比想清楚更重要": "先開一間，比想清楚更重要",
    "免费的，不绑卡。跑通一单再决定要不要花钱。": "免費的，不綁卡。跑通一單再決定要不要花錢。",
    "给海外卖家": "給海外賣家",
    "在中国的货架上选品": "在中國的貨架上選品",
    "在你自己的店里卖": "在你自己的店裡賣",
    "不用飞中国、不用懂中文、不用先压一批货。": "不用飛中國、不用懂中文、不用先壓一批貨。",
    "你选好商品，": "你選好商品，",
    "采购、检查、打包、发货我们来做": "採購、檢查、打包、發貨我們來做",
    "免费开店，先挑 3 件商品试试": "免費開店，先挑 3 件商品試試",
    "先看看店长什么样": "先看看店長什麼樣",
    "一件代发 · 不压库存 · 佣金低至 3%": "一件代發 · 不壓庫存 · 佣金低至 3%",
    "订单": "訂單",
    "物流": "物流",
    "设置": "設置",
    "待处理": "待處理",
    "运输中": "運輸中",
    "已签收": "已簽收",
    "物流全程可查": "物流全程可查",
    "燕文 · 4PX · 集运合箱": "燕文 · 4PX · 集運合箱",
    "中国的货架上有什么、怎么运到你手上，": "中國的貨架上有什麼、怎麼運到你手上，",
    "往下翻都能看到": "往下翻都能看到",
    "。先看你在第一步卡在哪。": "。先看你在第一步卡在哪。",
    "从选品到客户收到货": "從選品到客戶收到貨",
    "这几步，我们替你做了": "這幾步，我們替你做了",
    "想卖中国货，不知道找谁拿货？": "想賣中國貨，不知道找誰拿貨？",
    "打开商品库，按品类、价格、销量筛。每件商品都有实拍图和规格，看中的直接加进你的店。": "打開商品庫，按品類、價格、銷量篩。每件商品都有實拍圖和規格，看中的直接加進你的店。",
    "不用自己跑工厂、不用加中间商": "不用自己跑工廠、不用加中間商",
    "不会中文，怎么跟供应商谈？": "不會中文，怎麼跟供應商談？",
    "不用谈。下单、检查、安排发货都由平台完成，你只跟平台说你的语言。": "不用談。下單、檢查、安排發貨都由平台完成，你只跟平台說你的語言。",
    "全程不需要一句中文": "全程不需要一句中文",
    "怕压一批货卖不掉？": "怕壓一批貨賣不掉？",
    "一件代发。客户在你的店下单，我们才去采购和发货，你手上不压库存，也不占资金。": "一件代發。客戶在你的店下單，我們才去採購和發貨，你手上不壓庫存，也不佔資金。",
    "零库存起步，卖不动不亏钱": "零庫存起步，賣不動不虧錢",
    "怕收到的货跟图片不一样？": "怕收到的貨跟圖片不一樣？",
    "商品由平台审核后进入商品库，出库前检查。坏损、错发按平台规则处理，不用你自己去跟工厂扯。": "商品由平台審核後進入商品庫，出庫前檢查。壞損、錯發按平台規則處理，不用你自己去跟工廠扯。",
    "出了问题有人负责": "出了問題有人負責",
    "客户等不及，一直催单？": "客戶等不及，一直催單？",
    "国际专线直发，全程可查。客户在你的店里就能看到货走到哪了，不用来问你。": "國際專線直發，全程可查。客戶在你的店裡就能看到貨走到哪了，不用來問你。",
    "物流进度客户自己看": "物流進度客戶自己看",
    "收款要等多久，平台抽多少？": "收款要等多久，平台抽多少？",
    "客户用他们习惯的方式付款。平台不从你的销售里抽成，卖多少你收多少。": "客戶用他們習慣的方式付款。平台不從你的銷售裡抽成，賣多少你收多少。",
    "佣金按阶梯，最高也只 6%": "佣金按階梯，最高也只 6%",
    "这一段叫「第一公里」": "這一段叫「第一公里」",
    "把货送出中国，是别人的问题": "把貨送出中國，是別人的問題",
    "把货从工厂弄到你手上，才是你的问题": "把貨從工廠弄到你手上，才是你的問題",
    "紫色是我们替你办的，灰色是你只需要做的那一步。": "紫色是我們替你辦的，灰色是你只需要做的那一步。",
    "中国工厂": "中國工廠",
    "按你的选品采购": "按你的選品採購",
    "先验资质再下单": "先驗資質再下單",
    "平台仓": "平台倉",
    "入库验货、称重、拍照": "入庫驗貨、稱重、拍照",
    "不合格直接退回": "不合格直接退回",
    "国际段": "國際段",
    "燕文 / 4PX 专线": "燕文 / 4PX 專線",
    "或集运合箱": "或集運合箱",
    "你的店": "你的店",
    "价格你定": "價格你定",
    "品牌是你的": "品牌是你的",
    "你的客户": "你的客戶",
    "下单、付款、收货": "下單、付款、收貨",
    "数据留在你后台": "數據留在你後台",
    "紫色：我们替你办": "紫色：我們替你辦",
    "灰色：你只需要做这一步": "灰色：你只需要做這一步",
    "两档做法": "兩檔做法",
    "先轻后重：先代发跑通，再备货放大": "先輕後重：先代發跑通，再備貨放大",
    "同一个店，两种节奏。不用一上来就把钱压进去。": "同一家店，兩種節奏。不用一上來就把錢壓進去。",
    "一件代发": "一件代發",
    "轻": "輕",
    "客户在你的店下单，我们采购、验货、出国际单，一直送到他手上。你只需要把商品挂上去。": "客戶在你的店下單，我們採購、驗貨、出國際單，一直送到他手上。你只需要把商品掛上去。",
    "零库存、零资金占用，卖不动就换品": "零庫存、零資金佔用，賣不動就換品",
    "单件成本高一点，但不用赌": "單件成本高一點，但不用賭",
    "适合新店、新品、没试过的品类": "適合新店、新品、沒試過的品類",
    "适合：": "適合：",
    "还没验证过的品": "還沒驗證過的品",
    "备货到本地": "備貨到本地",
    "重": "重",
    "卖得动的品批量采购，走集运合箱或海外仓，单件成本和到货时间都压下来。": "賣得動的品批量採購，走集運合箱或海外倉，單件成本和到貨時間都壓下來。",
    "单件成本更低，利润更厚": "單件成本更低，利潤更厚",
    "到货更快，客户体验和复购更好": "到貨更快，客戶體驗和複購更好",
    "需要一点备货资金和仓位": "需要一點備貨資金和倉位",
    "已经卖稳的爆款": "已經賣穩的爆款",
    "不懂中文也能管店": "不懂中文也能管店",
    "18 位 AI 员工，替你处理日常": "18 位 AI 員工，替你處理日常",
    "商品、订单、增长、经营四组，按需订阅，不需要一次全开。": "商品、訂單、增長、經營四組，按需訂閱，不需要一次全開。",
    "你不用雇人，也不用学会中文后台": "你不用雇人，也不用學會中文後台",
    "——它们用你市场的语言干活。": "——它們用你市場的語言幹活。",
    "商品文案官": "商品文案官",
    "用目标市场的语言写标题和描述，不是机翻": "用目標市場的語言寫標題和描述，不是機翻",
    "AI 客服": "AI 客服",
    "7×24，用客户的语言回复，常见问题直接解决": "7×24，用客戶的語言回復，常見問題直接解決",
    "选品助手": "選品助手",
    "看哪些品在你的市场真的卖得动": "看哪些品在你的市場真的賣得動",
    "经营日报": "經營日報",
    "今天发生了什么，明天该做什么": "今天發生了什麼，明天該做什麼",
    "三步，不用先付钱": "三步，不用先付錢",
    "第一步": "第一步",
    "注册开店": "註冊開店",
    "几分钟注册，不需要信用卡。店名和域名随时能改。": "幾分鐘註冊，不需要信用卡。店名和域名隨時能改。",
    "约 5 分钟": "約 5 分鐘",
    "第二步": "第二步",
    "挑商品": "挑商品",
    "从中国商品库挑，或者导入你自己的货源。看中就一键铺到店里。": "從中國商品庫挑，或者導入你自己的貨源。看中就一鍵鋪到店裡。",
    "当天能挑完": "當天能挑完",
    "第三步": "第三步",
    "开卖": "開賣",
    "客户下单，我们发货。物流他自己能查，售后有人接。": "客戶下單，我們發貨。物流他自己能查，售後有人接。",
    "0 库存": "0 庫存",
    "你在中国，想把货卖出去？": "你在中國，想把貨賣出去？",
    "看这一页 →": "看這頁 →",
    "第一公里是最容易低估的一段": "第一公里是最容易低估的一段",
    "工厂到仓、仓到口岸、口岸到干线——": "工廠到倉、倉到口岸、口岸到幹線——",
    "这三段任何一段卡住，后面全乱": "這三段任何一段卡住，後面全亂",
    "。先把这一段跑顺，再谈增长。": "。先把這一段跑順，再談增長。",
    "你挑货、定价、卖货，货从中国直接到客户手上。": "你挑貨、定價、賣貨，貨從中國直接到客戶手上。",
    "不需要仓库，不需要员工，也不需要会说中文。": "不需要倉庫，不需要員工，也不需要會說中文。",
    "帮助中心": "幫助中心",
    "有问题，先在这里找": "有問題，先在這裡找",
    "常见问题按分类整理好了，搜不到就直接问 AI 客服，它会带着你的问题接着答。": "常見問題已按分類整理好，搜不到就直接問 AI 客服，它會帶著你的問題接著答。",
    "搜索：怎么改价格、退款怎么处理、忘记密码…": "搜索：怎麼改價格、退款怎麼處理、忘記密碼…",
    "搜索": "搜尋",
    "常搜：": "常搜：",
    "懒得翻？直接问 AI 客服": "懶得翻？直接問 AI 客服",
    "开店、选品、物流、结算都能问，答不上会转人工。": "開店、選品、物流、結算都能問，答不上會轉人工。",
    "开始提问": "開始提問",
    "搜不到就直接问 AI 客服，": "搜不到就直接問 AI 客服，",
    "别自己在那儿猜。": "別自己在那兒猜。",
    "猜错一步，后面要多改三处。": "猜錯一步，後面要多改三處。",
    "条": "條",
    "常见问题": "常見問題",
    "大家问得最多的这些": "大家問得最多的這些",
    "当前筛选：": "當前篩選：",
    "清空筛选": "清空篩選",
    "这条没解决，问 AI 客服": "這條沒解決，問 AI 客服",
    "没有找到这一条。": "沒有找到這一條。",
    "把这个问给 AI 客服": "把這個問給 AI 客服",
    "没搜到，已经把「": "沒搜到，已經把「",
    "」发给 AI 客服了，在右下角继续聊。": "」發給 AI 客服了，在右下角繼續聊。",
    "还没解决": "還沒解決",
    "三条路，总有一条能通": "三條路，總有一條能通",
    "AI 客服随时在线，工单最慢 4 小时回，邮件适合附合同和证件。": "AI 客服隨時在線，工單最慢 4 小時回，郵件適合附合同和證件。",
    "开店、选品、物流、结算的常见问题，它当场答；答不上会转人工。": "開店、選品、物流、結算的常見問題，它當場答；答不上會轉人工。",
    "打开对话": "打開對話",
    "提工单": "提工單",
    "描述清楚问题、附上订单号或截图，一般 4 小时内有人接。": "描述清楚問題、附上訂單號或截圖，一般 4 小時內有人接。",
    "登录后提工单": "登錄後提工單",
    "发邮件": "發郵件",
    "适合需要附合同、发票、证件的情况，附件不会丢。": "適合需要附合同、發票、證件的情況，附件不會丟。",
    "写邮件": "寫郵件",
    "开放接口": "開放接口",
    "有自己的系统？接进来就行": "有自己的系統？接進來就行",
    "商品、库存、订单、物流轨迹都开放了 REST 接口和 Webhook。用 ERP 管货的，可以只同步库存；用自己后台管订单的，可以只拉订单。": "商品、庫存、訂單、物流軌跡都開放了 REST 接口和 Webhook。用 ERP 管貨的，可以只同步庫存；用自己的後台管訂單的，可以只拉訂單。",
    "REST API，Token 鉴权，支持分页与增量拉取": "REST API，Token 鑒權，支持分頁與增量拉取",
    "Webhook 推送下单、付款、发货、退款事件": "Webhook 推送下單、付款、發貨、退款事件",
    "沙箱环境，不影响正式店铺数据": "沙箱環境，不影響正式店鋪數據",
    "向 AI 客服要接口文档": "向 AI 客服要接口文檔",
    "接口按": "接口按",
    "店铺维度隔离，": "店鋪維度隔離，",
    "一个 Token 只能读自己店的数据。": "一個 Token 只能讀自己店的數據。",
    "正常": "正常",
    "店铺前台访问": "店鋪前台訪問",
    "后台与订单接口": "後台與訂單接口",
    "面单与轨迹回传": "面單與軌跡回傳",
    "AI 能力": "AI 能力",
    "最近一次异常：10-21 02:10–02:26，物流轨迹回传延迟，已恢复。": "最近一次異常：10-21 02:10–02:26，物流軌跡回傳延遲，已恢復。",
    "查看历史": "查看歷史",
    "还是没解决？直接问 AI 客服": "還是沒解決？直接問 AI 客服",
    "把店铺编号和截图一起发过去，通常当天就有回复。": "把店鋪編號和截圖一起發過去，通常當天就有回覆。",
    "还没开店？先开一间再来问": "還沒開店？先開一間再來問",
    "大部分问题，开完店自己就明白了。免费的，不绑卡。": "大部分問題，開完店自己就明白了。免費的，不綁卡。",
    "看功能": "看功能",
    "改价格": "修改價格",
    "退款": "退款",
    "绑定域名": "綁定域名",
    "忘记密码": "忘記密碼",
    "物流不更新": "物流未更新",
    "不管你在供应链的哪一端": "不管你在供應鏈的哪一端",
    "中国货，卖全球": "中國貨，賣全球",
    "零代码开店 · 多语言商城 · 一键铺货 · 全球收付款": "零代碼開店 · 多語言商城 · 一鍵鋪貨 · 全球收付款",
    "建站、翻译、收款、发货、获客，中间这几件麻烦事我们全包了。": "建站、翻譯、收款、發貨、獲客，中間這幾件麻煩事我們全包了。",
    "如果你在中国": "如果你在中國",
    "我在中国": "我在中國",
    "要把货卖出去": "要把貨賣出去",
    "不用会建站、不用懂外语、不用自己发国际快递": "不用會建站、不用懂外語、不用自己發國際快遞",
    "如果你在海外": "如果你在海外",
    "我在海外": "我在海外",
    "要卖中国好货": "要賣中國好貨",
    "直连中国供应链，一件代发、不用压货、不用懂中文": "直連中國供應鏈，一件代發、不用壓貨、不用懂中文",
    "看看能卖什么": "看看能賣什麼",
    "对号入座": "對號入座",
    "你在哪一端？两条路都能走通": "你在哪一端？兩條路都能走通",
    "两端缺的东西正好相反：一头缺把货送出去，一头缺把货弄到手。": "兩端缺的東西正好相反：一頭缺把貨送出去，一頭缺把貨弄到手。",
    "两条路都在下面，": "兩條路都在下面，",
    "选你站在的那一端": "選你站在的那一端",
    "往下读就行。选错了也不打紧，开店后随时能改。": "往下讀就行。選錯了也不打緊，開店後隨時能改。",
    "中国卖家": "中國賣家",
    "有工厂或货源，想跳过中间商直接卖给老外": "有工廠或貨源，想跳過中間商直接賣給外國人",
    "在平台卖了很多年，怕一条规则下来店就没了": "在平台賣了很多年，怕一條規則下來店就沒了",
    "主要做国内生意，想有个自己的店，不再把利润分给平台": "主要做國內生意，想有個自己的店，不再把利潤分給平台",
    "看中国卖家怎么开始": "看中國賣家怎麼開始",
    "海外卖家": "海外賣家",
    "在当地已经有客源，想加点中国货但不想先压一批库存": "在当地已經有客源，想加點中國貨但不想先壓一批庫存",
    "想创业，找不到靠谱的工厂，也不会做网站": "想創業，找不到靠譜的工廠，也不會做網站",
    "已经在做代购或微商，想把手上这些客户搬到一个正式的网站": "已經在做代購或微商，想把手上的這些客戶搬到一個正式的網站",
    "看海外卖家怎么开始": "看海外賣家怎麼開始",
    "全链路闭环": "全鏈路閉環",
    "从工厂到客户手上": "從工廠到客戶手上",
    "中间这几件麻烦事，我们全包": "中間這幾件麻煩事，我們全包",
    "不用再对接七八个系统，一个后台从头管到尾。": "不用再對接七八個系統，一個後台從頭管到尾。",
    "快速建站": "快速建站",
    "10 分钟，零代码": "10 分鐘，零代碼",
    "拥有专业品牌独立站": "擁有專業品牌獨立站",
    "海量铺货": "海量鋪貨",
    "1688 / 淘宝一键采集": "1688 / 淘寶一鍵採集",
    "AI 翻译，批量上架": "AI 翻譯，批量上架",
    "便捷收款": "便捷收款",
    "支持全球主流支付": "支援全球主流支付",
    "资金安全直达": "資金安全直達",
    "智能物流": "智慧物流",
    "多仓发货，合箱出库": "多倉發貨，合箱出庫",
    "实时跟踪，全球送达": "實時跟蹤，全球送達",
    "持续运营": "持續運營",
    "数据分析，SEO 优化": "數據分析，SEO 優化",
    "会员管理，长期复购": "會員管理，長期複購",
    "平台特色": "平台特色",
    "别的工具卖你一个网站": "別的工具賣你一個網站",
    "我们给你一整个团队": "我們給你一整個團隊",
    "建站只是起点。真正难的是三件事：": "建站只是起點。真正難的是三件事：",
    "没人干活、没人看见、货发不出去。": "沒人幹活、沒人看見、貨發不出去。",
    "18 位员工": "18 位員工",
    "你睡觉的时候，有人还在改标题、回差评、盯物流": "你睡覺的時候，有人還在改標題、回差評、盯物流",
    "每天巡检全店：缺图、缺描述、踩违规词，直接改掉": "每天巡檢全店：缺圖、缺描述、踩違規詞，直接改掉",
    "按成本、运费和佣金算真实毛利，不靠感觉定价": "按成本、運費和佣金計算真實毛利，不靠感覺定價",
    "差评回复、社媒文案、客服话术、对账报告，点一下出稿": "差評回覆、社媒文案、客服話術、對帳報告，點一下出稿",
    "看看这 18 位员工都干什么": "看看這 18 位員工都幹什麼",
    "5 大渠道": "5 大渠道",
    "店建好了没人来 —— 这比建站难十倍": "店建好了沒人來 —— 這比建站難十倍",
    "先诊断再开方：标题还是中文，就先修标题，不急着发内容": "先診斷再開方：標題還是中文，就先修標題，不急著發內容",
    "30 天方案拆成每天 2–3 件事，做完打勾": "30 天方案拆成每天 2–3 件事，做完打勾",
    "Google、Meta、TikTok、Snapchat、Microsoft 一站接入，像素有没有生效能自己验": "Google、Meta、TikTok、Snapchat、Microsoft 一站接入，像素有沒有生效能自己驗",
    "看 30 天推广方案长什么样": "看 30 天推廣方案長什麼樣",
    "零门槛": "零門檻",
    "今天就能把淘宝、1688 的货，挂到自己站上卖": "今天就能把淘寶、1688 的貨，掛到自己站上賣",
    "一条链接变一个商品页，图、价、规格自动填": "一條連結變一個商品頁，圖、價、規格自動填",
    "买家点「代购下单」跳代购平台，商品链接已经填好": "買家點「代購下單」跳代購平台，商品連結已經填好",
    "你只发国内快递，跨境支付和国际物流都不用碰": "你只發國內快遞，跨境支付和國際物流都不用碰",
    "看懂这个模式": "看懂這個模式",
    "生意做大了，整条链路攥在自己手里": "生意做大了，整條鏈路攥在自己手裡",
    "售价里含代购服务费，按比例或按固定金额收": "售價裡含代購服務費，按比例或按固定金額收",
    "入库称重、多个包裹合箱出库，比单件直发省": "入庫稱重、多個包裹合箱出庫，比單件直發省",
    "燕文、4PX 自动取号出单，轨迹自动回填给买家": "燕文、4PX 自動取號出單，軌跡自動回填給買家",
    "对比它和 BuyLink 的区别": "對比它和 BuyLink 的區別",
    "这四件事，建站工具一件都做不了 —— 因为它们需要": "這四件事，建站工具一件都做不了 —— 因為它們需要",
    "货源、仓库、承运商和真实数据，": "貨源、倉庫、承運商和真實數據，",
    "不是几段代码。": "不是幾段程式碼。",
    "AI 营销 · 获客": "AI 行銷 · 獲客",
    "流量不是等来的，是一步一步算出来的": "流量不是等來的，是一步一步算出來的",
    "四步，每一步都能看到做完之后的变化。": "四步，每一步都能看到做完之後的變化。",
    "先说真话": "先說真話",
    "商品标题还是中文？站是日语站、描述只有 1/65？先修地基，不急着发内容。": "商品標題還是中文？站是日語站、描述只有 1/65？先修地基，不急著發內容。",
    "30 天方案": "30 天方案",
    "按你的品类、市场、库存，拆成每天 2–3 件能做完的小事。": "按你的品類、市場、庫存，拆成每天 2–3 件能做完的小事。",
    "AI 出稿": "AI 出稿",
    "社媒短文、短视频脚本、营销邮件、活动方案，点一下就有。": "社媒短文、短視頻腳本、行銷郵件、活動方案，點一下就有。",
    "第四步": "第四步",
    "投放追效果": "投放追蹤效果",
    "五渠道接入，商品 feed 自动生成，像素没生效能自己查出来。": "五渠道接入，商品 feed 自動生成，像素沒生效能自己查出來。",
    "你的 AI 助手可以直接读你的店": "你的 AI 助手可以直接讀你的店",
    "豆包 · ChatGPT · Claude 接上就能取商品、取方案、存稿件，不用把账号密码交给任何插件": "豆包 · ChatGPT · Claude 接上就能取商品、取方案、存稿件，不用把帳號密碼交給任何插件",
    "看怎么接": "看怎麼接",
    "这四步不用一次做完": "這四步不用一次做完",
    "大部分人卡在第一步：连自己店里有多少条商品描述还是中文都不知道。先把这一步做完，后面三步才有意义。": "大部分人都卡在第一步：連自己店裡有多少條商品描述還是中文都不知道。先把這一步做完，後面三步才有意義。",
    "想省事就让 AI 先扫一遍，": "想省事就讓 AI 先掃一遍，",
    "它会把该改的地方列出来。": "它會把該改的地方列出來。",
    "能拿产品事实说清楚的，就不吹数字": "能拿產品事實說清楚的，就不吹數字",
    "种店铺语言": "種店鋪語言",
    "位 AI 员工": "位 AI 員工",
    "大投放渠道": "主要投放渠道",
    "全部为你现在就能打开后台看到的数字，不是宣传口径。": "全部為你現在就能打開後台看到的數字，不是宣傳口徑。",
    "准备好把这门生意做起来了吗": "準備好把這門生意做起來了嗎",
    "零代码 · 订阅制 · 10 分钟拥有自己的品牌独立站": "零代碼 · 訂閱制 · 10 分鐘擁有自己的品牌獨立站",
    "立即免费开通": "立即免費開通",
    "不需要信用卡 · 随时可以关掉": "不需要信用卡 · 隨時可以關掉",
    "跨境物流": "跨境物流",
    "从你手里到客户手里，": "從你手裡到客戶手裡，",
    "中间这一段我们接": "中間這一段我們接",
    "头程揽收、报关出境、干线运输、末端派送——": "頭程攬收、報關出境、幹線運輸、末端派送——",
    "四条线路按货物和时效选": "四條線路按貨物和時效選",
    "。面单在后台打，轨迹在后台看，出事有人管。": "。面單在後台打，軌跡在後台看，出事有人管。",
    "免费开店，先算一单运费": "免費開店，先算一單運費",
    "看三条线路": "看三條線路",
    "美线专线 6–9 天": "美線專線 6–9 天",
    "220+ 国家可达": "220+ 國家可達",
    "全程轨迹可查": "全程軌跡可查",
    "以前要加三个货代微信、问四次价格。": "以前要加三個貨代微信、問四次價格。",
    "现在一个后台里比价下单": "現在一個後台裡比價下單",
    "，单号自动回到订单里。": "，單號自動回到訂單裡。",
    "美线专线参考时效（天）": "美線專線參考時效（天）",
    "可送达国家与地区": "可送達國家與地區",
    "国内揽收仓，就近交货": "國內攬收倉，就近交貨",
    "主力承运商实时比价": "主力承運商即時比價",
    "以上为常见线路的参考区间，具体时效与价格以系统按重量、目的地、品类算出的报价为准。": "以上為常見線路的參考區間，具體時效與價格以系統按重量、目的地、品類算出的報價為準。",
    "三条线路": "三條線路",
    "货不一样，走法也不一样": "貨不一樣，走法也不一樣",
    "轻小件走小包，多件合一起走集运，卖得快的备到海外仓。三条路可以同时用。": "輕小件走小包，多件合一起走集運，賣得快的備到海外倉。三條路可以同時用。",
    "直发小包": "直發小包",
    "一单一发，不用备货。适合刚起步、单量不大、品类还摸不准的时候。": "一單一發，不用備貨。適合剛起步、單量不大、品類還摸不準的時候。",
    "按克计费，200g 起": "按克計費，200g 起",
    "美国 6–9 天 / 欧洲 7–12 天": "美國 6–9 天 / 歐洲 7–12 天",
    "带全程跟踪号": "帶全程追蹤號",
    "适合：单价 $10–60 的轻小件": "適合：單價 $10–60 的輕小件",
    "集运合箱": "集運合箱",
    "同一个客户买了几件，先到国内仓，去掉外包装合成一箱再发。运费按一箱算，不是按四箱算。": "同一客戶購買多件商品，先送到國內倉庫，去掉外包裝合併成一箱再發送。運費按一箱計算，而不是按四箱計算。",
    "多件合并，省首重": "多件合併，省首重",
    "免费仓储 30 天": "免費倉儲 30 天",
    "可代贴标、代加固": "可代貼標、代加固",
    "适合：多件订单、批发小单": "適合：多件訂單、小批量批發",
    "海外仓备货": "海外倉備貨",
    "卖得动的款提前备到当地仓，客户下单当天就发。退换也能就地处理。": "熱銷款式提前備到當地倉庫，客戶下單當天即可發貨。退換貨也能就地處理。",
    "本地派送 2–4 天": "本地派送 2–4 天",
    "支持本地退换地址": "支持本地退換地址",
    "库存和店铺同步": "庫存和店鋪同步",
    "适合：月销 100 单以上的爆款": "適合：月銷 100 單以上的爆款",
    "一件包裹要过五道手": "一件包裹要過五道手",
    "哪一段由谁负责，写清楚了，出问题才知道找谁。": "哪一段由誰負責，寫清楚了，出問題才知道找誰。",
    "你打包": "你打包",
    "后台打面单": "後台打面單",
    "贴好交给快递": "貼好交給快遞",
    "收货、验货": "收貨、驗貨",
    "合箱、称重": "合箱、稱重",
    "报关出境": "報關出境",
    "资料代填": "資料代填",
    "清单预申报": "清單預申報",
    "干线": "幹線",
    "空运为主": "空運為主",
    "按线路排舱": "按線路排艙",
    "末端派送": "末端派送",
    "当地邮政或快递": "當地郵政或快遞",
    "签收信息回传": "簽收信息回傳",
    "报价参考": "報價參考",
    "什么货、走哪条、多少钱": "什麼貨、走哪條、多少錢",
    "下表按 200g 包裹估算，方便你先算一笔账。": "下表按 200g 包裹估算，方便你先算一筆帳。",
    "目的地": "目的地",
    "线路": "線路",
    "参考时效": "參考時效",
    "200g 参考运费": "200g 參考運費",
    "可跟踪": "可追蹤",
    "美国": "美國",
    "经济小包": "經濟小包",
    "8–12 个工作日": "8–12 個工作日",
    "¥26 起": "¥26 起",
    "全程": "全程",
    "标准专线": "標準專線",
    "6–9 个工作日": "6–9 個工作日",
    "¥34 起": "¥34 起",
    "英国 / 德国": "英國 / 德國",
    "欧洲专线": "歐洲專線",
    "7–12 个工作日": "7–12 個工作日",
    "¥31 起": "¥31 起",
    "日本 / 韩国": "日本 / 韓國",
    "东亚专线": "東亞專線",
    "3–5 个工作日": "3–5 個工作日",
    "¥22 起": "¥22 起",
    "澳大利亚": "澳大利亞",
    "澳洲专线": "澳洲專線",
    "7–10 个工作日": "7–10 個工作日",
    "¥30 起": "¥30 起",
    "中东 / 南美": "中東 / 南美",
    "偏远专线": "偏遠專線",
    "12–20 个工作日": "12–20 個工作日",
    "¥45 起": "¥45 起",
    "仅关键节点": "僅關鍵節點",
    "表内为示意价格，不含燃油与偏远附加费。实际下单时系统按重量、体积重、品类实时报价。": "表內為示意價格，不含燃油與偏遠附加費。實際下單時系統按重量、體積重、品類即時報價。",
    "轨迹": "軌跡",
    "客户问「我的包裹到哪了」，你不用去翻聊天记录": "客戶問「我的包裹到哪了」，你不用去翻聊天記錄",
    "每单都有时间轴，从揽收到签收一条线拉下来。客户在你店里就能自己查，不用来问你。真出问题，系统会比客户先告诉你。": "每單都有時間軸，從攬收到簽收一條線拉下來。客戶在你店裡就能自己查，不用來問你。真出問題，系統會比客戶先告訴你。",
    "轨迹节点自动回传，中英文对照": "軌跡節點自動回傳，中英文對照",
    "超时未更新、清关滞留、派送失败会自动标红": "超時未更新、清關滯留、派送失敗會自動標紅",
    "异常件单独一列，处理完再归位": "異常件單獨一列，處理完再歸位",
    "Berlin, DE · 由收件人本人签收": "Berlin, DE · 由收件人本人簽收",
    "派送中": "派送中",
    "Out for delivery · DHL 本地派送": "出貨中 · DHL 本地派送",
    "清关完成": "清關完成",
    "法兰克福口岸放行": "法蘭克福口岸放行",
    "干线运输中": "幹線運輸中",
    "深圳 → 法兰克福，航班已起飞": "深圳 → 法蘭克福，航班已起飛",
    "已入库合箱": "已入庫合箱",
    "深圳仓 · 2 件合并，减重 0.3kg": "深圳倉 · 2 件合併，減重 0.3kg",
    "出问题怎么办": "出問題怎麼辦",
    "丢件、破损、退回来，都有说法": "丟件、破損、退回來，都有說法",
    "跨境最怕的不是出事，是出了事没人认。": "跨境最怕的不是出事，是出了事沒人認。",
    "丢件赔付": "丟件賠付",
    "承运商确认丢失后按申报价值赔付，上限写在报价单里，不用来回扯。": "承運商確認遺失後按申報價值賠付，上限寫在報價單裡，不用來回扯。",
    "退换地址": "退換地址",
    "美国、德国、英国有本地退货地址，客户寄回不用付国际邮费。": "美國、德國、英國有本地退貨地址，客戶寄回不用付國際郵費。",
    "专人跟进": "專人跟進",
    "单票超过 15 天没更新，平台会主动开一张工单跟进，不用你催。": "單票超過 15 天沒更新，平台會主動開一張工單跟進，不用你催。",
    "时效表里的数字是常态，不是承诺": "時效表裡的數字是常態，不是承諾",
    "真卡住了，": "真的卡住了，",
    "先看轨迹再问人": "先看軌跡再問人",
    "。九成问题看单号就能定位：清关延误、地址不详、派送失败，轨迹上写得比客服说的清楚。": "。九成問題看單號就能定位：清關延誤、地址不詳、派送失敗，軌跡上寫得比客服說的清楚。",
    "先算一单，再决定走哪条线": "先算一單，再決定走哪條線",
    "开店后输入重量和目的地，三条线路的价格和时效会一起列出来。": "開店後輸入重量和目的地，三條線路的價格和時效會一起列出來。",
    "免费开店试算": "免費開店試算",
    "看收款怎么走": "看收款怎麼走",
    "客户怎么付得方便，": "客戶怎麼付得方便，",
    "你就怎么收": "你就怎麼收",
    "欧美人习惯刷卡、德国人爱用 PayPal、东南亚用本地钱包、中东还在转账——": "歐美人習慣刷卡、德國人愛用 PayPal、東南亞用本地錢包、中東還在轉賬——",
    "多种收单方式接上就能用": "多種收單方式接上就能用",
    "，后台统一看账。": "，後台統一看帳。",
    "免费开店，绑定收款": "免費開店，綁定收款",
    "看费率": "看費率",
    "不用自己申请商户号": "不用自己申請商戶號",
    "T+7 自动结算": "T+7 自動結算",
    "最常被问的是「钱什么时候到我账上」。": "最常被問的是「錢什麼時候到我帳上」。",
    "答案写在结算规则里": "答案寫在結算規則裡",
    "，不用发邮件问。": "，不用發郵件問。",
    "种收单方式可选": "種收款方式可選",
    "妥投后 7 天可提现": "妥投後 7 天可提現",
    "支持提现的币种": "支持提現的幣種",
    "T+7 是留出的退款与拒付窗口。已妥投且过了窗口的订单，余额可随时提现。": "T+7 是留出的退款與拒付窗口。已妥投且過了窗口的訂單，餘額可隨時提現。",
    "收单": "收款",
    "客户看到的付款方式，越多越容易成交": "客戶看到的付款方式，越多越容易成交",
    "结账页上少一个支付选项，就可能少一单。常用的这几种，默认都开着。": "結帳頁上少一個支付選項，就可能少一單。常用的這幾種，默認都開著。",
    "欧美客户最认的一种，有买家保护，争议处理流程成熟。": "歐美客戶最認的一種，有買家保護，爭議處理流程成熟。",
    "覆盖 200+ 国家": "覆蓋 200+ 國家",
    "支持信用卡无账号付款": "支持信用卡無帳號付款",
    "信用卡 / 借记卡": "信用卡 / 借記卡",
    "通过 Stripe 收 Visa、Mastercard、Amex，3D 验证默认开启。": "通過 Stripe 收 Visa、Mastercard、Amex，3D 驗證默認開啟。",
    "支持自动扣款与订阅": "支持自動扣款與訂閱",
    "拒付率低于纯 PayPal 通道": "拒付率低於純 PayPal 通道",
    "本地钱包": "本地錢包",
    "德国的 Klarna、荷兰的 iDEAL、巴西的 Pix，按市场自动出现。": "德國的 Klarna、荷蘭的 iDEAL、巴西的 Pix，按市場自動出現。",
    "按客户所在地展示": "按客戶所在地展示",
    "不用单独签约": "不用單獨簽約",
    "收款账户是你自己的": "收款帳戶是你自己的",
    "。平台不代收货款，钱从客户直接进你的 PayPal / Stripe 账户，我们不碰这笔钱。": "。平台不代收貨款，錢從客戶直接進你的 PayPal / Stripe 帳戶，我們不碰這筆錢。",
    "资金流向": "資金流向",
    "一笔钱从客户到你的账上，走四步": "一筆錢從客戶到你的帳上，走四步",
    "客户付款": "客戶付款",
    "结账页选方式": "結帳頁選方式",
    "按当地币种支付": "按當地幣種支付",
    "进入你的账户": "進入你的帳戶",
    "订单妥投": "訂單妥投",
    "轨迹显示签收": "軌跡顯示簽收",
    "开始算 T+7": "開始算 T+7",
    "提现到账": "提現到帳",
    "提人民币或外币": "提人民幣或外幣",
    "1–3 个工作日": "1–3 個工作日",
    "费率": "費率",
    "每一笔扣多少，写在明面上": "每一筆扣多少，寫在明面上",
    "通道费由收单机构收，平台不在这上面加价。": "通道費由收單機構收，平台不在這上面加價。",
    "收单方式": "收款方式",
    "参考费率": "參考費率",
    "到账时间": "到帳時間",
    "提现费": "提現費",
    "争议处理": "爭議處理",
    "约 4.4% + $0.30": "約 4.4% + $0.30",
    "即时到 PayPal 余额": "即時到 PayPal 餘額",
    "按提现通道": "按提現通道",
    "买家保护，180 天": "買家保護，180 天",
    "信用卡（Stripe）": "信用卡（Stripe）",
    "约 2.9% + $0.30": "約 2.9% + $0.30",
    "T+2 到 Stripe 余额": "T+2 到 Stripe 餘額",
    "拒付 15–30 天内申诉": "拒付 15–30 天內申訴",
    "支付宝 / Alipay+": "支付寶 / Alipay+",
    "约 1.2%": "約 1.2%",
    "免": "免",
    "平台介入": "平台介入",
    "约 1.5%–2.5%": "約 1.5%–2.5%",
    "按当地规则": "按當地規則",
    "Taoify 平台服务费": "Taoify 平台服務費",
    "费率为行业常见区间，实际以你与收单机构签约时的条款为准；不同国家、不同卡种会有差异。": "費率為業界常見區間，實際以你與收單機構簽約時的條款為準；不同國家、不同卡種會有差異。",
    "风控": "風險控制",
    "最怕的不是没单，是收了钱又被退回去": "最怕的不是沒單，是收了錢又被退回去",
    "高风险订单在付款时就会被拦下来——地址和卡不一致、短时间多笔、代理 IP。与其事后申诉，不如事前不接。": "高風險訂單在付款時就會被攔下來——地址和卡不一致、短時間多筆、代理 IP。與其事後申訴，不如事前不接。",
    "高风险订单自动标记，可选择暂缓发货": "高風險訂單自動標記，可選擇暫緩發貨",
    "每笔拒付的申诉材料模板，照着填就行": "每筆拒付的申訴材料模板，照著填就行",
    "拒付率接近警戒线时提前提醒，避免被封号": "拒付率接近警戒線時提前提醒，避免被封號",
    "金额": "金額",
    "风险": "風險",
    "建议": "建議",
    "低": "低",
    "正常发货": "正常發貨",
    "中": "中",
    "核对地址": "核對地址",
    "高": "高",
    "暂缓 · 卡地不符": "暫緩 · 卡地不符",
    "高风险订单不会自动取消，": "高風險訂單不會自動取消，",
    "决定权还在你": "決定權還在你",
    "，系统只负责提醒。": "，系統只負責提醒。",
    "提现": "提現",
    "赚的钱，随时能拿出来": "賺的錢，隨時能拿出來",
    "提到银行卡": "提到銀行卡",
    "人民币直接进国内储蓄卡，1–3 个工作日到账，单笔最低 100 元。": "人民幣直接進國內儲蓄卡，1–3 個工作日到帳，單筆最低 100 元。",
    "留在外币账户": "留在外幣賬戶",
    "美元、欧元、英镑可以留着付广告费、付供应商，不用来回换汇。": "美元、歐元、英鎊可以留著付廣告費、付供應商，不用來回換匯。",
    "对账单": "對賬單",
    "每笔收入、退款、拒付都有流水，按月导出，报税和记账直接用。": "每筆收入、退款、拒付都有流水，按月導出，報稅和記賬直接用。",
    "费率这块最容易看漏一句": "費率這塊最容易看漏一句",
    "。钱从客户那里直接进你的账户，平台不代收，也就不存在压款、跑路、限额提不出来这些事。": "。錢從客戶那裡直接進你的賬戶，平台不代收，也就不存在壓款、跑路、限額提不出來這些事。",
    "先把收款接上，再谈卖什么": "先把收款接上，再談賣什麼",
    "开店后绑定 PayPal 或 Stripe，当天就能收第一笔钱。": "開店後綁定 PayPal 或 Stripe，當天就能收第一筆錢。",
    "价格": "價格",
    "订阅按店铺收费": "訂閱按店鋪收費",
    "佣金按成交额往下走": "佣金按成交額往下走",
    "套餐是固定的工具费，佣金只在你出单时收。": "套餐是固定的工具費，佣金只在你出單時收。",
    "卖得越多，费率越低": "賣得越多，費率越低",
    "成交额越大费率越低，自动算，不用谈。": "成交額越大費率越低，自動算，不用談。",
    "免费试用": "免費試用",
    "逐项对比": "逐項對比",
    "试用不绑卡": "試用不綁卡",
    "月 / 季 / 年随时换": "月/季/年隨時換",
    "佣金封顶": "佣金封頂",
    "先领 {days} 天试用，跑通一单再选档。": "先領 {days} 天試用，跑通一單再選檔。",
    "佣金只有成交才收": "佣金只有成交才收",
    "，没出单一分不收。": "，沒出單一分不收。",
    "订阅套餐": "訂閱套餐",
    "四档，按你开到第几家店来选": "四檔，按你開到第幾家店來選",
    "价格以美元计，月付 / 季付 / 年付三档同权，只是单价不同。": "價格以美元計，月付/季付/年付三檔同權，只是單價不同。",
    "多数人选这个": "多數人選這個",
    "/ 月": "/ 月",
    "每店限领一次，不绑卡": "每店限領一次，不綁卡",
    "季付": "季付",
    "年付": "年付",
    "领试用": "領試用",
    "选这个": "選這個",
    "价格取自平台计费中心，调整后本页同步。季付按 3 个月、年付按 12 个月计价，中途换档按剩余天数折算。": "價格取自平台計費中心，調整後本頁同步。季付按 3 個月、年付按 12 個月計價，中途換檔按剩餘天數折算。",
    "交易佣金": "交易佣金",
    "成交额越大，抽成越低": "成交額越大，抽成越低",
    "按店铺自然月成交额（折算美元）命中档位，整月按该档比例计提。没成交就没有佣金。": "按店鋪自然月成交額（折算美元）命中檔位，整月按該檔比例計提。沒成交就沒有佣金。",
    "只对已完成且未退款的订单计提，退款自动冲回。": "只對已完成且未退款的訂單計提，退款自動沖回。",
    "佣金与套餐档位无关，选哪档都是同一套阶梯。": "佣金與套餐檔位無關，選哪檔都是同一套階梯。",
    "账单每月 1 号出，后台可下载明细，逐单可查。": "帳單每月 1 號出，後台可下載明細，逐單可查。",
    "差在哪，一条条看": "差在哪，一條條看",
    "额度": "額度",
    "月付价格": "月付價格",
    "免费": "免費",
    "季付价格": "季付價格",
    "年付价格": "年付價格",
    "可开店数": "可開店數",
    "可上架商品": "可上架商品",
    "文本翻译": "文本翻譯",
    "次": "次",
    "图片翻译": "圖片翻譯",
    "AI 模板": "AI 模板",
    "套": "套",
    "阶梯，与档位无关": "階梯，與檔位無關",
    "额度按月计，用完可等次月重置，或升档补足；未用完不结转到下月。": "額度按月計，用完可等次月重置，或升檔補足；未用完不結轉到下月。",
    "付钱之前，先把这些问清楚": "付錢之前，先把这些問清楚",
    "佣金到底怎么算？": "佣金到底怎麼算？",
    "按店铺当月成交额（折算美元）落在哪一档，整月就按那一档的比例计提，档位和费率见上面的阶梯表。退款订单会把对应佣金冲回，不多收。": "按店鋪當月成交額（折算美元）落在哪一檔，整月就按那一檔的比例計提，檔位和費率見上面的階梯表。退款訂單會把對應佣金沖回，不多收。",
    "佣金是按订单金额还是按利润收？": "佣金是按訂單金額還是按利潤收？",
    "按订单实际成交金额（不含运费和税），不是按你的利润。所以亏钱卖的单也会产生佣金——定价时把这一项算进成本，后台的毛利计算器已经默认扣掉了。": "按訂單實際成交金額（不含運費和稅），不是按你的利潤。所以虧錢賣的單也會產生佣金——定價時把這一項算進成本，後台的毛利計算器已經默認扣掉了。",
    "试用结束后会怎样？": "試用結束後會怎樣？",
    "试用期不绑卡、不自动扣费。到期后店铺进入只读状态：商品和订单都还在，但不能接新单，选一档套餐付费后立即恢复。每个店铺只能领一次试用。": "試用期不綁卡、不自動扣費。到期後店鋪進入只讀狀態：商品和訂單都還在，但不能接新單，選一檔套餐付費後立即恢復。每個店鋪只能領一次試用。",
    "可以随时换档或退款吗？": "可以隨時換檔或退款嗎？",
    "可以。升档立即生效，按剩余天数折算差价；降档在下个账期生效，不会立刻断掉额度。月付随时取消，年付 7 天内未使用可全额退。": "可以。升檔立即生效，按剩餘天數折算差價；降檔在下個帳期生效，不會立刻斷掉額度。月付隨時取消，年付 7 天內未使用可全額退。",
    "换套餐，店铺数据会丢吗？": "換套餐，店鋪數據會丟嗎？",
    "不会。商品、订单、客户、模板都会保留。降档后超出新额度的部分变成只读，不会删除；再升回来立刻恢复。": "不會。商品、訂單、客戶、模板都會保留。降檔後超出新額度的部分變成只讀，不會刪除；再升回來立刻恢復。",
    "多开店铺怎么算？": "多開店鋪怎麼算？",
    "按套餐给的开店数算，档位越高能开的店越多。每家店独立域名、独立语言、独立客户数据，佣金也按店分别计算档位。": "按套餐給的開店數算，檔位越高能開的店越多。每家店獨立域名、獨立語言、獨立客戶數據，佣金也按店分別計算檔位。",
    "先别挑最贵的": "先別挑最貴的",
    "大部分人是": "大部分的人是",
    "先领 {days} 天试用，再选单店版跑一个月": "先領 {days} 天試用，再選單店版跑一個月",
    "，等单量稳定了才升档。升档按天折算，不用重新付一整月。": "，等單量穩定了才升檔。升檔按天折算，不用重新付一整月。",
    "先试 {days} 天，跑通一单再说": "先試 {days} 天，跑通一單再說",
    "不绑卡、不自动续费。试用到期店铺只读，数据不会丢。": "不綁卡、不自動續費。試用到期店鋪只讀，數據不會丟。",
    "领 {days} 天试用": "領 {days} 天試用",
    "还有问题": "還有問題",
    "以上": "以上",
    "月成交额 ＜": "月成交額 ＜",
    "给想把中国货卖到全世界的人，一个能真正跑通生意的地方。": "給想把中國貨賣到全世界的人，一個能真正跑通生意的地方。",
    "在线客服": "在線客服",
    "产品": "產品",
    "全部功能": "全部功能",
    "模板市场": "模板市場",
    "卖家": "賣家",
    "我在中国 · 把货卖出去": "我在中國 · 把貨賣出去",
    "我在海外 · 卖中国好货": "我在海外 · 賣中國好貨",
    "BuyLink": "BuyLink",
    "资源": "資源",
    "开店教程": "開店教程",
    "服务状态": "服務狀態",
    "联系我们": "聯繫我們",
    "公司": "公司",
    "关于 Taoify": "關於 Taoify",
    "加入我们": "加入我們",
    "隐私政策": "隱私政策",
    "服务条款": "服務條款",
    "退款政策": "退款政策",
    "保留所有权利。": "保留所有權利。",
    "等 20 种语言": "等 20 種語言",
    "主导航": "主導航",
    "语言": "語言",
    "20 种语言 · 买家看自己的母语": "20 種語言 · 買家看自己的母語",
    "登录": "登入",
    "模板中心": "模板中心",
    "用户": "用戶",
    "小店管理": "小店管理",
    "退出登录": "登出",
    "菜单": "選單",
    "欢迎回来": "歡迎回來",
    "登录您的账户，继续您的建站之旅": "登錄您的賬戶，繼續您的建站之旅",
    "电子邮件": "電子郵件",
    "示例@mail.com": "示例@mail.com",
    "登录密码": "登錄密碼",
    "还没有账号": "還沒有賬號",
    "注册": "註冊",
    "专业主题网站模板": "專業主題網站模板",
    "我忘记登录密码了，怎么重置": "我忘記登錄密碼了，怎麼重設",
    "请输入电子邮件": "請輸入電子郵件",
    "请输入登陆密码": "請輸入登錄密碼",
    "选择店铺类型": "選擇店鋪類型",
    "开通即拥有 AI 运营团队，7×24 小时自动管理你的跨境商店": "開通即擁有 AI 運營團隊，7×24 小時自動管理你的跨境商店",
    "在线商店": "在線商店",
    "不单是建立了一个网站，而是建立了一个完整的、自动履单免维护，并且可无限扩展升级的事业": "不只是建立了一個網站，而是建立了一個完整的、自動履單免維護，並且可無限擴展升級的事業",
    "AI 员工代运营": "AI 員工代運營",
    "开通店铺即配备 AI 运营团队，自动上架商品、回复客户、处理订单，无需招人管理": "開通店鋪即配備 AI 運營團隊，自動上架商品、回復客戶、處理訂單，無需招人管理",
    "AI 跨境获客": "AI 跨境獲客",
    "AI 自动生成多语言商品文案与营销素材，智能投放引流，帮你获取全球客户": "AI 自動生成多語言商品文案與行銷素材，智能投放引流，幫你獲取全球客戶",
    "AI 智能客服": "AI 智慧客服",
    "AI 客服 7×24 小时多语言应答，自动处理售前售后，转化率显著提升": "AI 客服 7×24 小時多語言應答，自動處理售前售后，轉化率顯著提升",
    "离开": "離開",
    "下一步": "下一步",
    "店铺模板": "店鋪模板",
    "上百种精选电商主题模板一键应用，卡片式操作，无需设计能力，快速拥有一个能提现您品牌调性、安全、稳定的在线商店": "上百種精選電商主題模板一鍵應用，卡片式操作，無需設計能力，快速擁有一個能提现您品牌調性、安全、穩定的在線商店",
    "请选择您想要的模板~": "請選擇您想要的模板~",
    "全部": "全部",
    "搜索模板名称": "搜索模板名稱",
    "最低价": "最低價",
    "最高价": "最高價",
    "筛选": "篩選",
    "重置": "重設",
    "个模板": "個模板",
    "选择模板": "選擇模板",
    "取消选择": "取消選擇",
    "需付费使用": "需付費使用",
    "可在模板市场购买": "可在模板市場購買",
    "预览": "預覽",
    "后退": "後退",
    "完善店铺信息": "完善商店資訊",
    "填写店铺名称与域名，完成注册即可开店": "填寫商店名稱與網域，完成註冊即可開店",
    "店铺信息": "商店資訊",
    "店铺名称": "商店名稱",
    "创建一个简单好记的店铺名称": "創建一個簡單好記的商店名稱",
    "填写您的店铺名称": "填寫您的商店名稱",
    "店铺域名": "商店網域",
    "设置简洁前缀，方便用户检索商店": "設置簡潔前綴，方便用戶檢索商店",
    "字母或数字": "字母或數字",
    "个人信息": "個人資訊",
    "填写您的电子邮箱": "填寫您的電子郵件",
    "店铺密码": "商店密碼",
    "填写您的店铺密码": "填寫您的商店密碼",
    "邮箱验证码": "電子郵件驗證碼",
    "请输入邮箱验证码": "請輸入電子郵件驗證碼",
    "电话号码": "電話號碼",
    "区号": "區號",
    "搜索国家": "搜索國家",
    "填写您的电话号码": "填寫您的電話號碼",
    "我已阅读并同意以下法律文件：": "我已閱讀並同意以下法律文件：",
    "消费协议": "消費協議",
    "用户使用协议": "用戶使用協議",
    "请先阅读并勾选同意上述法律文件，才能开通店铺": "請先閱讀並勾選同意上述法律文件，才能開通店鋪",
    "创建": "創建",
    "开通": "開通",
    "法律文件": "法律文件",
    "我已阅读并同意": "我已閱讀並同意",
    "商城站": "商城站",
    "代购站": "代購站",
    "创建一个电子商务网站，帮您在线采购中国商品，系统化订单管理，促进销售并管理您的日常工作。": "創建一個電子商務網站，幫您在線採購中國商品，系統化訂單管理，促進銷售並管理您的日常工作。",
    "请填写有效的域名": "請填寫有效的域名",
    "请填写正确的邮箱": "請填寫正確的郵箱",
    "请填写有效的电话号码": "請填寫有效的電話號碼",
    "点击发送验证码": "點擊發送驗證碼",
    "不支持大写字母，请使用小写字母": "不支持大寫字母，請使用小寫字母",
    "商店地址要求：4-50个字符，由小写字母、数字和连接符（-）组成，不能以数字或连接符开头或结尾，且不能包含大写字母或空格。": "商店地址要求：4-50個字符，由小寫字母、數字和連接符（-）組成，不能以數字或連接符開頭或結尾，且不能包含大寫字母或空格。",
    "电话号码需为7-15位数字": "電話號碼需為7-15位數字",
    "电话号码格式正确": "電話號碼格式正確",
    "请填写店铺名称": "請填寫店鋪名稱",
    "请填写有效的电子邮箱": "請填寫有效的電子郵件",
    "请填写店铺密码": "請填寫店鋪密碼",
    "请填写邮箱验证码": "請填寫電子郵件驗證碼",
    "请选择区号": "請選擇區號",
    "请填写有效的店铺域名": "請填寫有效的店鋪網址",
    "请选择店铺模板": "請選擇店鋪模板",
    "关于我们": "關於我們",
    "让想把中国货卖出去的人，都能自己开一家跨境店": "讓想把中國貨賣出去的人，都能自己開一家跨境店",
    "Taoify 是一套跨境电商 SaaS：开店、装修、商品、订单、物流、收款、AI 客服，都在一个后台里管完。": "Taoify 是一套跨境電商 SaaS：開店、裝修、商品、訂單、物流、收款、AI 客服，都在一個後台裡管完。",
    "阶梯佣金，按成交额自动降": "階梯佣金，按成交額自動降",
    "AI 客服在线接待": "AI 客服在線接待",
    "个后台管完全流程": "一個後台管完全流程",
    "我们是谁": "我們是誰",
    "一支做跨境电商系统出身的团队": "一支做跨境電商系統出身的團隊",
    "不是通用建站工具改出来的，是从代购、集运、清关这些真实环节里长出来的系统。": "不是通用建站工具改出來的，是從代購、集運、清關這些真實環節裡長出來的系統。",
    "香港星橋國際貿易有限公司": "香港星橋國際貿易有限公司",
    "跨境行业全链路解决方案软件服务商": "跨境行業全鏈路解決方案軟件服務商",
    "公司以互联网信息技术开发与物联网 IOT 服务为核心，为跨境卖家提供从建站到履约的整套工具。": "公司以互聯網信息技術開發與物聯網 IOT 服務為核心，為跨境賣家提供從建站到履約的整套工具。",
    "依托自身服务体系与技术团队，我们把店铺系统、商品翻译、跨境物流、收款结算和 AI 客服做成了一条能跑通的链路——卖家不需要自己拼七八个系统。": "依托自身服務體系與技術團隊，我們把店鋪系統、商品翻譯、跨境物流、收款結算和 AI 客服做成了一條能跑通的鏈路——賣家不需要自己拼七八個系統。",
    "产品团队长期和一线卖家、物流商、支付机构一起打磨，形成 Taoify 对跨境场景的理解：能落地的功能，比看起来花哨的功能更重要。": "產品團隊長期和一線賣家、物流商、支付機構一起打磨，形成 Taoify 對跨境場景的理解：能落地的功能，比看起來花哨的功能更重要。",
    "店铺与装修": "店鋪與裝修",
    "模板市场 + 可视化装修，装修不用等开发": "模板市場 + 可視化裝修，裝修不用等開發",
    "商品、政策页、店铺界面一起翻，买家看母语": "商品、政策頁、店鋪界面一起翻，買家看母語",
    "面单、轨迹、异常件在一个后台处理": "面單、軌跡、異常件在一個後台處理",
    "AI 员工与客服": "AI 員工與客服",
    "按你的规则答客户，规则外自动转人工": "按你的規則答客戶，規格外自動轉人工",
    "想聊合作、聊方案，直接找人": "想聊合作、聊方案，直接找人",
    "售前问题可以先问 AI 客服，它答不上会转给同事。": "售前問題可以先問 AI 客服，它答不上會轉給同事。",
    "售前咨询": "售前諮詢",
    "工作日 9:00–21:00 有人接，急事直接打电话。": "工作日 9:00–21:00 有人接，急事直接打電話。",
    "合作与入驻": "合作與入駐",
    "渠道合作、代理、企业采购，发邮件说明来意即可。": "渠道合作、代理、企業採購，發郵件說明來意即可。",
    "开店、选品、物流、结算的问题，随时问。": "開店、選品、物流、結算的問題，隨時問。",
    "做跨境这件事，我们一直在找懂业务、也愿意把细节做扎实的人。简历发到合作邮箱，标题写清岗位方向。": "做跨境這件事，我們一直在找懂業務、也願意把細節做紮實的人。履歷發到合作郵箱，標題寫清崗位方向。",
    "扫码添加客服": "掃碼添加客服",
    "扫码联系我们": "掃碼聯繫我們",
    "先开一间店，比自己拼系统快": "先開一間店，比自己拼系統快",
    "免费试用，不绑卡。跑通一单再决定用哪一档。": "免費試用，不綁卡。跑通一單再決定用哪一檔。",
    "Taoify用户注册协议": "Taoify用戶註冊協議",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户注册协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "提示：您如需註冊或使用 Taoify 平台服務，應當完整閱讀並嚴格遵守《Taoify 用戶註冊協議》，重點關注免責聲明、責任限制、違規處置等內容，明確自身權利、義務、使用規則及違約責任。平台後續上線的全部新功能、新工具，均受本使用協議約束。",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify有權不定期更新、修改本使用協議裡的內容，有權在 Taoify網站上發布更新和修改更新本使用協議。最新版本將統一公示於商城處，請您定期查閱條款更新內容。若您不認可條款修訂內容，須立即停止使用平台全部服務。",
    "本协议为《Taoify 服务条款》补充文件，全套文件还包括《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；针对主协议未予以明确的事项，适用本协议约定。": "本協議為《Taoify 服務條款》補充文件，全套文件還包括《Taoify 用戶隱私政策》等，其中《Taoify 服務條款》為主協議。本協議約定內容如與《Taoify 服務條款》衝突，以《Taoify 服務條款》為準；針對主協議未予以明確的事項，適用本協議約定。",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "除本協議明確約定內容以外，雙方所有其他權利義務、規則約束均以《Taoify 服務條款》《Taoify 用戶使用協議》《Taoify消費協議》等為準。",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括本协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》《Taoify 消费协议》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "完成帳號註冊，即代表您已充分知曉並自願接受Taoify 平台所有協議、條款，包括本協議、《Taoify 用戶使用協議》《Taoify 服務條款》《Taoify用戶隱私政策》《Taoify 消費協議》等。若您不認可Taoify 平台所有協議、條款內容，請立即停止註冊。",
    "定义": "定義",
    "1、本协议通用术语定义均与《Taoify 服务条款》保持一致，不再重复释义，仅针对一件代发、店铺代运营、商品存储作出专项释义。": "1、本協議通用術語定義均與《Taoify 服務條款》保持一致，不再重複釋義，僅針對一件代發、店鋪代運營、商品存儲作出專項釋義。",
    "2、一件代发服务：指经您书面申请，Taoify平台审批通过，您办理完毕一件代发所需手续（包括但不限于签订协议等）后，Taoify平台为您采购中国境内一个或多个商品并在打包完成后寄送到您的指定收货地址的整个服务流程。": "2、一件代發服務：指經您書面申請，Taoify平台審批通過，您辦理完畢一件代發所需手續（包括但不限於簽訂協議等）後，Taoify平台為您採購中國境內一個或多個商品並在打包完成後寄送到您的指定收貨地址的整個服務流程。",
    "3、店铺代运营服务：指经您书面申请，Taoify平台审批通过，您办理完毕店铺代运营服务所需手续（包括但不限于签订店铺代运营合同/SOP）后，基于您选择的店铺服务项对您的店铺进行代运营操作的整个过程。": "3、店鋪代運營服務：指經您書面申請，Taoify平台審批通過，您辦理完畢店鋪代運營服務所需手續（包括但不限於簽訂店鋪代運營合同/SOP）後，基於您選擇的店鋪服務項對您的店鋪進行代運營操作的整個過程。",
    "4、商品存储服务：指经您书面申请，Taoify平台审批通过，您办理完毕商品存储开通所需手续（包括但不限于您与平台另行签署协议）后，寄送至Taoify仓库的商品提供存储服务。": "4、商品存儲服務：指經您書面申請，Taoify平台審批通過，您辦理完畢商品存儲開通所需手續（包括但不限於您與平台另行簽署協議）後，寄送至Taoify倉庫的商品提供存儲服務。",
    "二、服务内容": "二、服務內容",
    "（一）基础服务": "（一）基礎服務",
    "1、建店/关联店铺，支持绑定Shopify/Taoify店铺平台。Taoify为您一键创建独立站店铺，同时Taoify能支持绑定您的独立站店铺并提供选择商品、订单管理、包裹管理和国际物流等全流程电商服务。": "1、建店/關聯店鋪，支持綁定Shopify/Taoify店鋪平台。Taoify為您一鍵創建獨立站店鋪，同時Taoify能支持綁定您的獨立站店鋪並提供選擇商品、訂單管理、包裹管理和國際物流等全流程電商服務。",
    "2、Taoify为每位用户提供一定的免费次数，您需为超出的次数付费。包括对接的第三方平台，商品搜索/编辑、订单同步到Taoify全球寄送等基础服务。": "2、Taoify為每位用戶提供一定的免費次數，您需為超出的次數付費。包括對接的第三方平台，商品搜索/編輯、訂單同步到Taoify全球寄送等基礎服務。",
    "3、海量商品搜索、上架，支持中国电商平台(淘宝、天猫、1688)。": "3、海量商品搜索、上架，支持中國電商平台(淘寶、天貓、1688)。",
    "（二）增值服务": "（二）增值服務",
    "1、商品采购、仓储打包、国际物流发货过程中发生的商品、包裹等增值服务，包括但不限于到付件代付、修剪线头、商品盘点、商品个性化贴标、EPE泡沫填充物、纸护角卡条、拉伸膜、木架加固等。": "1、商品採購、倉儲打包、國際物流發貨過程中發生的商品、包裹等增值服務，包括但不限於到付件代付、修剪線頭、商品盤點、商品個性化貼標、EPE泡沫填充物、紙護角卡條、拉伸膜、木架加固等。",
    "2、店铺运营中增值服务，包括但不限于Taoify为您提供多样化的店铺装修、商品管理、订单管理、店铺搭建托管、产品托管、订单托管、店铺运营托管等。": "2、店鋪運營中增值服務，包括但不限於Taoify為您提供多樣化的店鋪裝修、商品管理、訂單管理、店鋪搭建託管、產品託管、訂單託管、店鋪運營託管等。",
    "3、商品存储。经您书面申请、Taoify 平台审批通过，并另行签署相关协议办妥全部入库手续后，您寄送至 Taoify 仓库的商品方可入库存储。仓储完整收费标准、入库规则、库存管理、催告处置、损毁责任、付费仓储细则等全部权利义务，以双方另行签署的相关协议约定为准。商品自仓库签收当日起享有30天免费存储周期；免费存储到期前3日，平台将通过站内信、绑定邮箱向您发送到期提醒，您可选择将商品出库寄送，或选购付费仓储套餐延长存储期限。若免费存储期限届满后，您未在3日内完成商品出库、亦未办理付费仓储延期，且经平台再次催告后仍未处置滞留商品的，平台有权按照另行签订的协议约定对超期商品统一销毁处理；商品一经销毁无法找回、补发，因逾期未处置产生的全部损失、清运处置费用均由您自行承担，Taoify不承担任何赔偿责任。": "3、商品存儲。經您書面申請、Taoify 平台審批通過，並另行簽署相關協議辦妥全部入庫手續後，您寄送至 Taoify 倉庫的商品方可入庫存儲。倉儲完整收費標準、入庫規則、庫存管理、催告處置、損毀責任、付費倉儲細則等全部權利義務，以雙方另行簽署的相關協議約定為準。商品自倉庫簽收當日起享有30天免費存儲週期；免費存儲到期前3日，平台將通過站內信、綁定郵箱向您發送到期提醒，您可選擇將商品出庫寄送，或選購付費倉儲套餐延長存儲期限。若免費存儲期限屆滿後，您未在3日內完成商品出庫、亦未辦理付費倉儲延期，且經平台再次催告後仍未處置滯留商品的，平台有權按照另行簽訂的協議約定對超期商品統一銷毀處理；商品一經銷毀無法找回、補發，因逾期未處置產生的全部損失、清運處置費用均由您自行承擔，Taoify不承擔任何賠償責任。",
    "三、注意事项": "三、注意事項",
    "1、为了您的账号安全，在使用账号服务时，请您事先自行核实操作规则或谨慎决定是否授权给代运营团队操作。": "1、為了您的帳號安全，在使用帳號服務時，請您事先自行核實操作規則或謹慎決定是否授權給代運營團隊操作。",
    "2、您用户账户的使用记录和交易数据等均以我们的系统记录为准，如您对该等数据存有异议的，可及时向我们提出，我们会根据您提供的相关证据积极予以核实。": "2、您用戶帳號的使用記錄和交易數據等均以我們的系統記錄為準，如您對該等數據存有異議的，可及時向我們提出，我們會根據您提供的相關證據積極予以核實。",
    "3、平台可选择以网站公告、电子邮件、站内信等方式向您发送通知。": "3、平台可選擇以網站公告、電子郵件、站內信等方式向您發送通知。",
    "4、为了保护您及他人的合法权益，如您被他人投诉或投诉他人，我们可能会将您的姓名及身份信息和联系方式，企业经营范围和投诉相关内容等提供给第三方，以便及时解决投诉纠纷。": "4、為了保護您及其他人的合法權益，若您被他人投訴或投訴他人，我們可能會將您的姓名及身份信息和聯繫方式，企業經營範圍和投訴相關內容等提供給第三方，以便及時解決投訴糾紛。",
    "5、Taoify销售的商品均采购自中华人民共和国，符合中华人民共和国有关商品质量、安全、卫生、环保、标识等标准，可能与您所在国家的标准存在差异或冲突，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "5、Taoify銷售的商品均採購自中華人民共和國，符合中華人民共和國有關商品質量、安全、衛生、環保、標識等標準，可能與您所在國家的標準存在差異或衝突，您須自行辨別並承擔相關風險，Taoify平台不承擔任何賠償責任。",
    "6、Taoify销售的商品主要符合中华人民共和国的相关知识产权，但因知识产权的地域性因素影响，可能会侵犯您所在国家的相关知识产权，您须自行辨别并承担相关风险，Taoify平台不承担任何赔偿责任。": "6、Taoify銷售的商品主要符合中華人民共和國的相關知識產權，但因知識產權的地域性因素影響，可能會侵犯您所在國家的相關知識產權，您須自行辨別並承擔相關風險，Taoify平台不承擔任何賠償責任。",
    "7、如果任何组织或个人认为Taoify网站上的任何内容可能侵犯其知识产权，可以通过在线客服及时通知我们，我们会在收到通知后核实。": "7、如果任何組織或個人認為Taoify網站上的任何內容可能侵犯其知識產權，可以通過在線客服及時通知我們，我們會在收到通知後核實。",
    "四、其他": "四、其他",
    "1、平台有关条款（包括但不限于本注册协议等）可能会有除中文以外的其他版本。如果不同语言版本的注册协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本注册协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本注册协议，予以明确排除。": "1、平台有關條款（包括但不限於本註冊協議等）可能會有除中文以外的其他版本。如果不同語言版本的註冊協議之間存在任何差異、不一致或歧義，均以中文文本為準，其他文本僅作參考，不得用於抵觸或變更中文文本的含義。本註冊協議條款的訂立、效力、解釋、履行及爭議解決，均以中華人民共和國法律作為準據法，排除境外法律衝突規則。《聯合國國際貨物銷售合同公約》不應用於本註冊協議，予以明確排除。",
    "2、因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2、因本協議引起或與本協議有關的任何爭議，雙方應友好協商解決；協商不成的，任何一方均有權向Taoify 平台經營地有管轄權的人民法院提起訴訟。",
    "3、争议处理期间，除争议事项外，双方应继续履行本协议其他约定。": "3、爭議處理期間，除爭議事項外，雙方應繼續履行本協議其他約定。",
    "4、本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "4、本協議部分條款被廢止、無效或不能執行，並不影響其他條款效力。",
    "商店已经准备就绪": "商店已經準備就緒",
    "电子邮箱": "電子郵件",
    "店铺地址": "店鋪地址",
    "请确认基本的商店信息，之后您可以在管理中更改订阅": "請確認基本的商店信息，之後您可以在管理中更改訂閱",
    "去修改": "去修改",
    "进入我的店铺": "進入我的店鋪",
    "管理后台": "管理後台",
    "查看您的商店业务概述": "查看您的商店業務概覽",
    "多达": "多達",
    "一键上传到你的商店，销售什么商品由你来决定": "一鍵上傳到你的商店，銷售什麼商品由你來決定",
    "数10种类付款方式，您的顾客在选择好商品之后，可以选择当地的安全支付方式为您快捷收款": "數十種付款方式，讓您的顧客在選擇商品後，可以選用當地的安全支付方式快速付款",
    "灵活的物流渠道选择，把货物安全的交付给您的顾客": "靈活的物流渠道選擇，安全地將貨物送達您的顧客手中",
    "简化订单，跟踪付款和查看实时业务，因此您可以更专注于建立您的业务": "簡化訂單處理、追蹤付款和查看即時業務狀況，讓您可以更專注於拓展業務",
    "直接在商店里与消费者沟通，提升千倍销量，接触并留住消费者": "直接在商店內與消費者溝通，提升千倍銷售量，接觸並留住消費者",
    "点击进入我的店铺": "點擊進入我的店鋪",
    "激活成功": "啟動成功",
    "去购物": "去購物",
    "Taoify消费协议": "Taoify消費協議",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify消费协议》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本消费协议约束。": "提示：若您需要註冊或使用 Taoify 平台服務，應完整閱讀並嚴格遵守《Taoify消費協議》，明確自身權利、義務、使用規則及違約責任。平台後續上線的所有新功能、新工具，均受本消費協議約束。",
    "Taoify有权不定期更新、修改本消费协议里的内容，有权在 Taoify 网站上发布更新和修改本消费协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify 有權不定期更新、修改本消費協議中的內容，並有權在 Taoify 網站上發布更新和修改本消費協議。最新版本將統一公示於商城處，請您定期查閱條款更新內容。若您不認可條款修訂內容，須立即停止使用平台全部服務。",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify 用户隐私政策》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》等为准。": "本協議為《Taoify 服務條款》補充文件，全套文件還包括《Taoify 用戶使用協議》《Taoify 用戶隱私政策》等，其中《Taoify 服務條款》為主協議。本協議約定內容如與《Taoify 服務條款》衝突，以《Taoify 服務條款》為準；除本協議明確約定內容以外，雙方所有其他權利義務、規則約束均以《Taoify 服務條款》《Taoify 用戶使用協議》《Taoify 用戶隱私政策》等為準。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本消费协议、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "您完成帳戶註冊，即代表您已充分知曉並同意接受 Taoify 平台所有協議、條款，包括本消費協議、《Taoify 用戶使用協議》《Taoify 服務條款》《Taoify 用戶隱私政策》等。若您不認同 Taoify 平台所有協議、條款內容，請立即停止註冊。",
    "本协议中所有术语定义，均与《Taoify 服务条款》保持统一，不再重复释义。": "本協議中所有術語定義，均與《Taoify 服務條款》保持一致，不再重複釋義。",
    "一、消费须知": "一、消費須知",
    "1、Taoify 将向用户提供 Taoify 官网所展示的电商建站服务、相关的技术支持以及网络支持等服务。用户需按平台公示标准支付对应费用，具体包括但不限于订阅费用、保证金、交易佣金等。": "1、Taoify 將向用戶提供 Taoify 官網所展示的電商建站服務、相關的技術支持以及網絡支持等服務。用戶需按平台公示標準支付對應費用，具體包括但不限於訂閱費用、保證金、交易佣金等。",
    "2、所有服务收费标准都在订购页面予以列明公示，您可自行选择具体服务类型、服务套餐，并按列明的价格支付费用。您可以登录店铺后台，依次点击「后台设置」>「账单」>「账单管理」进行查看付费明细。": "2、所有服務收費標準都在訂購頁面予以列明公示，您可以自行選擇具體服務類型、服務套餐，並按列明的價格支付費用。您可以登錄店鋪後台，依次點擊「後台設置」>「帳單」>「帳單管理」進行查看付費明細。",
    "二、服务费用与付费方式": "二、服務費用與付費方式",
    "1、服务费用": "1、服務費用",
    "您可以按照您的需求，根据方案计价选择相应的套餐类型，并根据所选择的套餐类型支付服务费用。": "您可以根據您的需求，選擇相應的套餐類型，並根據所選擇的套餐類型支付服務費用。",
    "2、付费方式": "2、付費方式",
    "2.1 预付制": "2.1 預付制",
    "2.1.1 店铺订阅费用采用预付模式，系统将在服务到期前5个自然日自动发起续费扣款。续费、扣款失败、退回等完整规则见《Taoify 服务条款》。": "2.1.1 店鋪訂閱費用採用預付模式，系統將在服務到期前5個自然日自動發起續費扣款。續費、扣款失敗、退回等完整規則見《Taoify 服務條款》。",
    "2.1.2 保证金采用预付制，用户完成账户注册时，须一次性足额缴纳经营保证金1000元，保证金不得抵扣订阅费、税费。保证金支付、退回等完整规则见《Taoify 服务条款》。": "2.1.2 保證金採用預付制，用戶完成賬戶註冊時，須一次性足額繳納經營保證金1000元，保證金不得抵扣訂閱費、稅費。保證金支付、退回等完整規則見《Taoify 服務條款》。",
    "2.1.3 费用支付后，平台提供服务。若因付款异常导致支付中止，您可在商城「后台设置」>「账单」>「账单管理」中查看处理结果，并手工完成支付。": "2.1.3 費用支付後，平台提供服務。若因付款異常導致支付中止，您可在商城「後台設置」>「賬單」>「賬單管理」中查看處理結果，並手工完成支付。",
    "2.2 付费": "2.2 付費",
    "2.2.1 佣金": "2.2.1 佣金",
    "2.2.1.1 用户按平台公示标准向平台支付佣金；平台现行阶段暂未计收佣金，具体费率以平台届时公示为准。": "2.2.1.1 用戶按平台公示標準向平台支付佣金；平台現行階段暫未計收佣金，具體費率以平台屆時公示為準。",
    "2.2.1.2 Taoify收取的佣金基于订单的付款状态计取，每月销售付款金额以平台后台生成的订单截图为准，若由于后续订单产生退款等，不退还该笔订单的佣金。": "2.2.1.2 Taoify收取的佣金基於訂單的付款狀態計取，每月銷售付款金額以平台後台生成的訂單截圖為準，若由於後續訂單產生退款等，不退還該筆訂單的佣金。",
    "2.2.1.3 平台于每月月底向用户出具当月付款销售业务的结算报告（包括销售付款金额及相应佣金金额）并交付给用户。用户在收到结算报告后2日内提出异议，若未提出异议视为认可结算报告。用户须于收到结算报告后5日内，单独向平台付清该月佣金。若用户在收到结算报告后2日内提出书面异议的，就无争议佣金须于收到结算报告5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期佣金暂按平台原结算报告金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.2.1.3 平台於每月月底向用戶出具當月付款銷售業務的結算報告（包括銷售付款金額及相應佣金金額）並交付給用戶。用戶在收到結算報告後2日內提出異議，若未提出異議視為認可結算報告。用戶須於收到結算報告後5日內，單獨向平台付清該月佣金。若用戶在收到結算報告後2日內提出書面異議的，就無爭議佣金須於收到結算報告5日內單獨支付。就爭議部分雙方應自用戶提出異議之日起15日內完成對賬核對、提供全部業務憑證並確認調整金額；若雙方自用戶提出異議之日起15日內仍無法就金額達成一致，該期佣金暫按平台原結算報告金額先行支付；後續經核對、調解、訴訟確認差額後，在下一期結算中多退少補。",
    "2.3 其他费用": "2.3 其他費用",
    "2.3.1 除订阅费用、保证金、佣金外，经用户申请，平台自行内部审核通过后，用户可与Taoify平台另行签约开通后付费模式，签约后用户可以先使用Taoify为您提供的服务，平台再清算您店铺内所产生的费用，并通过线下交易的形式收取。": "2.3.1 除訂閱費用、保證金、佣金外，經用戶申請，平台自行內部審核通過後，用戶可與Taoify平台另行簽約開通後付費模式，簽約後用戶可以先使用Taoify為您提供的服務，平台再清算您店鋪內所產生的費用，並通過線下交易的形式收取。",
    "2.3.2 Taoify 后付费的具体流程：用户申请；平台自行内部审核通过；Taoify 在每月结束后通过 Taoify 客服通知您的账单；如您对账单有任何异议的，应于下月15日之前向 Taoify 客服书面提出，未在上述期限提出书面异议的，视为认可该账单及发票。用户须于收到账单后5日内，单独向平台付清。若用户在收到账单后2日内提出书面异议的，就无争议部分须于收到账单5日内单独支付。就争议部分双方应自用户提出异议之日起15日内完成对账核对、提供全部业务凭证并确认调整金额；若双方自用户提出异议之日起15日内仍无法就金额达成一致，该期费用暂按平台原账单金额先行支付；后续经核对、调解、诉讼确认差额后，在下一期结算中多退少补。": "2.3.2 Taoify 後付費的具體流程：用戶申請；平台自行內部審核通過；Taoify 在每月結束後通過 Taoify 客服通知您的賬單；如您對賬單有任何異議的，應於下月15日之前向 Taoify 客服書面提出，未在上述期限提出書面異議的，視為認可該賬單及發票。用戶須於收到賬單後5日內，單獨向平台付清。若用戶在收到賬單後2日內提出書面異議的，就無爭議部分須於收到賬單5日內單獨支付。就爭議部分雙方應自用戶提出異議之日起15日內完成對賬核對、提供全部業務憑證並確認調整金額；若雙方自用戶提出異議之日起15日內仍無法就金額達成一致，該期費用暫按平台原賬單金額先行支付；後續經核對、調解、訴訟確認差額後，在下一期結算中多退少補。",
    "三、费用支付": "三、費用支付",
    "1、您必须向平台提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1、您必須向平台提供有效可用的支付方式，以避免扣款失敗影響店鋪使用。建議您綁定多張信用卡並授權使用自動支付。賬單支付的技術由第三方專業金融公司提供技術支持。",
    "2、账单生成后，系统将通过您授权的支付方式自动扣款，该扣款流程持续至本服务终止。若您设置默认支付卡，系统将优先从默认卡完成扣费。除另行约定外，所有费用均以美元作为结算及支付币种。": "2、賬單生成後，系統將通過您授權的支付方式自動扣款，該扣款流程持續至本服務終止。若您設置默認支付卡，系統將優先從默認卡完成扣費。除另行約定外，所有費用均以美元作為結算及支付幣種。",
    "3、费用将显示在账单上，并通过提供的电子邮件发送至商店所有者。如果您对账单存在疑问，可以与 Taoify 的相关业务部门进行联系。后续将通过电子邮件的形式与您取得联系，账单争议内容将发送至您所提供的店铺财务邮箱。": "3、費用將顯示在賬單上，並通過提供的電子郵件發送至商店所有者。如果您對賬單存在疑問，可以與 Taoify 的相關業務部門進行聯繫。後續將通過電子郵件的形式與您取得聯繫，賬單爭議內容將發送至您所提供的店鋪財務郵箱。",
    "4、针对 Taoify 自身收取的平台服务费，可联系平台对应业务部门办理，发票将通过邮件发送至您预留的店铺财务邮箱；第三方收取的款项，您应直接对接第三方主体办理，Taoify 可予以必要配合。": "4、針對 Taoify 自身收取的平台服務費，可聯繫平台對應業務部門辦理，發票將通過郵件發送至您預留的店鋪財務郵箱；第三方收取的款項，您應直接對接第三方主體辦理，Taoify 可予以必要配合。",
    "5、平台提前30日发出服务费用变更通知后即可调整服务收费标准，平台可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "5、平台提前30日發出服務費用變更通知後即可調整服務收費標準，平台可通過平台官網公告或您店鋪後台管理頁面公示的方式送達該通知。",
    "6、平台不就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "6、平台不就關於服務的任何修改、價格變動、暫停或終止對您或任何第三方承擔任何責任。",
    "7、若平台无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。平台每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，平台有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "7、若平台無法通過授權銀行卡成功扣取訂閱費用，將向您所有者發送郵件告知扣款失敗，並提示更新支付銀行卡。平台每間隔24小時重複發起扣費，總計最多三次扣款嘗試（含首次扣款）。第三次扣款仍失敗的，平台有權暫停並限制您賬戶使用權限。您繳清全部未結清款項及下一計費周期訂閱費用後，賬戶方可恢復正常訪問權限。",
    "8、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "8、服務期限屆滿前您未及時續訂閱費用的，服務自動終止；服務關閉滿10日用戶仍未續訂閱費用的，Taoify 平台有權刪除網站全部數據，相關損失由用戶自行承擔。",
    "9、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本消费协议中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向平台提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "9、Taoify 自行收取的平台服務費不包含各類政府徵收的稅金、規費及其他收費（本消費協議中統稱為\"稅費\"）。除平台服務費外，您因訂閱、採購 Taoify 產品與服務產生的全部適用稅費，均由您自行承擔。稅費將依據您提供的帳單地址適用稅率核算，並從您授權支付卡自動扣取。若您具備免稅資格，須向平台提交有效免稅憑證；部分司法管轄區要求提供能夠證實免稅資質、符合當地法規的官方證明文件，免稅政策自材料審核通過之日起生效。若 Taoify 未代為計收相關稅費，您必須自行判斷自身納稅義務，由您向稅務主管機關完成申報繳納稅款。",
    "10、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本消费协议约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "10、除 Taoify 代為收取並上繳主管稅務機關的稅費外，法律法規規定的各類稅款扣除、預提代繳義務均由您自行承擔，並由您單獨向對應稅務機關完成繳納。無論是否存在前述稅款扣除或預提要求，Taoify 均有權按照本消費協議約定，從您授權支付卡扣收全部應付費用，但Taoify無主動扣費義務。",
    "11、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "11、您店鋪經營銷售行為產生的全部適用稅費，均由您自行承擔並依法繳納。",
    "12、平台订阅费用、交易佣金应用费、模板费、罚金等均不支持退款；用户主动注销、中途终止服务、违规封禁账号，已缴纳全部费用不予返还；订单售后退款、退货的，对应订单已扣除佣金不予退还。": "12、平台訂閱費用、交易佣金應用費、模板費、罰金等均不支持退款；用戶主動註銷、中途終止服務、違規封禁帳號，已繳納全部費用不予返還；訂單售後退款、退貨的，對應訂單已扣除佣金不予退還。",
    "四、罚金政策": "四、罰金政策",
    "1、商家应确保及时、准确地处理订单、并将物流单号同步到后台。超时发货的订单采取了严格的处罚措施，具体处罚措施：付款30天内没有上传物流单号，每单额外收取0.5美元罚金。": "1、商家應確保及時、準確地處理訂單、並將物流單號同步到後臺。超時發貨的訂單採取了嚴格的處罰措施，具體處罰措施：付款30天內沒有上傳物流單號，每單額外收取0.5美元罰金。",
    "2、对于定制类、预售等可能需要超过30天的类目，须向 Taoify 书面提出申请延长发货申请，审批通过后不予处罚。": "2、對於定制類、預售等可能需要超過30天的類目，須向 Taoify 書面提出申請延長發貨申請，審批通過後不予處罰。",
    "3、Taoify 系统只提供基础建站功能，不提供、不负责买家与用户的资金处理与结算，资金相关的服务由第三方支付机构处理，相应风险由用户承担。": "3、Taoify 系統只提供基礎建站功能，不提供、不負責買家與用戶的資金處理與結算，資金相關的服務由第三方支付機構處理，相應風險由用戶承擔。",
    "4、若用户店铺单个自然月超时发货订单满5笔，或同一自然年度内累计超时发货订单满20笔的，用户除按约定向平台支付对应罚金外，平台亦有权依据平台公示协议及规则，暂停店铺经营服务、单方终止双方合作，且用户已向平台缴纳的全部费用不予退还。": "4、若用戶店鋪單個自然月超時發貨訂單滿5筆，或同一自然年度內累計超時發貨訂單滿20筆的，用戶除按約定向平台支付對應罰金外，平台亦有權依據平台公示協議及規則，暫停店鋪經營服務、單方終止雙方合作，且用戶已向平台繳納的全部費用不予退還。",
    "五、服务到期或欠款": "五、服務到期或欠款",
    "1、服务到期": "1、服務到期",
    "1.1 按时计费": "1.1 按時計費",
    "1.1.1 免费试用版：服务期限自平台为用户开通试用当日起算，到期未付费自动关闭站点。": "1.1.1 免費試用版：服務期限自平台為用戶開通試用當日起算，到期未付費自動關閉站點。",
    "1.1.2 付费版：服务期自用户支付服务费用付费或套餐支付费用后激活之日起计算，到期时间以店铺后台公示为准。": "1.1.2 付費版：服務期自用戶支付服務費用付費或套餐支付費用後激活之日起計算，到期時間以店鋪後臺公示為準。",
    "2、按量计费：若您使用的是先付费服务，即先购买服务次数/条数再使用的，在服务项目服务次数/条数在使用过程中消耗至零时，即视为服务到期。": "2、按量計費：若您使用的是先付費服務，即先購買服務次數/條數再使用的，在服務項目服務次數/條數在使用過程中消耗至零時，即視為服務到期。",
    "第六条 争议解决": "第六條 爭議解決",
    "1、平台有关条款（包括但不限于本消费协议等）可能会有除中文以外的其他版本。如果不同语言版本的消费协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本消费协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本消费协议，予以明确排除。": "1、平台有關條款（包括但不限於本消費協議等）可能會有除中文以外的其他版本。如果不同語言版本的消費協議之間存在任何差異、不一致或歧義，均以中文文本為準，其他文本僅作參考，不得用於抵觸或變更中文文本的含義。本消費協議條款的訂立、效力、解釋、履行及爭議解決，均以中華人民共和國法律作為準據法，排除境外法律衝突規則。《聯合國國際貨物銷售合同公約》不應用於本消費協議，予以明確排除。",
    "第七条 其他约定": "第七條 其他約定",
    "1、运营主体：本平台由香港星橋國際貿易有限公司（https://aitaoify.com，以下简称\"Taoify\"或\"平台\"）运营。您可通过邮箱 liutaotao@taocarts.com 或微信号 zzsist666 与平台取得联系。": "1、運營主體：本平台由香港星橋國際貿易有限公司（https://aitaoify.com，以下簡稱\"Taoify\"或\"平台\"）運營。您可通過郵箱 liutaotao@taocarts.com 或微信號 zzsist666 與平台取得聯繫。",
    "2、未成年人使用：本平台服务面向具有完全民事行为能力的主体。未成年人应在监护人陪同、指导下阅读本协议并在监护人同意后方可注册、使用本平台服务；监护人应就未成年人使用平台的行为承担相应法律责任。": "2、未成年人使用：本服務平台面向具有完全民事行為能力的主體。未成年人應在監護人陪同、指導下閱讀本協議並在監護人同意後方可註冊、使用本服務平台；監護人應就未成年人使用平台的行為承擔相應法律責任。",
    "3、知识产权：Taoify平台的商标、标识、页面设计、文案、软件、代码等知识产权均归平台或相关权利人所有，未经书面许可，任何人不得复制、修改、传播或用于商业用途。用户对其自行上传的内容依法享有权利，并保证该内容不侵犯第三方合法权益。": "3、智慧財產權：Taoify 平台的商標、標識、頁面設計、文案、軟體、代碼等智慧財產權均歸平台或相關權利人所有，未經書面許可，任何人不得複製、修改、傳播或用於商業用途。用戶對其自行上傳的內容依法享有權利，並保證該內容不侵犯第三方合法權益。",
    "4、通知送达：平台通过您预留的注册邮箱、店铺后台公告、站内消息或短信发出的通知，于发出之日即视为送达。您应保持联系方式有效，因联系方式变更未及时通知平台导致的后果由您自行承担。": "4、通知送達：平台通過您預留的註冊電子郵件、店鋪後台公告、站內消息或短信發出的通知，於發出之日即視為送達。您應保持聯繫方式有效，因聯繫方式變更未及時通知平台導致的後果由您自行承擔。",
    "5、完整协议：本协议连同《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 用户隐私政策》构成您与平台之间关于使用本平台服务的完整约定，取代此前双方就同一事项达成的口头或书面约定。": "5、完整協議：本協議連同《Taoify 服務條款》《Taoify 用戶使用協議》《Taoify 用戶隱私政策》構成您與平台之間關於使用本服務平台的完整約定，取代此前雙方就同一事項達成的口頭或書面約定。",
    "6、本协议更新日期：2026年1月1日；生效日期：2026年1月1日。": "6、本協議更新日期：2026年1月1日；生效日期：2026年1月1日。",
    "版权所有": "版權所有",
    "Taoify用户隐私政策": "Taoify用戶隱私政策",
    "提示：您如需注册或使用 Taoify平台服务，应当完整阅读并严格遵守《Taoify用户隐私政策》，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本用户隐私政策约束。": "提示：您如需註冊或使用 Taoify 平台服務，應當完整閱讀並嚴格遵守《Taoify 用戶隱私政策》，明確自身權利、義務、使用規則及違約責任。平台後續上線的全部新功能、新工具，均受本用戶隱私政策約束。",
    "Taoify有权不定期更新、修改本用户隐私政策里的内容，有权在 Taoify 网站上发布更新和修改本用户隐私政策。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify 有權不定期更新、修改本用戶隱私政策裡的內容，有權在 Taoify 網站上發布更新和修改本用戶隱私政策。最新版本將統一公示於商城處，請您定期查閱條款更新內容。若您不認可條款修訂內容，須立即停止使用平台全部服務。",
    "本协议为《Taoify服务条款》补充文件，全套文件还包括《Taoify 用户使用协议》《Taoify消费协议》等，其中《Taoify 服务条款》为主协议。本协议约定内容如与《Taoify 服务条款》冲突，以《Taoify 服务条款》为准；除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify 用户使用协议》《Taoify消费协议》等为准。": "本協議為《Taoify 服務條款》補充文件，全套文件還包括《Taoify 用戶使用協議》《Taoify 消費協議》等，其中《Taoify 服務條款》為主協議。本協議約定內容如與《Taoify 服務條款》衝突，以《Taoify 服務條款》為準；除本協議明確約定內容以外，雙方所有其他權利義務、規則約束均以《Taoify 服務條款》《Taoify 用戶使用協議》《Taoify 消費協議》等為準。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify平台所有协议、条款，包括本用户隐私政策、《Taoify 用户使用协议》《Taoify 服务条款》《Taoify消费协议》等。若您不认可Taoify平台所有协议、条款内容，请立即停止注册。": "您完成賬戶註冊，即代表您已充分知曉並自願接受 Taoify 平台所有協議、條款，包括本用戶隱私政策、《Taoify 用戶使用協議》《Taoify 服務條款》《Taoify 消費協議》等。若您不認可 Taoify 平台所有協議、條款內容，請立即停止註冊。",
    "一、适用范围": "一、適用範圍",
    "1、本政策适用于所有注册、访问、使用 Taoify 独立站建站平台的用户（商店所有者、员工账号）；": "1、本政策適用於所有註冊、訪問、使用 Taoify 獨立站建站平台的用戶（商店所有者、員工帳號）；",
    "2、本政策规范两类信息处理：2.1 用户自身注册资质、经营信息；2.2 用户店铺面向境外消费者收集的个人信息；": "2、本政策規範兩類信息處理：2.1 用戶自身註冊資質、經營信息；2.2 用戶店鋪面向境外消費者收集的個人資訊；",
    "3、本政策不适用于其他第三方（如支付、物流、广告服务商），第三方隐私规则由其自身政策约束，与平台无关。": "3、本政策不適用於其他第三方（如支付、物流、廣告服務商），第三方隱私規則由其自身政策約束，與平台無關。",
    "4、您完成账户注册，将被视为接受、同意、确认：您在自愿下同意向我们披露个人资料；您会遵守本隐私政策的全部条款和限制；您在我们的网站上作登记、资料会被收集；您同意日后我们对隐私政策的任何修改；您同意我们的分公司、附属公司、雇员，就您可能会感兴趣的产品和服务与您联络。": "4、您完成賬戶註冊，將被視為接受、同意、確認：您在自願下同意向我們披露個人資料；您會遵守本隱私政策的全部條款和限制；您在我們的網站上作登記、資料會被收集；您同意日後我們對隱私政策的任何修改；您同意我們的分公司、附屬公司、雇員，就您可能會感興趣的產品和服務與您聯絡。",
    "二、个人信息的收集": "二、個人資訊的收集",
    "1、收集用户（平台注册用户）信息": "1、收集用戶（平台註冊用戶）信息",
    "1.1 在您注册我们的服务、获取使用我们的服务或者以其他方式向我们提供信息时，我们会收集您的个人信息。": "1.1 在您註冊我們的服務、獲取使用我們的服務或者以其他方式向我們提供信息時，我們會收集您的個人資訊。",
    "1.2 经您同意，我们会收集、管理和监控个人资料。为了向您提供我们的各项服务，您需要提供个人资料，包括但不限于：企业名称、地址、联系电话、邮箱、营业执照、经营资质等，用于账户核验、资质审核、账单通知、售后对接、履约担保。": "1.2 經您同意，我們會收集、管理和監控個人資料。為了向您提供我們的各項服務，您需要提供個人資料，包括但不限於：企業名稱、地址、聯繫電話、電子郵件、營業執照、經營資質等，用於賬戶核驗、資質審核、賬單通知、售後對接、履約擔保。",
    "1.3 我们收集您访问 Taoify 上的网页的相关数据。我们还会收集有关您访问账号的方式和时间的相关数据，包括您使用的设备和浏览器，网络连接以及您的IP地址、设备型号、登录时间、操作记录等信息，用于账户安全风控、异常登录识别、平台功能优化。": "1.3 我們收集您訪問 Taoify 上的網頁的相關數據。我們還會收集有關您訪問賬號的方式和時間的相關數據，包括您使用的設備和瀏覽器，網絡連接以及您的 IP 地址、設備型號、登錄時間、操作記錄等信息，用於賬戶安全風險控制、異常登錄識別、平台功能優化。",
    "1.4 我们收集与支付相关信息，包括但不限于支付和处理订单、绑定信用卡等。": "1.4 我們收集與支付相關的信息，包括但不限於支付和處理訂單、綁定信用卡等。",
    "2、收集用户店铺的终端消费者信息：Taoify 仅作为技术工具存储数据，收集访客姓名、邮箱、电话、收货地址、支付订单、物流信息，用于订单履约、发货售后、订单对账。": "2、收集用戶店鋪的終端消費者信息：Taoify 僅作為技術工具存儲數據，收集訪客姓名、郵箱、電話、收貨地址、支付訂單、物流信息，用於訂單履約、發貨售后、訂單對賬。",
    "3、Cookie及非身份信息收集": "3、Cookie及非身份信息收集",
    "3.1 我们将通过您的IP地址来收集您的部分非个人化信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集该信息，我们将进行客流量统计，从而改进网站的管理和服务。": "3.1 我們將通過您的IP地址來收集您的部分非個人化信息，例如您的瀏覽器性質、操作系統種類、給您提供接入服務的ISP的域名等，以優化在您計算機屏幕上顯示的頁面。通過收集該信息，我們將進行客流量統計，從而改進網站的管理和服務。",
    "3.2 Cookies是一种技术，当您访问设有Cookies装置的本网站时，本网站之服务器会自动发送Cookies至您浏览器内，并储存到您的电脑硬盘内，此Cookies便负责记录日后您到访本网站的种种活动、个人资料、浏览习惯、消费习惯、信用记录。": "3.2 Cookies是一種技術，當您訪問設有Cookies裝置的本網站時，本網站之伺服器會自動發送Cookies至您瀏覽器內，並儲存到您的電腦硬盤內，此Cookies便負責記錄日後您到訪本網站的種種活動、個人資料、瀏覽習慣、消費習慣、信用記錄。",
    "3.3 运用Cookies技术，本网站能够为您提供更加周到的个性化服务。本网站将会运用Cookies追访您的购物喜好，从而向您提供感兴趣的信息资料或储存密码，以便您造访本网站时不必每次重复输入密码。": "3.3 運用Cookies技術，本網站能夠為您提供更加周到的個性化服務。本網站將會運用Cookies追訪您的購物喜好，從而向您提供感興趣的信息資料或儲存密碼，以便您造訪本網站時不必每次重複輸入密碼。",
    "3.4 您可自行在浏览器中关闭、清除 Cookie，关闭后部分平台功能将无法正常使用。": "3.4 您可自行在瀏覽器中關閉、清除 Cookie，關閉後部分平台功能將無法正常使用。",
    "三、个人信息的用途": "三、個人資訊的用途",
    "通常情况，本网站将采取合理的措施保护您的个人信息，使其避免未经授权的披露。在遵守相关法律的前提下，我们可能会与以下实体（可能包括境内和境外）分享使用您的个人信息。": "通常情況，本網站將採取合理的措施保護您的個人資訊，使其避免未經授權的披露。在遵守相關法律的前提下，我們可能會與以下實體（可能包括境內和境外）分享使用您的個人資訊。",
    "1、供应商：包括但不限于为了满足您网站需求的供货商、软件商、结汇收款、仓储物流、活动展会服务、代理商等。这些供应商可能根据需要与您联系，以完成相关产品服务；": "1、供應商：包括但不限於為了滿足您網站需求的供貨商、軟件商、結匯收款、倉儲物流、活動展會服務、代理商等。這些供應商可能根據需要與您聯繫，以完成相關產品服務；",
    "2、金融机构和第三方支付机构：当您预订订单、申请退款、购买保险时，我们会与金融机构或第三方支付机构共享特定的订单信息，当我们认为用于欺诈检测和预防目的实属必要时，我们将进一步和相关金融机构共享其他必要信息，如IP地址等；": "2、金融機構和第三方支付機構：當您預訂訂單、申請退款、購買保險時，我們會與金融機構或第三方支付機構共享特定的訂單信息，當我們認為用於欺詐檢測和預防目的實屬必要時，我們將進一步和相關金融機構共享其他必要信息，如IP地址等；",
    "3、业务第三方：我们可能与第三方为您提供产品或者服务，包括快递业务、通讯服务、客户服务、市场推广、广告投放等；": "3、業務第三方：我們可能與第三方為您提供產品或者服務，包括快遞業務、通訊服務、客戶服務、市場推廣、廣告投放等；",
    "4、我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用；": "4、我們可能會將來自某項服務的個人資訊與來自其他服務的信息結合起來，用於為了給您提供更加個性化的服務使用；",
    "5、经您许可的其他用途。": "5、經您許可的其他用途。",
    "四、个人信息的管理": "四、個人資訊的管理",
    "1、客户信息使用限制：作为 Taoify 平台商家，未经您书面明确许可，Taoify 不会主动单独联系您的客户，亦不会利用您店铺客户信息开展营销推广。但是如果我们是从其他渠道获取到您客户的信息，比如客户自己提供给我们，Taoify 可能会联系或向这些客户营销。": "1、客戶信息使用限制：作為 Taoify 平台商家，未經您書面明確許可，Taoify 不會主動單獨聯繫您的客戶，亦不會利用您店鋪客戶信息開展營銷推廣。但是如果我們是從其他渠道獲取到您客戶的信息，比如客戶自己提供給我們，Taoify 可能會聯繫或向這些客戶營銷。",
    "2、信息安全防护措施：Taoify 将落实物理、电子、流程、多维度技术安全防护机制，对平台存储的个人信息采取加密存储、访问权限管控、操作日志留痕等保护手段，防范个人信息泄露、篡改、丢失、非法访问。在我们网站上所搜集的一切资料都由我们所拥有，Taoify 不会向无关第三方共享、出租、出售您及您客户的任何个人信息。": "2、信息安全防護措施：Taoify 將落實物理、電子、流程、多維度技術安全防護機制，對平台存儲的個人資訊採取加密存儲、訪問權限管控、操作日誌留痕等保護手段，防范個人資訊泄露、篡改、丟失、非法訪問。在我們網站上所搜集的一切資料都由我們所擁有，Taoify 不會向無關第三方共享、出租、出售您及您客戶的任何個人資訊。",
    "3、网络传输风险提示：互联网传输环境存在固有安全风险，Taoify无法承诺网络传输过程实现绝对无风险。对因未经授权而接触您个人资料所发生的事件平台一概不承担责任，对于产生或导致的任何损失或损害，平台也不负责赔偿。": "3、網絡傳輸風險提示：互聯網傳輸環境存在固有安全風險，Taoify無法承諾網絡傳輸過程實現絕對無風險。對因未經授權而接觸您個人資料所發生的事件平台一概不承擔責任，對於產生或導致的任何損失或損害，平台也不負責賠償。",
    "4、用户自身安全保管义务：您需妥善保管账号、登录密码、员工账号权限、支付相关信息，不得向无关第三方泄露；在公用设备、他人设备登录平台后，务必及时退出登录。因您未妥善保管账号、随意下放员工数据权限、主动泄露信息引发的数据泄漏、财产损失、行政处罚、第三方索赔，全部责任由您自行承担，平台不承担任何责任。": "4、用戶自身安全保管義務：您需妥善保管帳號、登錄密碼、員工帳號權限、支付相關信息，不得向無關第三方泄露；在公用設備、他人設備登錄平台後，務必及時退出登錄。因您未妥善保管帳號、隨意下放員工數據權限、主動泄露信息引發的數據泄漏、財產損失、行政處罰、第三方索賠，全部責任由您自行承擔，平台不承擔任何責任。",
    "5、您对个人信息的自主管理权利：您依法享有个人信息的访问、查阅、更正、补充、限制使用、申请删除等权利。您可在店铺后台「账户设置」中自主编辑更新账户联系邮箱、联系电话、绑定支付卡片等基础信息。您可联系平台客服并提交对应证明材料申请更新营业执照、经营资质、历史备案主体等后台无法直接修改的信息。您可申请平台对非法定留存类个人信息进行删除。若您申请删除业务信息、限制订单/支付/风控所需信息的使用，店铺建站、收款、订单履约、账单推送等基础服务无法正常使用，由此产生的经营损失由您自行承担。": "5、您對個人資訊的自主管理權利：您依法享有個人資訊的訪問、查閱、更正、補充、限制使用、申請刪除等權利。您可在店鋪後台「帳戶設置」中自主編輯更新帳戶聯繫郵箱、聯繫電話、綁定支付卡片等基礎信息。您可聯繫平台客服並提交對應證明材料申請更新營業執照、經營資質、歷史備案主體等後台無法直接修改的信息。您可申請平台對非法定留存類個人資訊進行刪除。若您申請刪除業務信息、限制訂單/支付/風控所需信息的使用，店鋪建站、收款、訂單履約、帳單推送等基礎服務無法正常使用，由此產生的經營損失由您自行承擔。",
    "6、配套规则指引：本条未约定的员工数据权限管控、服务注销后信息留存、信息泄露赔付、第三方数据责任等全部事宜，均按照《Taoify 服务条款》《Taoify 用户使用协议》《Taoify 消费协议》执行。": "6、配套規則指引：本條未約定的員工數據權限管控、服務註銷後信息留存、信息洩露賠付、第三方數據責任等全部事宜，均按照《Taoify 服務條款》《Taoify 用戶使用協議》《Taoify 消費協議》執行。",
    "7、信息限制：7.1 平台面向跨境商家，不主动收集未成年人信息，若您店铺收集未成年人信息，由您自行承担合规责任。7.2 用户店铺面向境外消费者收集的境外个人信息，由用户自行满足当地数据出境合规要求，平台仅提供存储技术服务。": "7、信息限制：7.1 平台面向跨境商家，不主動收集未成年人信息，若您店鋪收集未成年人信息，由您自行承擔合規責任。7.2 用戶店鋪面向境外消費者收集的境外個人信息，由用戶自行滿足當地數據出境合規要求，平台僅提供存儲技術服務。",
    "8、信息储存与留存：服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "8、信息儲存與留存：服務無論因何種原因終止，您須自行完整留存店鋪經營全部資料（包括但不限於訂單記錄、商品資質、購銷合同、品牌授權、物流憑證、客戶交易臺賬、質檢報告等）並自行備案存檔，我方無義務代為保管、整理、備案任何資料。",
    "五、我们如何共享信息": "五、我們如何共享信息",
    "Taoify 对您及您店铺消费者的全部个人信息承担严格保密义务，不会以营销为目的向任何第三方出售、出租、共享您的个人信息。仅在以下法定、约定情形下，可依规共享相关信息：": "Taoify 對您及您店鋪消費者的全部個人信息承擔嚴格保密義務，不會以營銷為目的向任何第三方出售、出租、共享您的個人信息。僅在以下法定、約定情形下，可依規共享相關信息：",
    "1、事先取得您明确、书面的同意或授权；": "1、事先取得您明確、書面的同意或授權；",
    "2、依据生效法律文书、监管部门法定调查要求，配合司法、行政机关依法调取；": "2、依據生效法律文書、監管部門法定調查要求，配合司法、行政機關依法調取；",
    "3、向 Taoify 母公司、子公司、全资关联主体共享信息，关联方同样受本隐私政策约束，仅可用于平台配套经营服务，不得对外二次泄露；": "3、向 Taoify 母公司、子公司、全資關聯主體共享信息，關聯方同樣受本隱私政策約束，僅可用於平台配套經營服務，不得對外二次洩露；",
    "4、向可信第三方服务商（支付、物流、风控、建站插件等）提供必要信息，服务商仅能按照 Taoify 指令处理数据，且需遵守同等保密、安全义务，超出服务范围不得使用、披露您的信息；": "4、向可信第三方服務商（支付、物流、風控、建站插件等）提供必要信息，服務商僅能按照 Taoify 指令處理數據，且需遵守同等保密、安全義務，超出服務範圍不得使用、披露您的信息；",
    "5、为保护 Taoify、平台其他用户、终端消费者的人身、财产、数据合法权益，确有必要披露相关信息；": "5、為保護 Taoify、平台其他用戶、終端消費者的人身、財產、數據合法權益，確有必要披露相關信息；",
    "6、发生平台合并、收购、业务转让等情形，承接主体将继续受本隐私政策约束，若数据处理规则发生重大变更，平台将提前公示告知您。": "6、發生平台合併、收購、業務轉讓等情形，承接主體將繼續受本隱私政策約束，若數據處理規則發生重大變更，平台將提前公示告知您。",
    "7、用户存在违反中华人民共和国法律法规、平台协议及平台规则的行为；": "7、用戶存在違反中華人民共和國法律法規、平台協議及平台規則的行為；",
    "8、为保护 Taoify、其关联主体、平台其他用户及终端消费者的合法权益。": "8、為保護 Taoify、其關聯主體、平台其他用戶及終端消費者的合法權益。",
    "六、争议解决": "六、爭議解決",
    "1、平台有关条款（包括但不限于本用户隐私政策等）可能会有除中文以外的其他版本。如果不同语言版本的用户隐私政策之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本用户隐私政策条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本用户隐私政策，予以明确排除。": "1、平台有關條款（包括但不限於本用戶隱私政策等）可能會有除中文以外的其他版本。如果不同語言版本的用戶隱私政策之間存在任何差異、不一致或歧義，均以中文文本為準，其他文本僅作參考，不得用於抵觸或變更中文文本的含義。本用戶隱私政策條款的訂立、效力、解釋、履行及爭議解決，均以中華人民共和國法律作為準據法，排除境外法律衝突規則。《聯合國國際貨物銷售合同公約》不應用於本用戶隱私政策，予以明確排除。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本政策更新日期：2026年1月1日。": "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）運營，聯繫郵箱：liutaotao@taocarts.com，微信號：zzsist666。本政策更新日期：2026年1月1日。",
    "Taoify 服务条款": "Taoify 服務條款",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 服务条款》（以下简称\"本服务条款\"），重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本服务条款约束。": "提示：您如需註冊或使用 Taoify 平台服務，應當完整閱讀並嚴格遵守《Taoify 服務條款》（以下簡稱\"本服務條款\"），重點關注免責聲明、責任限制、違規處置等內容，明確自身權利、義務、使用規則及違約責任。平台後續上線的全部新功能、新工具，均受本服務條款約束。",
    "Taoify有权不定期更新、修改本服务条款里的内容，有权在 Taoify 网站上发布更新和修改更新本服务条款。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify 有權不定期更新、修改本服務條款裡的內容，有權在 Taoify 網站上發布更新和修改更新本服務條款。最新版本將統一公示於商城處，請您定期查閱條款更新內容。若您不認可條款修訂內容，須立即停止使用平台全部服務。",
    "您完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify用户隐私政策》。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "您完成賬戶註冊，即代表您已充分知曉並自願接受Taoify 平台所有協議、條款，包括《Taoify 用戶使用協議》《Taoify用戶隱私政策》。若您不認可Taoify 平台所有協議、條款內容，請立即停止註冊。",
    "一、定义": "一、定義",
    "1、服务：Taoify 为您提供独立站搭建、店铺管理、订单收款、配套工具等建站经营服务，用于商户面向境外消费者销售商品、提供服务。": "1、服務：Taoify 為您提供獨立站搭建、店鋪管理、訂單收款、配套工具等建站經營服務，用於商戶面向境外消費者銷售商品、提供服務。",
    "2、用户或您：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织，包括但不限于商店所有者及\"员工账户\"下的用户。": "2、用戶或您：指完成 Taoify 平台註冊，並使用平台各項服務的自然人、法人及其他組織，包括但不限於商店所有者及\"員工賬戶\"下的用戶。",
    "3、平台：指Taoify 运营企业及平台软硬件系统、网站、服务端口等整体服务载体。": "3、平台：指Taoify 運營企業及平台軟硬體系統、網站、服務端口等整體服務載體。",
    "二、通用运营规则": "二、通用運營規則",
    "1、Taoify 服务相关的技术支持仅对已完成注册的有效商户开放。": "1、Taoify 服務相關的技術支持僅對已完成註冊的有效商戶開放。",
    "2、因法律法规调整、服务优化、平台运营调整等，我方有权修订、增补本服务条款、用户使用协议、隐私政策等全部 Taoify 平台规则，亦有权调整或关停平台服务、终止您账户；服务终止不影响终止日前双方已产生的各项权利与义务。": "2、因法律法規調整、服務優化、平台運營調整等，我方有權修訂、增補本服務條款、用戶使用協議、隱私政策等全部 Taoify 平台規則，亦有權調整或關停平台服務、終止您賬戶；服務終止不影響終止日前雙方已產生的各項權利與義務。",
    "3、您认可并同意 Taoify 可以通过在商城发布相关的修正或新增的任何条款，修订提前1个工作日在平台公示，资费调整提前1个月公示，在网站公示后的七（7）日公示期后生效。如果您在公示期间没有提出异议或在生效日后继续使用服务即表示您同意并接受此修订版。": "3、您認可並同意 Taoify 可以通過在商城發布相關的修正或新增的任何條款，修訂提前1個工作日在平台公示，資費調整提前1個月公示，在網站公示後的七（7）日公示期後生效。如果您在公示期間沒有提出異議或在生效日後繼續使用服務即表示您同意並接受此修訂版。",
    "4、您不得将服务用于任何非法目的，您在使用本服务期间须严格遵守经营所在地、客户所在地及中华人民共和国全部现行法律法规（包括但不限于版权相关法律）。": "4、您不得將服務用於任何非法目的，您在使用本服務期間須嚴格遵守經營所在地、客戶所在地及中華人民共和國全部現行法律法規（包括但不限於版權相關法律）。",
    "5、您须对本人名下 API 证书的使用行为承担全部责任，并妥善保管 API 证书，保障其使用安全。": "5、您須對本人名下 API 證書的使用行為承擔全部責任，並妥善保管 API 證書，保障其使用安全。",
    "6、未经 Taoify 书面许可，您不得对Taoify 平台、服务的任何部分进行任何形式的再生产、修改、编辑、破解、反编译、反向工程、拆解、改编、衍生开发等操作；不得修改源代码、默认模板、自带文档、功能模块、接口程序等与系统相关的任何内容；不得复制、销售、转售或以此牟利。": "6、未經 Taoify 書面許可，您不得對Taoify 平台、服務的任何部分進行任何形式的再生產、修改、編輯、破解、反編譯、反向工程、拆解、改編、衍生開發等操作；不得修改源代碼、默認模板、自帶文檔、功能模塊、接口程序等與系統相關的任何內容；不得複製、銷售、轉售或以此牟利。",
    "7、您不得注册、购买或使用包含 Taoify、Taoify 商标，以及该商标衍生变体、近似错拼词汇的域名；亦不得将前述相关词汇用于搜索引擎推广或其他按点击付费广告（如谷歌广告）。": "7、您不得註冊、購買或使用包含 Taoify、Taoify 商標，以及該商標衍生變體、近似錯拼詞彙的域名；亦不得將前述相關詞彙用於搜索引擎推廣或其他按點擊付費廣告（如谷歌廣告）。",
    "8、有关本服务条款的任何问题，请发邮件到 liutaotao@taocarts.com。": "8、有關本服務條款的任何問題，請發郵件到 liutaotao@taocarts.com。",
    "9、您知晓您的资料（不包括信用卡信息）可能未经加密转移，并涉及通过各种网络传输。": "9、您知曉您的資料（不包括信用卡信息）可能未經加密轉移，並涉及通過各種網絡傳輸。",
    "10、平台有关条款（包括但不限于本服务条款等）可能会有除中文以外的其他版本。如果不同语言版本的服务条款之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本服务条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本服务条款，予以明确排除。": "10、平台有關條款（包括但不限於本服務條款等）可能會有除中文以外的其他版本。如果不同語言版本的服務條款之間存在任何差異、不一致或歧義，均以中文文本為準，其他文本僅作參考，不得用於抵觸或變更中文文本的含義。本服務條款的訂立、效力、解釋、履行及爭議解決，均以中華人民共和國法律作為準據法，排除境外法律衝突規則。《聯合國國際貨物銷售合同公約》不應用於本服務條款，予以明確排除。",
    "11、本服务条款对双方、双方各自的继承人、权利义务承继人、合法受让方及法定代表人均具备约束力。Taoify 可无需向您发出通知、亦无需取得您同意，自行转让本服务条款项下全部权利义务。未经 Taoify 事先书面许可，您不得将本服务条款，或您在本协议项下享有的任何权利、承担的任何义务转让、变相转移予任何第三方。": "11、本服務條款對雙方、雙方各自的繼承人、權利義務承繼人、合法受讓方及法定代表人均具備約束力。Taoify 可無需向您發出通知、亦無需取得您同意，自行轉讓本服務條款項下全部權利義務。未經 Taoify 事先書面許可，您不得將本服務條款，或您在本協議項下享有的任何權利、承擔的任何義務轉讓、變相轉移予任何第三方。",
    "12、若因任何事由致使本服务条款任一完整条款或条款部分内容无效，仅该条款或对应部分丧失效力，其余所有条款效力不受影响。": "12、若因任何事由致使本服務條款任一完整條款或條款部分內容無效，僅該條款或對應部分喪失效力，其餘所有條款效力不受影響。",
    "13、无论您申请注销账号、还是平台因违规终止合作，本服务条款商业秘密保护约定、权责划分与损失赔偿规则、第三方服务风险兜底、知识产权相关约定、争议管辖与法律适用、费用结算、侵权赔付、数据合规相关全部条款仍具备法律效力，不受服务终止影响。": "13、無論您申請註銷賬號、還是平台因違規終止合作，本服務條款商業秘密保護約定、權責劃分與損失賠償規則、第三方服務風險兜底、知識產權相關約定、爭議管轄與法律適用、費用結算、侵權賠付、數據合規相關全部條款仍具備法律效力，不受服務終止影響。",
    "三、账户管理规范": "三、賬戶管理規範",
    "1、您注册 Taoify 账号时必须提供合法完整姓名、现地址、电话号码、有效的电子邮件地址以及其他所需的任何信息。Taoify 有权基于任何理由拒绝您的账号申请或注销现有账户。": "1、您註冊 Taoify 賬號時必須提供合法完整姓名、現地址、電話號碼、有效的電子郵件地址以及其他所需的任何信息。Taoify 有權基於任何理由拒絕您的賬號申請或註銷現有賬戶。",
    "2、您必须年满18岁或达到您使用本服务所在地或经营所在地的法定成年的年龄。": "2、您必須年滿18歲或達到您使用本服務所在地或經營所在地的法定成年的年齡。",
    "3、您承诺是为经营之商业目的使用Taoify 服务，不得将账号、店铺用于个人日常消费、家庭自用等非经营场景。": "3、您承諾是為經營之商業目的使用Taoify 服務，不得將帳號、店鋪用於個人日常消費、家庭自用等非經營場景。",
    "4、店铺的创建与运营过程中的全部负责由您自行承担。": "4、店鋪的創建與運營過程中的全部責任由您自行承擔。",
    "5、Taoify 仅提供独立站建站技术工具，不介入您与第三方之间的订单、售后、货款往来，您与第三方进行的直接交易，相关纠纷均与 Taoify 无关，我方不承担任何调解、赔付责任。": "5、Taoify 僅提供獨立站建站技術工具，不介入您與第三方之間的訂單、售後、貨款往來，您與第三方進行的直接交易，相關糾紛均與 Taoify 無關，我方不承擔任何調解、賠付責任。",
    "6、您对账户内所有操作行为，以及账户内上传、收集、生成、存储、展示、分发、传输的全部内容（包括图片、视频、图文素材、音频、代码、信息、数据等）承担全部责任。": "6、您對帳號內所有操作行為，以及帳號內上傳、收集、生成、存儲、展示、分發、傳輸的全部內容（包括圖片、視頻、圖文素材、音頻、代碼、信息、數據等）承擔全部責任。",
    "7、若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "7、若因用戶違反本協議約定，導致平台被第三方索賠、起訴、仲裁，或被行政機關處以罰款、責令賠付，全部責任均由用戶獨立承擔。用戶須向平台足額賠付平台由此產生的全部直接損失與間接損失，損失範圍包括但不限於：平台向第三方支付的賠償金、和解金、補償金、違約金；行政機關、司法機關收取的罰款、滯納金、訴訟費、仲裁費、保全費、執行費、鑒定費、評估費；平台為維權支出的律師費、公證費、調查取證費、差旅費、擔保費；平台商譽受損損失、業務中斷損失、可得利益損失、第三方追責產生的額外賠付等一切相關費用。",
    "四、账户管理": "四、帳戶管理",
    "1、Taoify 账户商店所有者": "1、Taoify 帳戶商店所有者",
    "1.1 完成注册服务的用户将是商店所有者，并且将被授权使用我方提供给商店所有者的相关服务。您需保证营业执照、行政许可、审批、备案、资质等注册资料，在店铺页面清晰公示，供监管部门、消费者核验。": "1.1 完成註冊服務的用戶將是商店所有者，並且將被授權使用我方提供給商店所有者的相關服務。您需保證營業執照、行政許可、審批、備案、資質等註冊資料，在店鋪頁面清晰公示，供監管部門、消費者核驗。",
    "1.2 若您代表第三方注册本服务，则第三方为商店所有者。您必须使用第三方名下或者指定的邮箱完成注册，同时声明并保证已取得第三方合法书面授权且有效，提交授权许可手续，明确已授权范围，包括但不限于授权注册、日常登录、授权认可并自愿接受Taoify 平台所有协议、条款等。": "1.2 若您代表第三方註冊本服務，則第三方為商店所有者。您必須使用第三方名下或者指定的郵箱完成註冊，同時聲明並保證已取得第三方合法書面授權且有效，提交授權許可手續，明確已授權範圍，包括但不限於授權註冊、日常登錄、授權認可並自願接受Taoify 平台所有協議、條款等。",
    "1.3 注册账户后，若您需在店铺内上架、展示、销售第三方品牌商品或服务，您须提前向平台提交品牌授权书、经销许可、使用许可等合法有效手续，并保证相关授权、许可持续有效。未按要求提供手续或授权失效的，平台有权下架对应商品、暂停服务直至终止账户，由此产生的全部法律责任与损失由您自行承担。": "1.3 註冊帳戶後，若您需在店鋪內上架、展示、銷售第三方品牌商品或服務，您須提前向平台提交品牌授權書、經銷許可、使用許可等合法有效手續，並保證相關授權、許可持續有效。未按要求提供手續或授權失效的，平台有權下架對應商品、暫停服務直至終止帳戶，由此產生的全部法律責任與損失由您自行承擔。",
    "1.4 一个 Taoify 商店只能有一名商店所有者，一名商店所有者可以有多家 Taoify 商店。\"商店\"表示与账户相关联的在线商店或者实体零售地点。": "1.4 一個 Taoify 商店只能有一名商店所有者，一名商店所有者可以有多家 Taoify 商店。\"商店\"表示與帳戶相關聯的線上商店或者實體零售地點。",
    "2、员工账户": "2、員工帳戶",
    "2.1 根据您订阅的 Taoify 套餐，您可以创建一个或多个员工账户，商店所有者必须设置权限，限制员工账户对业务数据、店铺功能的访问范围（例如限制查看销售报表、禁止修改店铺基础设置等）。": "2.1 根據您訂閱的 Taoify 套餐，您可以創建一個或多個員工帳戶，商店所有者必須設置權限，限制員工帳戶對業務數據、店鋪功能的訪問範圍（例如限制查看銷售報表、禁止修改店鋪基礎設置等）。",
    "2.2 凡使用本平台为门店开立的员工账号所实施的全部行为，由此产生的一切法律责任、经济损失及相应后果，均由商店所有者承担；前述员工账号操作行为，视同商店所有者作出的行为。": "2.2 凡使用本平台為門店開立的員工帳號所實施的全部行為，由此產生的一切法律責任、經濟損失及相應後果，均由商店所有者承擔；前述員工帳號操作行為，視同商店所有者作出的行為。",
    "3、收款结算账户": "3、收款結算帳戶",
    "3.1 注册成功后，Taoify 将提供多家支付服务商供您进行选择。您可以从中选择收取顾客款项的渠道。": "3.1 註冊成功後，Taoify 將提供多家支付服務商供您進行選擇。您可以從中選擇收取顧客款項的渠道。",
    "3.2 您须自行负责注册、激活及维护收款账户，自行承担收款账户需承担费用。如果您不再需要这些收款账户，您须自行关停账户。支付服务商属于本服务条款中的第三方服务。": "3.2 您須自行負責註冊、激活及維護收款帳戶，自行承擔收款帳戶需承擔費用。如果您不再需要這些收款帳戶，您須自行關停帳戶。支付服務商屬於本服務條款中的第三方服務。",
    "3.3 您在店铺内使用收款账户，即视为您同意遵守对应支付服务商的服务条款与规则；支付服务商可随时修订条款，修订内容一经公示即刻生效。若您在条款修订公示完成后，继续使用店铺收款账户开展业务操作，即代表您认可并完全接受修订后的全部条款内容。若您不认可条款变更，须立即注销收款账户，并停止使用该支付服务。": "3.3 您在店鋪內使用收款帳戶，即視為您同意遵守對應支付服務商的服務條款與規則；支付服務商可隨時修訂條款，修訂內容一經公示即刻生效。若您在條款修訂公示完成後，繼續使用店鋪收款帳戶開展業務操作，即代表您認可並完全接受修訂後的全部條款內容。若您不認可條款變更，須立即註銷收款帳戶，並停止使用該支付服務。",
    "五、Taoify权利": "五、Taoify權利",
    "1、我方保留随时修改、暂停、终止全部或部分平台服务的权利，且无需提前通知用户。部分服务、功能并非在所有国家/地区使用，我方无义务在任意区域提供指定服务。": "1、我方保留隨時修改、暫停、終止全部或部分平台服務之權利，且無需提前通知用戶。部分服務、功能並非在所有國家/地區使用，我方無義務在任意區域提供指定服務。",
    "2、Taoify 拥有自主选择权，保留拒绝向任意主体提供平台服务的权利。": "2、Taoify 擁有自主選擇權，保留拒絕向任意主體提供平台服務之權利。",
    "3、如果我方判定店铺提供的商品或服务或者发布到店铺的资料违反了 Taoify 的协议，包括但不限于《Taoify 用户使用协议》《Taoify用户隐私政策》、本服务条款等，我方有权要求整改、删除违规内容、暂停或永久终止全部服务，用户已缴纳的所有费用不予退还。": "3、如果我方判定店鋪提供的商品或服務或者發布到店鋪的資料違反了 Taoify 的協議，包括但不限於《Taoify 用戶使用協議》《Taoify用戶隱私政策》、本服務條款等，我方有權要求整改、刪除違規內容、暫停或永久終止全部服務，用戶已繳納的所有費用不予退還。",
    "4、凡以口头、书面其他任何形式辱骂 Taoify 客户、员工、工作人员，或打击报复类威胁言论的，其账户将被立即永久终止使用，用户已缴纳的所有费用不予退还。": "4、凡以口頭、書面其他任何形式辱罵 Taoify 客戶、員工、工作人員，或打擊報復類威脅言論的，其賬戶將被立即永久終止使用，用戶已繳納的所有費用不予退還。",
    "5、平台内容由您负责、承担责任，Taoify 不预先审核用户发布内容，我方有权自行裁量，单方拒绝展示或删除平台内任意内容，Taoify 无提前告知义务。": "5、平台內容由您負責、承擔責任，Taoify 不預先審核用戶發布內容，我方有權自行裁量，單方拒絕展示或刪除平台內任意內容，Taoify 無提前告知義務。",
    "6、Taoify 可向您的同业竞争者提供服务，不向任何用户授予细分市场独家合作权益。您确认并同意，Taoify 的合作方及员工均有可能成为 Taoify 平台客户或入驻，前述主体可能与您开展同业竞争，但严禁擅自使用您保密信息。": "6、Taoify 可向您的同業競爭者提供服務，不向任何用戶授予細分市場獨家合作權益。您確認並同意，Taoify 的合作方及員工均有可能成為 Taoify 平台客戶或入駐，前述主體可能與您開展同業競爭，但嚴禁擅自使用您保密信息。",
    "7、若就商店所有者权属产生争议，我方有权要求相关方提交权属证明文件，包括但不限于营业执照扫描件、政府机关核发的有效身份证件、信用卡后四位卡号、在职证明等资料。": "7、若就商店所有者權屬產生爭議，我方有權要求相關方提交權屬證明文件，包括但不限於營業執照掃描件、政府機關核發的有效身份證件、信用卡後四位卡號、在職證明等資料。",
    "8、依据现有材料，我方有权判定账户的商店所有者，并有权根据我方的单方判断将账户转让给商店所有者，若您有异议，请及时提出转让异议。如果我方无法判定账户合法所有者或者收到转让异议，Taoify 有权临时冻结该账户，直至争端双方直至争议各方达成纠纷解决方案。": "8、依據現有材料，我方有權判定賬戶的商店所有者，並有權根據我方的單方判斷將賬戶轉讓給商店所有者，若您有異議，請及時提出轉讓異議。如果我方無法判定賬戶合法所有者或者收到轉讓異議，Taoify 有權臨時凍結該賬戶，直至爭端雙方直至爭議各方達成糾紛解決方案。",
    "9、Taoify平台无需就您遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "9、Taoify平台無需就您遭受的任何直接損失、間接損失、商譽損失、預期收益損失、經營利潤損失等承擔任何賠償責任。",
    "10、若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "10、若存在法定或其他 Taoify 應當承擔賠償責任的情形，Taoify 對用戶的全部累計賠償責任（含違約金、賠償金、維權支出）最高限額為：損失事件發生對應服務周期內，您實際向 Taoify 支付的服務費總金額。無論索賠事由多少、損失金額高低，合計賠付總額不得突破該上限。",
    "六、责任限制": "六、責任限制",
    "1、您保证符合合法经营资质（包括但不限于营业执照、行政审批等）、保证商品质量合格、保证图文与实际物品规则、质量、功能等一致，不存在虚假宣传、不正当竞争等；": "1、您保證符合合法經營資質（包括但不限於營業執照、行政審批等）、保證商品質量合格、保證圖文與實際物品規則、質量、功能等一致，不存在虛假宣傳、不正當競爭等；",
    "2、在现行法律允许的最大范围内，因平台服务无法使用、系统故障产生的各类经营损失，平台及服务商均无需承担赔偿，包括经营收入减少、客户流失、品牌口碑受损、数据丢失、预期收益下滑等各类直接、间接经济损耗与衍生损失。": "2、在現行法律允許的最大範圍內，因平台服務無法使用、系統故障產生的各類經營損失，平台及服務商均無需承擔賠償，包括經營收入減少、客戶流失、品牌口碑受損、數據丟失、預期收益下滑等各類直接、間接經濟損耗與衍生損失。",
    "3、若您存在违反本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》、违反法律法规或侵害第三方合法权益的行为，您须保障 Taoify及其关联主体、合作方、员工及供应商免受一切索赔追责，并须全额赔付 Taoify 及其关联方、合作方、员工、供应商遭受的全部损失、诉讼费、律师费。": "3、若您存在違反本服務條款及《Taoify 用戶使用協議》《Taoify用戶隱私政策》、違反法律法規或侵害第三方合法權益的行為，您須保障 Taoify及其關聯主體、合作方、員工及供應商免受一切索賠追責，並須全額賠付 Taoify 及其關聯方、合作方、員工、供應商遭受的全部損失、訴訟費、律師費。",
    "4、您使用本服务需要自担风险。平台以\"现状\"提供服务，不作出任何书面、口头经营收益、系统稳定类承诺。": "4、您使用本服務需要自擔風險。平台以\"現狀\"提供服務，不作出任何書面、口頭經營收益、系統穩定類承諾。",
    "5、Taoify 不保证服务及时、安全、零差错、不间断运行。": "5、Taoify 不保證服務及時、安全、零差錯、不中斷運行。",
    "6、Taoify 不保证使用本服务所输出、取得的结果具备准确性与可靠性。": "6、Taoify 不保證使用本服務所輸出、取得的結果具備準確性與可靠性。",
    "7、因您使用本服务产生的全部税费缴纳义务，均由您自行承担并缴纳，Taoify 不承担任何相关责任。": "7、因您使用本服務產生的全部稅費繳納義務，均由您自行承擔並繳納，Taoify 不承擔任何相關責任。",
    "8、Taoify 不保证平台产品、服务、信息符合您的预期，亦无义务修复服务内全部漏洞、差错。": "8、Taoify 不保證平台產品、服務、信息符合您的預期，亦無義務修復服務內全部漏洞、差錯。",
    "七、知识产权约定": "七、知識產權約定",
    "1、您上传至 Taoify 服务平台的图片、文案、商标、素材知识产权、所有权归您所有，您须保证上传图片、文案、商标、素材不侵犯任何第三人知识产权等权益，须确保前述内容符合全部法律法规。您可随时注销账户，同步清除其 Taoify 店铺内全部相关素材，清除后即无法恢复。": "1、您上傳至 Taoify 服務平台的圖片、文案、商標、素材知識產權、所有權歸您所有，您須保證上傳圖片、文案、商標、素材不侵犯任何第三人知識產權等權益，須確保前述內容符合全部法律法規。您可隨時註銷賬戶，同步清除其 Taoify 店鋪內全部相關素材，清除後即無法恢復。",
    "2、您上传内容即视为同意下述约定：2.1 允许其他主体免费查阅您上传至 Taoify 店铺的全部内容；2.2 就您公开发布的内容，授予 Taoify 存储、免费展示及免费使用该等内容；2.3 Taoify 有权核查、删除您上传至本平台服务的任意内容，但并无开展前述操作的强制性义务。2.4 Taoify可免费使用与您店铺相关的商号、注册商标、服务标识及品牌标识，用于推广、宣传 Taoify 平台服务。": "2、您上傳內容即視為同意下述約定：2.1 允許其他主體免費查閱您上傳至 Taoify 店鋪的全部內容；2.2 就您公開發布的內容，授予 Taoify 存儲、免費展示及免費使用該等內容；2.3 Taoify 有權核查、刪除您上傳至本平台服務的任意內容，但並無開展前述操作的強制性義務。2.4 Taoify 可免費使用與您店鋪相關的商號、註冊商標、服務標識及品牌標識，用於推廣、宣傳 Taoify 平台服務。",
    "3、平台系统、程序（包括但不限于源代码、框架、设计、文档）、界面、官方文档等所有知识产权归平台所有，未经书面授权不得复制、传播、二次开发。": "3、平台系統、程序（包括但不限於源代碼、框架、設計、文檔）、界面、官方文檔等所有知識產權歸平台所有，未經書面授權不得複製、傳播、二次開發。",
    "八、商品发货与物流规则": "八、商品發貨與物流規則",
    "对于您Taoify商铺所售出的商品，您可以在发货时选择联系第三方承运商提供商处购买运输标签。商品发货、物流运输相关事宜、费用、风险均由您自行负责，Taoify不承担任何责任。": "對於您Taoify商鋪所售出的商品，您可以在發貨時選擇聯繫第三方承運商提供商處購買運輸標籤。商品發貨、物流運輸相關事宜、費用、風險均由您自行負責，Taoify不承擔任何責任。",
    "九、商店主题规范": "九、商店主題規範",
    "1、平台提供的店铺模板页面可展示平台官方标识；如模板内页面内容违反平台各项管理规则，平台有权单方面调整页面内容，无义务提前通知商家，但平台无开展前述操作的强制性义务。": "1、平台提供的店鋪模板頁面可展示平台官方標識；如模板內頁面內容違反平台各項管理規則，平台有權單方面調整頁面內容，無義務提前通知商家，但平台無開展前述操作的強制性義務。",
    "2、平台主题模版的知识产权仍属于设计者。您仅可在授权范围内使用；若超出授权范围使用，设计者可依法追责，平台亦有权修改店铺内容或关停账户，不利后果由您承担，Taoify 不承担任何责任。": "2、平台主題模版的知識產權仍屬於設計者。您僅可在授權範圍內使用；若超出授權範圍使用，設計者可依法追責，平台亦有權修改店鋪內容或關停賬戶，不利後果由您承擔，Taoify 不承擔任何責任。",
    "3、技术支持工作由设计者负责，Taoify 不承担提供此类支持的责任，但 Taoify 可帮助您联系设计者。": "3、技術支持工作由設計者負責，Taoify 不承擔提供此類支持的責任，但 Taoify 可幫助您聯繫設計者。",
    "4、您安装新模板时，必须自行做好数据备份，Taoify 无备份义务。因安装模板导致原有主题、界面、数据等内容损坏的，Taoify 不承担赔偿责任。": "4、您安裝新模板時，必須自行做好數據備份，Taoify 無備份義務。因安裝模板導致原有主題、界面、數據等內容損壞的，Taoify 不承擔賠償責任。",
    "十、费用支付规则": "十、費用支付規則",
    "1、您必须向我方提供有效可用的支付方式，以避免扣款失败影响店铺使用。建议您绑定多张信用卡并授权使用自动支付。账单支付的技术由第三方专业金融公司提供技术支持。": "1、您必須向我方提供有效可用的支付方式，以避免扣款失敗影響店鋪使用。建議您綁定多張信用卡並授權使用自動支付。賬單支付的技術由第三方專業金融公司提供技術支持。",
    "5、订阅费用采用预付制，系统将在服务到期前5个自然日自动发起续费扣款。例：服务到期时间为2022-01-06 23:59:59，则预计续费扣费时间为2022-01-01 23:59:59。": "5、訂閱費用採用預付制，系統將在服務到期前5個自然日自動發起續費扣款。例：服務到期時間為2022-01-06 23:59:59，則預計續費扣費時間為2022-01-01 23:59:59。",
    "6、我方提前30日发出服务费用变更通知后即可调整服务收费标准，我方可通过平台官网公告或您店铺后台管理页面公示的方式送达该通知。": "6、我方提前30日發出服務費用變更通知後即可調整服務收費標準，我方可通過平台官網公告或您店鋪後台管理頁面公示的方式送達該通知。",
    "7、我方不会就关于服务的任何修改、价格变动、暂停或终止对您或任何第三方承担任何责任。": "7、我方不會就關於服務的任何修改、價格變動、暫停或終止對您或任何第三方承擔任何責任。",
    "8、若我方无法通过授权银行卡成功扣取订阅费用，将向您所有者发送邮件告知扣款失败，并提示更新支付银行卡。我方每间隔24小时重复发起扣费，总计最多三次扣款尝试（含首次扣款）。第三次扣款仍失败的，我方有权暂停并限制您账户使用权限。您缴清全部未结清款项及下一计费周期订阅费用后，账户方可恢复正常访问权限。": "8、若我方無法通過授權銀行卡成功扣取訂閱費用，將向您所有者發送郵件告知扣款失敗，並提示更新支付銀行卡。我方每隔24小時重複發起扣費，總計最多三次扣款嘗試（含首次扣款）。第三次扣款仍失敗的，我方有權暫停並限制您賬戶使用權限。您繳清全部未結清款項及下一計費周期訂閱費用後，賬戶方可恢復正常訪問權限。",
    "9、服务期限届满前您未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "9、服務期限屆滿前您未及時續訂閱費用的，服務自動終止；服務關閉滿10日用戶仍未續訂閱費用的，Taoify 平台有權刪除網站全部數據，相關損失由用戶自行承擔。",
    "10、Taoify 自行收取的平台服务费不包含各类政府征收的税金、规费及其他收费（本服务条款中统称为\"税费\"）。除平台服务费外，您因订阅、采购 Taoify 产品与服务产生的全部适用税费，均由您自行承担。税费将依据您提供的账单地址适用税率核算，并从您授权支付卡自动扣取。若您具备免税资格，须向我方提交有效免税凭证；部分司法辖区要求提供能够证实免税资质、符合当地法规的官方证明文件，免税政策自材料审核通过之日起生效。若 Taoify 未代为计收相关税费，您必须自行判断自身纳税义务，由您向税务主管机关完成申报缴纳税款。": "10、Taoify 自行收取的平台服務費不包含各類政府徵收的稅金、規費及其他收費（本服務條款中統稱為\"稅費\"）。除平台服務費外，您因訂閱、採購 Taoify 產品與服務產生的全部適用稅費，均由您自行承擔。稅費將依據您提供的賬單地址適用稅率核算，並從您授權支付卡自動扣取。若您具備免稅資格，須向我方提交有效免稅憑證；部分司法管轄區要求提供能夠證實免稅資質、符合當地法規的官方證明文件，免稅政策自材料審核通過之日起生效。若 Taoify 未代為計收相關稅費，您必須自行判斷自身納稅義務，由您向稅務主管機關完成申報繳納稅款。",
    "11、除 Taoify 代为收取并上缴主管税务机关的税费外，法律法规规定的各类税款扣除、预提代缴义务均由您自行承担，并由您单独向对应税务机关完成缴纳。无论是否存在前述税款扣除或预提要求，Taoify 均有权按照本服务条款约定，从您授权支付卡扣收全部应付费用，但Taoify无主动扣费义务。": "11、除 Taoify 代為收取並上繳主管稅務機關的稅費外，法律法規規定的各類稅款扣除、預提代繳義務均由您自行承擔，並由您單獨向對應稅務機關完成繳納。無論是否存在前述稅款扣除或預提要求，Taoify 均有權按照本服務條款約定，從您授權支付卡扣收全部應付費用，但Taoify無主動扣費義務。",
    "12、您店铺经营销售行为产生的全部适用税费，均由您自行承担并依法缴纳。": "12、您店鋪經營銷售行為產生的全部適用稅費，均由您自行承擔並依法繳納。",
    "十一、保证金支付": "十一、保證金支付",
    "1、您完成 Taoify 账户注册时，须一次性足额缴纳经营保证金1000元。": "1、當您完成 Taoify 帳戶註冊時，須一次性足額繳納經營保證金1000元。",
    "2、保证金仅用于担保您履行本服务条款及《Taoify 用户使用协议》《Taoify用户隐私政策》等全部 Taoify 平台规则、全部义务，不能抵扣服务费用、税费。": "2、保證金僅用於擔保您履行本服務條款及《Taoify 用戶使用協議》《Taoify用戶隱私政策》等全部 Taoify 平台規則、全部義務，不能抵扣服務費用、稅費。",
    "3、若您出现商品质量违规、虚假宣传、侵害消费者权益、侵权、行政处罚、违约欠款、第三方索赔、产生赔付款项、依据平台规则须向我方赔偿等情形，您同意我方有权直接从您已缴纳的保证金中抵扣对应赔偿金、罚款、欠款、维权支出、律师费、诉讼费等全部应付费用。保证金经抵扣后余额不足约定标准金额的，您须在我方发出补缴通知后3个自然日内补足差额，恢复保证金足额标准；逾期未足额补缴的，Taoify 有权暂停店铺全部经营功能、限制账户操作，直至保证金足额补齐。": "3、若您出現商品質量違規、虛假宣傳、侵害消費者權益、侵權、行政處罰、違約欠款、第三方索賠、產生賠付款項、依據平台規則須向我方賠償等情形，您同意我方有權直接從您已繳納的保證金中抵扣對應賠償金、罰款、欠款、維權支出、律師費、訴訟費等全部應付費用。保證金經抵扣後餘額不足約定標準金額的，您須在我方發出補繳通知後3個自然日內補足差額，恢復保證金足額標準；逾期未足額補繳的，Taoify 有權暫停店鋪全部經營功能、限制帳戶操作，直至保證金足額補齊。",
    "4、在您主动申请注销账户、结清全部欠款、无未了结客诉、质量纠纷、行政处罚、侵权索赔后，我方将无息退还剩余保证金。存在未结清赔付、纠纷、处罚的，平台有权扣除对应款项后再无息退还剩余部分，不足部分平台保留向您追偿的权利。保证金不产生任何利息，我方无义务为保证金支付利息。": "4、在您主動申請註銷帳戶、結清全部欠款、無未了結客訴、質量糾紛、行政處罰、侵權索賠後，我方將無息退還剩餘保證金。存在未結清賠付、糾紛、處罰的，平台有權扣除對應款項後再無息退還剩餘部分，不足部分平台保留向您追償的權利。保證金不產生任何利息，我方無義務為保證金支付利息。",
    "十二、账户注销与服务终止": "十二、帳戶註銷與服務終止",
    "1、服务期内您主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "1、服務期內您主動申請終止服務的，需提前一個月書面通知 Taoify 平台，已繳納費用不予退還；用戶擅自終止協議造成 Taoify 平台損失的，須予以賠償，包括但不限於直接損失、間接損失、律師費等。",
    "2、您在暂停使用、注销账户或终止服务前，须自行备份留存账户内全部数据，Taoify 无义务保管您账户相关数据资料。": "2、您在暫停使用、註銷帳戶或終止服務前，須自行備份留存帳戶內全部數據，Taoify 無義務保管您帳戶相關數據資料。",
    "3、无论因何种事由任意一方终止本服务，Taoify 将即刻停止提供服务，您亦无法继续登录使用账户。除本服务条款另有约定外，您已缴纳费用不再退还。您因使用平台服务所欠付 Taoify 的全部款项立即届至清偿期，须一次性全额付清，同时您的 Taoify 店铺将被关停下架。": "3、無論因何種事由任意一方終止本服務，Taoify 將即刻停止提供服務，您亦無法繼續登錄使用帳戶。除本服務條款另有約定外，您已繳納費用不再退還。您因使用平台服務所欠付 Taoify 的全部款項立即屆至清償期，須一次性全額付清，同時您的 Taoify 店鋪將被關停下架。",
    "4、服务终止后，与域名相关的全部事宜由您自行对接域名服务商处理。": "4、服務終止後，與域名相關的全部事宜由您自行對接域名服務商處理。",
    "5、服务终止当日，若您存在未结清款项，我方将通过邮件向您发送最终账单，我方不再另行收取任何费用，也不再提供任何服务。": "5、服務終止當日，若您存在未結清款項，我方將通過郵件向您發送最終帳單，我方不再另行收取任何費用，也不再提供任何服務。",
    "6、服务无论因何种原因终止，您须自行完整留存店铺经营全部资料（包括但不限于订单记录、商品资质、购销合同、品牌授权、物流凭证、客户交易台账、质检报告等）并自行备案存档，我方无义务代为保管、整理、备案任何资料。": "6、服務無論因何種原因終止，您須自行完整留存店鋪經營全部資料（包括但不限於訂單記錄、商品資質、購銷合同、品牌授權、物流憑證、客戶交易臺賬、質檢報告等）並自行備案存檔，我方無義務代為保管、整理、備案任何資料。",
    "7、即便服务终止，若您销售的商品、提供的服务存在质量缺陷、侵权、售后纠纷、行政处罚、消费者索赔等全部问题，相关法律责任、赔偿责任、整改义务仍全部由您独立承担，我方不承担任何责任。": "7、即便服務終止，若您銷售的商品、提供的服務存在質量缺陷、侵權、售後糾紛、行政處罰、消費者索賠等全部問題，相關法律責任、賠償責任、整改義務仍全部由您獨立承擔，我方不承擔任何責任。",
    "8、如果我方怀疑您涉嫌任何欺诈行为（通过判决、和解、保险、托管调查或其他方式），我方有权暂停或终止您的账户，且我方可采取任何其他补救措施。": "8、如果我方懷疑您涉嫌任何詐欺行為（通過判決、和解、保險、託管調查或其他方式），我方有權暫停或終止您的帳戶，且我方可採取任何其他補救措施。",
    "十三、第三方工具、支付服务商规则": "十三、第三方工具、支付服務商規則",
    "1、Taoify可提供并开放第三方软件、应用程序、产品、服务接口及网站链接（前述统称\"第三方服务\"，下同），您自主选择开通使用，您与第三方服务商形成独立合作关系，平台不参与双方权利义务约定，不对第三方产品做背书或质量担保，不存在联营、隶属合作关系。": "1、Taoify可提供並開放第三方軟體、應用程式、產品、服務接口及網站連結（前述統稱\"第三方服務\"，下同），您自主選擇開通使用，您與第三方服務商形成獨立合作關係，平台不參與雙方權利義務約定，不對第三方產品做背書或質量擔保，不存在聯營、隸屬合作關係。",
    "2、对于使用第三方服务产生的风险，由您自行承担，您在使用第三方服务前先阅读第三方隐私政策、服务条款。Taoify 会从第三方服务提供商处获得收益份额，但该收益获取行为不代表 Taoify 需对第三方服务承担任何担保、赔偿等相关责任。": "2、對於使用第三方服務產生的風險，由您自行承擔，您在使用第三方服務前先閱讀第三方隱私政策、服務條款。Taoify 會從第三方服務提供商處獲得收益份額，但該收益獲取行為不代表 Taoify 需對第三方服務承擔任何擔保、賠償等相關責任。",
    "3、Taoify有权自主决定随时限制、关闭第三方服务访问权限，且无需提前通知；因暂停或禁用第三方服务产生的一切损失，Taoify 不向任何主体承担责任。第三方服务仅作参考，不可替代专业咨询。": "3、Taoify有權自主決定隨時限制、關閉第三方服務訪問權限，且無需提前通知；因暫停或禁用第三方服務產生的一切損失，Taoify 不向任何主體承擔責任。第三方服務僅作參考，不可替代專業諮詢。",
    "4、您绑定第三方工具并开启数据互通后，第三方可读取对应店铺经营数据，您与第三方之间的数据交互仅约束双方数据传输，存储风险由您自行承担，平台不会为第三方的数据泄露、篡改行为承担赔偿责任。": "4、您綁定第三方工具並開啟數據互通後，第三方可讀取對應店鋪經營數據，您與第三方之間的數據交互僅約束雙方數據傳輸，存儲風險由您自行承擔，平台不會為第三方的數據洩露、篡改行為承擔賠償責任。",
    "5、Taoify 有权直接或间接获取您与第三方服务商往来的全部邮件内容。Taoify 可向第三方服务商披露、共享您提交的联络方式及相关背景资料。": "5、Taoify 有權直接或間接獲取您與第三方服務商往來的全部郵件內容。Taoify 可向第三方服務商披露、共享您提交的聯絡方式及相關背景資料。",
    "6、因第三方或您与第三方服务商合作关系引发的一切直接、间接以及其他损失，Taoify 均不承担任何赔偿责任。即便提前告知风险，该免责条款仍有效。": "6、因第三方或您與第三方服務商合作關係引發的一切直接、間接以及其他損失，Taoify 均不承擔任何賠償責任。即便提前告知風險，該免責條款仍有效。",
    "7、您与第三方产生纠纷引发平台被起诉、索赔、行政处罚的，您需全额赔偿平台全部损失、维权开支，保障平台各方不受追责。": "7、您與第三方產生糾紛引發平台被起訴、索賠、行政處罰的，您需全額賠償平台全部損失、維權開支，保障平台各方不受追責。",
    "十四、内测Beta功能规则": "十四、內測Beta功能規則",
    "1、平台不定期定向邀请商户体验未正式上线的Beta内测功能，内测使用需同步遵守单独下发的内测补充规则。内测相关资料、沟通记录属于平台保密信息，适用本条款保密有关约定。": "1、平台不定期定向邀請商家體驗未正式上線的Beta內測功能，內測使用需同步遵守單獨下發的內測補充規則。內測相關資料、溝通記錄屬於平台保密信息，適用本條款保密有關約定。",
    "2、未经平台书面许可，商户不得在任何社交平台等渠道发布内测截图、功能细节等与内测有关的内容，禁止向任何第三方泄露内测相关内容。": "2、未經平台書面許可，商家不得在任何社交平台等渠道發布內測截圖、功能細節等與內測有關的內容，禁止向任何第三方洩露內測相關內容。",
    "3、Taoify不对Beta测试服务的功能作出任何明示或默示陈述或保证。内测功能不代表最终上线版本，平台有权根据开发需求调整、下线甚至永久放弃该功能上线；商家自愿参与测试产生的店铺故障、经营损耗等全部风险由商家自行承担，平台不提供补偿或赔付。": "3、Taoify 不對Beta測試服務的功能作出任何明示或默示陳述或保證。內測功能不代表最終上線版本，平台有權根據開發需求調整、下線甚至永久放棄該功能上線；商家自願參與測試產生的店鋪故障、經營損耗等全部風險由商家自行承擔，平台不提供補償或賠付。",
    "十五、商户评价规范": "十五、商家評價規範",
    "1、Taoify 欢迎您提交功能优化创意、经营改进建议、第三方工具评价。您向 Taoify 提供的全部创意、建议、配套资料、评价，Taoify 无需保密，无需向您支付任何报酬或补偿。您主动提交反馈、公开评价，即同意Taoify 无偿参考、落地优化相关方案，可按需修改后商用。": "1、Taoify 歡迎您提交功能優化創意、經營改進建議、第三方工具評價。您向 Taoify 提供的全部創意、建議、配套資料、評價，Taoify 無需保密，無需向您支付任何報酬或補償。您主動提交反饋、公開評價，即同意Taoify 無償參考、落地優化相關方案，可按需修改後商用。",
    "2、您向 Taoify 提交的所有评论，均须如实撰写，不得包含违法、低俗色情、恐吓、诽谤、侵害知识产权以及其他损害第三方权益、引人不适的内容。Taoify有权自主删除违规评价，但无必须开展删除、编辑操作的义务；同时 Taoify 不承担定期核查用户已发布反馈内容的责任。": "2、您向 Taoify 提交的所有評論，均須如實撰寫，不得包含違法、低俗色情、恐嚇、誹謗、侵害知識產權以及其他損害第三方權益、引人不適的內容。Taoify 有權自主刪除違規評價，但無必須開展刪除、編輯操作的義務；同時 Taoify 不承擔定期核查用戶已發布反饋內容的責任。",
    "十六、第三方权利限制": "十六、第三方權利限制",
    "除Taoify、Taoify关联企业、注册商户、合法权利受让方以外，未参与本协议签约的自然人、企业，无权依据本条款向平台主张任何权利，不能要求平台强制履行协议约定。": "除Taoify、Taoify關聯企業、註冊商家、合法權利受讓方以外，未參與本協議簽約的自然人、企業，無權依據本條款向平台主張任何權利，不能要求平台強制履行協議約定。",
    "十七、隐私和数据保护": "十七、隱私和數據保護",
    "Taoify 非常重视对您的个人信息的隐私保护，您使用平台服务即认可平台按照《隐私政策》收集、存储、使用客户个人信息。若商户面向欧盟经济区消费者经营、向欧盟客户销售商品、需要遵守 GDPR 法规，双方另行签署《数据处理补充协议》规范跨境数据传输行为。": "Taoify 非常重視對您的個人資訊的隱私保護，您使用平台服務即認可平台按照《隱私政策》收集、存儲、使用客戶個人資訊。若商家面向歐盟經濟區消費者經營、向歐盟客戶銷售商品、需要遵守 GDPR 法規，雙方另行簽署《數據處理補充協議》規範跨境數據傳輸行為。",
    "十八、商业秘密保护": "十八、商業秘密保護",
    "1、商业秘密：指双方获取、接触到的对方未对外公开的经营与技术资料，涵盖客户资源、潜在客户联系方式、产品研发方案、定价体系、经营成本、营销方案、内部运营流程、专属技术方案、未对外公示财务数据等一切具备商业价值的非公开资料，无论资料是否标注\"保密\"字样。平台内部运维方案、系统安全机制等内部资料同样属于平台商业秘密。": "1、商業秘密：指雙方獲取、接觸到的對方未對外公開的經營與技術資料，涵蓋客戶資源、潛在客戶聯絡方式、產品研發方案、定價體系、經營成本、行銷方案、內部運營流程、專屬技術方案、未對外公示財務數據等一切具備商業價值的非公開資料，無論資料是否標註\"保密\"字樣。平台內部運維方案、系統安全機制等內部資料同樣屬於平台商業秘密。",
    "2、保密义务要求：仅能基于履行本协议约定经营事项使用对方商业秘密，同时采取与自身内部保密同等力度的防护手段，严防商业秘密泄露、复制、擅自对外流转：2.1 仅允许岗位必需员工接触涉密资料，并通过内部制度约束员工保守商业秘密；2.2 如收到法院、监管机关强制调取涉密资料的通知，在法律允许范围内第一时间书面告知资料持有方，并尽可能缩小信息披露范围。": "2、保密義務要求：僅能基於履行本協議約定經營事項使用對方商業秘密，同時採取與自身內部保密同等力度的防護手段，嚴防商業秘密洩露、複製、擅自對外流轉：2.1 僅允許崗位必需員工接觸涉密資料，並通過內部制度約束員工保守商業秘密；2.2 如收到法院、監管機關強制調取涉密資料的通知，在法律允許範圍內第一時間書面告知資料持有方，並盡可能縮小信息披露範圍。",
    "3、豁免保密责任情形：3.1 在接触时已全网公开，或注册平台前就已合法持有该信息；3.2 合作方完全依靠自有资源、不参考对方涉密资料独立研发得到同类信息；3.3 合作方从无违约第三方渠道合法取得该信息，且该第三方不存在保密违约行为。": "3、豁免保密責任情形：3.1 在接觸時已全網公開，或註冊平台前就已合法持有該信息；3.2 合作方完全依靠自有資源、不參考對方涉密資料獨立研發得到同類信息；3.3 合作方從無違約第三方渠道合法取得該信息，且該第三方不存在保密違約行為。",
    "十九、争议解决规则": "十九、爭議解決規則",
    "1、本服务条款为本平台主协议；《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议均为该主协议补充文件，整套文件共同构成您与平台完整约定。若任一补充文件条款与本主协议内容存在冲突、不一致，一律以本服务条款约定为准。针对本主协议未作出细化、未明确约定的事项，以《Taoify 用户使用协议》《Taoify 用户隐私政策》等其他协议约定内容为准。": "1、本服務條款為本平台主協議；《Taoify 用戶使用協議》《Taoify 用戶隱私政策》等其他協議均為該主協議補充文件，整套文件共同構成您與平台完整約定。若任一補充文件條款與本主協議內容存在衝突、不一致，一律以本服務條款約定為準。針對本主協議未作出細化、未明確約定的事項，以《Taoify 用戶使用協議》《Taoify 用戶隱私政策》等其他協議約定內容為準。",
    "2、商户经营过程中产生的、与本服务条款相关的所有争议、索赔，统一由Taoify 平台运营主体所在地人民法院管辖。": "2、商家經營過程中產生的、與本服務條款相關的所有爭議、索賠，統一由Taoify 平台運營主體所在地人民法院管轄。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本条款更新日期：2026年1月1日。": "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）運營，聯繫郵箱：liutaotao@taocarts.com，微信號：zzsist666。本條款更新日期：2026年1月1日。",
    "Taoify 用户使用协议": "Taoify 用戶使用協議",
    "提示：您如需注册或使用 Taoify 平台服务，应当完整阅读并严格遵守《Taoify 用户使用协议》，重点关注免责声明、责任限制、违规处置等内容，明确自身权利、义务、使用规则及违约责任。平台后续上线的全部新功能、新工具，均受本使用协议约束。": "提示：您如需註冊或使用 Taoify 平台服務，應當完整閱讀並嚴格遵守《Taoify 用戶使用協議》，重點關注免責聲明、責任限制、違規處置等內容，明確自身權利、義務、使用規則及違約責任。平台後續上線的全部新功能、新工具，均受本使用協議約束。",
    "Taoify有权不定期更新、修改本使用协议里的内容，有权在 Taoify 网站上发布更新和修改更新本使用协议。最新版本将统一公示于商城处，请您定期查阅条款更新内容。若您不认可条款修订内容，须立即停止使用平台全部服务。": "Taoify有權不定期更新、修改本使用協議裡的內容，有權在 Taoify 網站上發布更新和修改更新本使用協議。最新版本將統一公示於商城處，請您定期查閱條款更新內容。若您不認可條款修訂內容，須立即停止使用平台全部服務。",
    "除本协议明确约定内容以外，双方所有其他权利义务、规则约束均以《Taoify 服务条款》《Taoify消费协议》等为准。": "除本協議明確約定內容以外，雙方所有其他權利義務、規則約束均以《Taoify 服務條款》《Taoify消費協議》等為準。",
    "完成账户注册，即代表您已充分知晓并自愿接受Taoify 平台所有协议、条款，包括《Taoify 用户使用协议》《Taoify 服务条款》《Taoify用户隐私政策》等。若您不认可Taoify 平台所有协议、条款内容，请立即停止注册。": "完成賬戶註冊，即代表您已充分知曉並自願接受Taoify 平台所有協議、條款，包括《Taoify 用戶使用協議》《Taoify 服務條款》《Taoify用戶隱私政策》等。若您不認可Taoify 平台所有協議、條款內容，請立即停止註冊。",
    "用户：指完成 Taoify 平台注册，并使用平台各项服务的自然人、法人及其他组织。": "用戶：指完成 Taoify 平台註冊，並使用平台各項服務的自然人、法人及其他組織。",
    "平台：指Taoify 平台运营主体及平台软硬件系统、网站、服务端口等整体服务载体。": "平台：指Taoify 平台運營主體及平台軟硬件系統、網站、服務端口等整體服務載體。",
    "二、账户注册与使用规范": "二、賬戶註冊與使用規範",
    "（一）用户资质与信息管理": "（一）用戶資質與信息管理",
    "1. 用户注册时，须向平台提交真实、合法、有效的身份信息、注册地址、实际经营地址、联系电话等资料，不得伪造、变造、隐瞒、虚报注册及资质资料。若用户依托本平台开展经营活动，除法律法规明确可不予登记的情形外，必须依法完成市场主体登记，取得有效营业执照，并在登记经营范围内开展业务。经营项目依法需要行政许可、审批、备案、资质认证的，用户须提前取得对应资质并保证资质持续有效，同时将相关文件提交平台留存。若许可资质被撤销、吊销、到期失效，用户须立即停止对应经营活动并同步告知平台，否则视为严重违约，由此产生的全部法律责任、经济损失由用户自行承担；造成平台损失的，用户须足额赔偿。平台依据监管要求中断、终止服务的，已收取费用不予退还。": "1. 用戶註冊時，須向平台提交真實、合法、有效的身份信息、註冊地址、實際經營地址、聯繫電話等資料，不得偽造、變造、隱瞞、虛報註冊及資質資料。若用戶依托本平台開展經營活動，除法律法規明確可不予登記的情形外，必須依法完成市場主體登記，取得有效營業執照，並在登記經營範圍內開展業務。經營項目依法需要行政許可、審批、備案、資質認證的，用戶須提前取得對應資質並保證資質持續有效，同時將相關文件提交平台留存。若許可資質被撤銷、吊銷、到期失效，用戶須立即停止對應經營活動並同步告知平台，否則視為嚴重違約，由此產生的全部法律責任、經濟損失由用戶自行承擔；造成平台損失的，用戶須足額賠償。平台依據監管要求中斷、終止服務的，已收取費用不予退還。",
    "用户须及时完善账户基础信息，因信息错误、失联产生的所有后果，由用户自行负责。用户信息、资质发生变更的，需在变更3个工作日内主动在平台完成更新备案。因资料虚假、失效、未及时更新引发的一切风险与责任，均由用户自行承担。用户需自行妥善保管账户资料、账号、密码等私密信息，不得向无关第三方泄露、转借。因保管不当、信息外泄造成的资金损失、财产损害及法律责任，全部由用户承担。": "用戶須及時完善賬戶基礎信息，因信息錯誤、失聯產生的所有後果，由用戶自行負責。用戶信息、資質發生變更的，需在變更3個工作日內主動在平台完成更新備案。因資料虛假、失效、未及時更新引發的一切風險與責任，均由用戶自行承擔。用戶需自行妥善保管賬戶資料、賬號、密碼等私密信息，不得向無關第三方泄露、轉借。因保管不當、信息外泄造成的資金損失、財產損害及法律責任，全部由用戶承擔。",
    "（二）平台使用限制": "（二）平台使用限制",
    "1. 用户需严格按照所购服务档位的资源限额使用平台服务，超出限制的，平台有权采取限流、关停网站等管控措施，相关损失由用户自行承担，已支付费用不予退还。": "1. 用戶需嚴格按照所購服務檔位的資源限額使用平台服務，超出限制的，平台有權採取限流、關停網站等管控措施，相關損失由用戶自行承擔，已支付費用不予退還。",
    "2. 用户严禁实施以下违规行为：": "2. 用戶嚴禁實施以下違規行為：",
    "（1）通过群发垃圾邮件、商业广告等方式推广站点；": "（1）通過群發垃圾郵件、商業廣告等方式推廣站點；",
    "（2）运行违规程序、进程，恶意占用服务器内存、CPU、宽带等资源，造成服务器卡顿、宕机，影响平台及其他用户正常使用；": "（2）運行違規程序、進程，惡意佔用伺服器內存、CPU、寬帶等資源，造成伺服器卡頓、宕機，影響平台及其他用戶正常使用；",
    "（3）发起网络攻击、篡改系统配置、破坏平台网络与信息安全；": "（3）發起網絡攻擊、篡改系統配置、破壞平台網絡與信息安全；",
    "（4）运行干扰服务器正常运行的程序、软件；": "（4）運行干擾伺服器正常運行的程序、軟件；",
    "（5）泄露自身及其他客户身份、隐私信息；": "（5）泄露自身及其他客戶身份、隱私信息；",
    "（6）提供、售卖与未成年人相关的违规商品及服务；": "（6）提供、銷售與未成年人相關的違規商品及服務；",
    "（7）发布、提供带有骚扰、诽谤性质的商品与服务；": "（7）發布、提供帶有騷擾、誹謗性質的商品與服務；",
    "（8）借助平台宣传、售卖基于种族、民族、肤色、宗教信仰等歧视他人、侵犯人权的商品或服务；": "（8）借助平台宣傳、銷售基於種族、民族、膚色、宗教信仰等歧視他人、侵犯人權的商品或服務；",
    "（9）侵犯任何第三方知识产权；": "（9）侵犯任何第三方知識產權；",
    "（10）售卖危险品、管制物品、侵权商品等国内外法律法规明令禁止流通、进出口的商品；": "（10）銷售危險品、管制物品、侵權商品等國內外法律法規明令禁止流通、進出口的商品；",
    "（11）利用平台开展洗钱、逃税、非法交易等各类违法活动；": "（11）利用平台開展洗錢、逃稅、非法交易等各類違法活動；",
    "（12）开展超出服务范围及国家法律法规禁止的其他行为。": "（12）開展超出服務範圍及國家法律法規禁止的其他行為。",
    "（三）用户基本义务": "（三）用戶基本義務",
    "数据安全义务：用户须遵守国家数据保护相关法律法规，建立数据安全防护机制，妥善存储、管理平台数据，严禁泄露、篡改、非法使用数据。因用户行为引发数据安全违规的，由用户独立承担全部法律责任。": "數據安全義務：用戶須遵守國家數據保護相關法律法規，建立數據安全防護機制，妥善存儲、管理平台數據，嚴禁洩露、篡改、非法使用數據。因用戶行為引發數據安全違規的，由用戶獨立承擔全部法律責任。",
    "商品与服务合规义务：用户上架、销售、提供的商品及服务，必须符合国家安全、生产、环保等法律法规与行业标准，不得提供存在安全隐患、污染环境、危害公众健康的产品及服务。因商品、服务问题引发投诉、处罚、民事赔偿的，责任由用户全部承担。平台收到投诉后，可根据情节采取警示、下架商品、删除内容、暂停服务、封禁账号等处置措施。": "商品與服務合規義務：用戶上架、銷售、提供的商品及服務，必須符合國家安全、生產、環保等法律法規與行業標準，不得提供存在安全隱患、污染環境、危害公眾健康的商品及服務。因商品、服務問題引發投訴、處罰、民事賠償的，責任由用戶全部承擔。平台收到投訴後，可根據情節採取警示、下架商品、刪除內容、暫停服務、封禁帳號等處置措施。",
    "税务与票据义务：用户开展经营活动须依法纳税，如实申报税费，按规定向交易方开具正规发票，严禁偷税、漏税、逃税、虚开发票、拒开发票，不得参与走私、变相避税等违法活动。平台有权核验票据及纳税凭证，用户违规的，平台可暂停或终止全部服务。": "稅務與票據義務：用戶開展經營活動須依法納稅，如實申報稅費，按規定向交易方開具正規發票，嚴禁偷稅、漏稅、逃稅、虛開發票、拒開發票，不得參與走私、變相避稅等違法活動。平台有權核驗票據及納稅憑證，用戶違規的，平台可暫停或終止全部服務。",
    "信息发布义务：用户发布内容需严格遵守法律法规，不得制作、复制、发布、传播违法违规、损害公共利益及他人合法权益的信息，不得为违规内容提供跳转、链接等便利。用户收到平台整改通知后须立即整改；拒不整改的，平台有权暂停或终止全部服务。因用户或其客户发布违规内容造成平台损失的，由客户、用户承担全部赔偿责任。": "信息發布義務：用戶發布內容需嚴格遵守法律法規，不得製作、複製、發布、傳播違法違規、損害公共利益及他人合法權益的信息，不得為違規內容提供跳轉、連結等便利。用戶收到平台整改通知後須立即整改；拒不整改的，平台有權暫停或終止全部服務。因用戶或其客戶發布違規內容造成平台損失的，由客戶、用戶承擔全部賠償責任。",
    "个人信息保护义务：用户收集、使用、存储、传输客户个人信息，需严格遵守法律法规，严禁非法收集、泄露、出售、篡改他人隐私信息。若发生信息泄露、侵权事件，用户承担全部民事、行政及刑事责任。": "個人資訊保護義務：用戶收集、使用、存儲、傳輸客戶個人資訊，需嚴格遵守法律法規，嚴禁非法收集、洩露、出售、篡改他人隱私信息。若發生信息洩露、侵權事件，用戶承擔全部民事、行政及刑事責任。",
    "知识产权保护义务：用户在平台上传、发布的文字、图片、视频、商标、设计等内容，需拥有知识产权或取得权利人授权，不得侵犯第三方著作权、商标权、专利权等合法权益。用户因侵权引发投诉、诉讼、索赔、行政处罚的，赔偿金、诉讼费、律师费、罚款等所有费用由用户承担，同时用户需赔偿平台方直接、间接损失。": "知識產權保護義務：用戶在平台上傳、發布的文字、圖片、視頻、商標、設計等內容，需擁有知識產權或取得權利人授權，不得侵犯第三方著作權、商標權、專利權等合法權益。用戶因侵權引發投訴、訴訟、索賠、行政處罰的，賠償金、訴訟費、律師費、罰款等所有費用由用戶承擔，同時用戶需賠償平台方直接、間接損失。",
    "账号安全义务：用户全权负责账号、站点内容、登录密码的安全保管，因账号外泄、保管不当造成的损失，由用户自行承担。用户需向平台报备对接人员及联系方式，相关人员行为产生的后果由用户承担。": "帳號安全義務：用戶全權負責帳號、站點內容、登錄密碼的安全保管，因帳號外洩、保管不當造成的損失，由用戶自行承擔。用戶需向平台報備對接人員及聯絡方式，相關人員行為產生的後果由用戶承擔。",
    "平台知识产权约定：平台所有技术资料、软件、系统、技术服务的知识产权均归 Taoify 平台所有，用户不得擅自复制、传播、转让、授权第三方使用，违者承担相应法律责任。": "平台知識產權約定：平台所有技術資料、軟件、系統、技術服務的知識產權均歸 Taoify 平台所有，用戶不得擅自複製、傳播、轉讓、授權第三方使用，違者承擔相應法律責任。",
    "服务使用规则：站点开通后，用户须及时登录会员中心完成基础配置。用户可同时订购多项平台服务，各项服务周期自购买当日起计算，服务期内不支持暂停。": "服務使用規則：站點開通後，用戶須及時登錄會員中心完成基礎配置。用戶可同時訂購多項平台服務，各項服務週期自購買當日起計算，服務期內不支持暫停。",
    "订单履约义务：用户收到平台警告后须及时优化发货效率、完成整改，长期拒不整改的，平台有权单方面终止服务。": "訂單履約義務：用戶收到平台警告後須及時優化發貨效率、完成整改，長期拒不整改的，平台有權單方面終止服務。",
    "投诉处置规则：若平台收到第三方针对用户发布内容、在售商品、提供服务、隐私侵权、知识产权侵权、违法违规等投诉或实名举报，平台有权不经用户同意，直接对用户相关内容、页面、商品、链接进行删除、屏蔽、下架处理；情节严重、拒不整改的，平台可直接暂停、终止全部服务，用户已缴纳的所有费用不予退还。": "投訴處置規則：若平台收到第三方針對用戶發布內容、在售商品、提供服務、隱私侵權、知識產權侵權、違法違規等投訴或實名舉報，平台有權不经用戶同意，直接對用戶相關內容、頁面、商品、連結進行刪除、屏蔽、下架處理；情節嚴重、拒不整改的，平台可直接暫停、終止全部服務，用戶已繳納的所有費用不予退還。",
    "三、服务费用、续费与佣金": "三、服務費用、續費與佣金",
    "本平台服务价格以 Taoify 平台官网、购买页面实时公示为准，用户须按约定方式、期限足额支付费用；未付清费用前，Taoify 平台有权暂停、终止提供服务。": "本服務價格以 Taoify 平台官網、購買頁面即時公佈為準，用戶須按約定方式、期限足額支付費用；未付清費用前，Taoify 平台有權暫停、終止提供服務。",
    "平台赠送服务、优惠活动均为一次性福利，赠送服务不包含修改、更新、维护费用，亦不得折价抵扣服务费，赠送服务最终解释权归 Taoify 平台所有。": "平台贈送服務、優惠活動均為一次性福利，贈送服務不包含修改、更新、維護費用，亦不得折價抵扣服務費，贈送服務最終解釋權歸 Taoify 平台所有。",
    "服务期限届满前用户未及时续订阅费用的，服务自动终止；服务关闭满10日用户仍未续订阅费用的，Taoify 平台有权删除网站全部数据，相关损失由用户自行承担。": "服務期限屆滿前用戶未及時續訂閱費用的，服務自動終止；服務關閉滿10日用戶仍未續訂閱費用的，Taoify 平台有權刪除網站全部數據，相關損失由用戶自行承擔。",
    "若用户实际交易额超出对应产品套装免佣额度，超出部分用户须按约定支付佣金。佣金按单笔实时扣除或自然月统一核算，用户收到账单后5个工作日内完成支付；逾期未支付的，Taoify 平台有权终止服务。": "若用戶實際交易額超出對應產品套裝免佣額度，超出部分用戶須按約定支付佣金。佣金按單筆即時扣除或自然月統一核算，用戶收到帳單後5個工作日內完成支付；逾期未支付的，Taoify 平台有權終止服務。",
    "用户有权要求 Taoify 平台就实付服务费用开具正规发票，赠送服务对应的金额不纳入开票范围。": "用戶有權要求 Taoify 平台就實付服務費用開具正規發票，贈送服務對應的金額不納入開票範圍。",
    "第四条 服务终止": "第四條 服務終止",
    "服务期内用户主动申请终止服务的，需提前一个月书面通知 Taoify 平台，已缴纳费用不予退还；用户擅自终止协议造成 Taoify 平台损失的，须予以赔偿，包括但不限于直接损失、间接损失、律师费等。": "服務期內用戶主動申請終止服務的，需提前一個月書面通知 Taoify 平台，已繳納費用不予退還；用戶擅自終止協議造成 Taoify 平台損失的，須予以賠償，包括但不限於直接損失、間接損失、律師費等。",
    "因系统停机、升级、维护；电信线路、设备故障，银行系统异常等第三方问题造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "因系統停機、升級、維護；電信線路、設備故障，銀行系統異常等第三方問題造成服務中斷、卡頓、故障的，Taoify 平台不承擔責任。",
    "因用户原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "因用戶原因造成服務中斷、卡頓、故障的，Taoify 平台不承擔責任。",
    "网络拥堵；黑客攻击、电信故障、政府管制、不可抗力、第三方原因等非 Taoify 平台原因造成服务中断、卡顿、故障的，Taoify 平台不承担责任。": "網絡擁堵；黑客攻擊、電信故障、政府管制、不可抗力、第三方原因等非 Taoify 平台原因造成服務中斷、卡頓、故障的，Taoify 平台不承擔責任。",
    "用户违规占用资源、发布违法信息、侵权、泄露隐私、违法经营、拒不整改等违反本协议约定的，Taoify 平台有权立即关闭网站、终止服务、冻结账号，余款不予退还，同时用户须赔偿 Taoify 平台全部损失，包括但不限于直接损失、间接损失、律师费等。": "用戶違規佔用資源、發布違法信息、侵權、洩露隱私、違法經營、拒不整改等違反本協議約定的，Taoify 平台有權立即關閉網站、終止服務、凍結帳號，餘款不予退還，同時用戶須賠償 Taoify 平台全部損失，包括但不限於直接損失、間接損失、律師費等。",
    "因用户使用第三方服务导致网站故障、无法使用的，Taoify 平台不承担任何责任。": "因用戶使用第三方服務導致網站故障、無法使用的，Taoify 平台不承擔任何責任。",
    "Taoify平台无需就用户遭受的任何直接损失、间接损失、商誉损失、预期收益损失、经营利润损失等承担任何赔偿责任。": "Taoify 平台無需就用戶遭受的任何直接損失、間接損失、商譽損失、預期收益損失、經營利潤損失等承擔任何賠償責任。",
    "若存在法定或其他 Taoify 应当承担赔偿责任的情形，Taoify 对用户的全部累计赔偿责任（含违约金、赔偿金、维权支出）最高限额为：损失事件发生对应服务周期内，您实际向 Taoify 支付的服务费总金额。无论索赔事由多少、损失金额高低，合计赔付总额不得突破该上限。": "若存在法定或其他 Taoify 應當承擔賠償責任的情形，Taoify 對用戶的全部累計賠償責任（含違約金、賠償金、維權支出）最高限額為：損失事件發生對應服務周期內，您實際向 Taoify 支付的服務費總金額。無論索賠事由多少、損失金額高低，合計賠付總額不得突破該上限。",
    "第五条 知识产权与平台内容约定": "第五條 知識產權與平台內容約定",
    "Taoify平台全部内容，包括但不限于文字、图片、文档、资讯、网站架构、界面设计、程序代码等，相关商标权、著作权、专利权、商业秘密等知识产权均归Taoify平台所有。未经 Taoify 平台书面许可，任何主体不得擅自使用、复制、修改、传播、分发平台内容及程序。": "Taoify 平台全部內容，包括但不限於文字、圖片、文檔、資訊、網站架構、界面設計、程序代碼等，相關商標權、著作權、專利權、商業秘密等知識產權均歸 Taoify 平台所有。未經 Taoify 平台書面許可，任何主體不得擅自使用、複製、修改、傳播、分發平台內容及程序。",
    "用户仅可在 Taoify平台指定专属服务器内使用本平台搭建的网站，不得将网站迁移至非本平台、非本平台提供的服务器运行。": "用戶僅可在 Taoify 平台指定專屬伺服器內使用本平台搭建的網站，不得將網站遷移至非本平台、非本平台提供的伺服器運行。",
    "用户自行在网站创建、上传的内容，由用户独立承担全部法律责任；基于本平台开发的第三方应用，其行为、内容、数据由第三方自行负责，Taoify 平台不承担连带责任。": "用戶自行在網站創建、上傳的內容，由用戶獨立承擔全部法律責任；基於本平台開發的第三方應用，其行為、內容、數據由第三方自行負責，Taoify 平台不承擔連帶責任。",
    "第六条 条款修订": "第六條 條款修訂",
    "Taoify平台有权随时修订本协议条款、服务定价，协议条款修订提前1个工作日在平台公示，资费调整提前1个月公示。修订后的条款公示后继续使用服务的，视为用户自愿接受全部修订内容。": "Taoify 平台有權隨時修訂本協議條款、服務定價，協議條款修訂提前1個工作日在平台公示，資費調整提前1個月公示。修訂後的條款公示後繼續使用服務的，視為用戶自願接受全部修訂內容。",
    "第七条 通知": "第七條 通知",
    "用户确认，在 Taoify平台注册所提供的身份信息、地址、联系方式为本协议履行、相关的诉讼、仲裁程序中的法定送达地址及送达方式，司法机关可直接据此送达各类司法文书。双方均同意以邮寄、电子送达方式收取司法文书。上述送达地址及方式的效力涵盖仲裁、一审、二审、再审及执行等全部诉讼阶段。若一方信息变更，需提前3个工作日申请变更，未变更的，原约定地址及方式仍视为有效送达地址，任何一方、司法机关按原地址送达即便被退回，也视为有效送达。": "用戶確認，在 Taoify 平台註冊所提供的身份信息、地址、聯繫方式為本協議履行、相關的訴訟、仲裁程序中的法定送達地址及送達方式，司法機關可直接據此送達各類司法文書。雙方均同意以郵寄、電子送達方式收取司法文書。上述送達地址及方式的效力涵蓋仲裁、一審、二審、再審及執行等全部訴訟階段。若一方信息變更，需提前3個工作日申請變更，未變更的，原約定地址及方式仍視為有效送達地址，任何一方、司法機關按原地址送達即便被退回，也視為有效送達。",
    "第八条 不可抗力": "第八條 不可抗力",
    "不可抗力指战争、武装冲突、自然灾害（如地震、洪水）、罢工、暴乱、政府行为（如禁令、制裁）、司法限制、全国性疫情等不能预见、不能避免且不能克服的客观事件。": "不可抗力指戰爭、武裝衝突、自然災害（如地震、洪水）、罷工、暴亂、政府行為（如禁令、制裁）、司法限制、全國性疫情等不能預見、不能避免且不能克服的客觀事件。",
    "第九条 其他约定": "第九條 其他約定",
    "1. Taoify平台发生上市、收购、合并、名称变更等情形时，有权将本协议项下全部权利、义务转移给权利义务承接方，用户对此无异议。": "1. Taoify 平台發生上市、收購、合併、名稱變更等情形時，有權將本協議項下全部權利、義務轉移給權利義務承接方，用戶對此無異議。",
    "2. Taoify 平台内服务说明、价格公示、申请表格等文件，均为本协议不可分割的组成部分，与本协议具有同等法律效力。": "2. Taoify 平台內服務說明、價格公示、申請表格等文件，均為本協議不可分割的組成部分，與本協議具有同等法律效力。",
    "3. 若因用户违反本协议约定，导致平台被第三方索赔、起诉、仲裁，或被行政机关处以罚款、责令赔付，全部责任均由用户独立承担。用户须向平台足额赔付平台由此产生的全部直接损失与间接损失，损失范围包括但不限于：平台向第三方支付的赔偿金、和解金、补偿金、违约金；行政机关、司法机关收取的罚款、滞纳金、诉讼费、仲裁费、保全费、执行费、鉴定费、评估费；平台为维权支出的律师费、公证费、调查取证费、差旅费、担保费；平台商誉受损损失、业务中断损失、可得利益损失、第三方追责产生的额外赔付等一切相关费用。": "3. 若因用戶違反本協議約定，導致平台被第三方索賠、起訴、仲裁，或被行政機關處以罰款、責令賠付，全部責任均由用戶獨立承擔。用戶須向平台足額賠付平台由此產生的全部直接損失與間接損失，損失範圍包括但不限於：平台向第三方支付的賠償金、和解金、補償金、違約金；行政機關、司法機關收取的罰款、滯納金、訴訟費、仲裁費、保全費、執行費、鑑定費、評估費；平台為維權支出的律師費、公證費、調查取證費、差旅費、擔保費；平台商譽受損損失、業務中斷損失、可得利益損失、第三方追責產生的額外賠付等一切相關費用。",
    "第十条 争议解决": "第十條 爭議解決",
    "1. 平台有关条款（包括但不限于本使用协议等）可能会有除中文以外的其他版本。如果不同语言版本的使用协议之间存在任何差异、不一致或歧义，均以中文文本为准，其他文本仅作参考，不得用于抵触或变更中文文本的含义。本使用协议条款的订立、效力、解释、履行及争议解决，均以中华人民共和国法律作为准据法，排除境外法律冲突规则。《联合国国际货物销售合同公约》不应用于本使用协议，予以明确排除。": "1. 平台有關條款（包括但不限於本使用協議等）可能會有除中文以外的其他版本。如果不同語言版本的使用協議之間存在任何差異、不一致或歧義，均以中文文本為準，其他文本僅作參考，不得用於抵觸或變更中文文本的含義。本使用協議條款的訂立、效力、解釋、履行及爭議解決，均以中華人民共和國法律作為準據法，排除境外法律衝突規則。《聯合國國際貨物銷售合同公約》不應用於本使用協議，予以明確排除。",
    "2. 因本协议引起或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权向Taoify 平台经营地有管辖权的人民法院提起诉讼。": "2. 因本協議引起或與本協議有關的任何爭議，雙方應友好協商解決；協商不成的，任何一方均有權向Taoify 平台經營地有管轄權的人民法院提起訴訟。",
    "争议处理期间，除争议事项外，双方应继续履行本协议其他约定。本协议部分条款被废止、无效或不能执行，并不影响其他条款效力。": "爭議處理期間，除爭議事項外，雙方應繼續履行本協議其他約定。本協議部分條款被廢止、無效或不能執行，並不會影響其他條款效力。",
    "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）运营，联系邮箱：liutaotao@taocarts.com，微信号：zzsist666。本协议更新日期：2026年1月1日。": "本平台由香港星橋國際貿易有限公司（https://aitaoify.com）運營，聯繫郵箱：liutaotao@taocarts.com，微信號：zzsist666。本協議更新日期：2026年1月1日。",
    "适用于任何项目的": "適用於任何項目",
    "根据自己的需求选择合适的模板，并在其基础上进行自定义和修改，以满足自己的品牌形象和功能要求。": "根據自己的需求選擇合適的模板，並在其基礎上進行自定義和修改，以滿足自己的品牌形象和功能要求。",
    "用 AI 设计你的专属模板": "用 AI 設計你的專屬模板",
    "一句话描述你的店铺风格，AI 自动生成专属模板": "一句話描述你的店鋪風格，AI 自动生成专属模板",
    "无需设计经验": "無需設計經驗",
    "秒级生成": "秒級生成",
    "可二次修改": "可二次修改",
    "立即 AI 设计": "立即 AI 設計",
    "搜索您想要的模版": "搜尋您想要的模板",
    "注册卖家": "註冊賣家",
    "行业模板": "行業模板",
    "满意度": "滿意度",
    "精选模板": "精選模板",
    "查看模板设计": "查看模板設計",
    "最新的主题和模板": "最新的主題和模板",
    "查看更多": "查看更多",
    "暂无模板，稍后再来看看吧": "暫無模板，稍後再來看看吧",
    "本周精选创作者": "本週精選創作者",
    "个作品": "個作品",
    "查看主页": "查看主頁",
    "数百万创意资源、无限下载": "數百萬創意資源、無限下載",
    "立即订阅、可随时取消": "立即訂閱、可隨時取消",
    "轻松的设计有您自己在线制作": "輕鬆的設計有您自己在線製作",
    "适合任何技能水平的智能模板": "適合任何技能水平的智能模板",
    "如何用 AI 设计模板": "如何用 AI 設計模板",
    "描述你的店铺类型和风格，如“欧美简约服饰店”": "描述你的店鋪類型和風格，如「歐美簡約服飾店」",
    "AI 自动生成多套模板设计供你选择": "AI 自动生成多套模板設計供你選擇",
    "选中模板后一键启用，随时调整细节": "選中模板後一鍵啟用，隨時調整細節",
    "去模板列表看看": "去模板列表看看",
    "我知道了": "我知道了",
    "个筛选": "個篩選",
    "全部模板": "全部模板",
    "没有结果": "沒有結果",
    "作者": "作者",
    "更新时间": "更新時間",
    "实时预览": "即時預覽",
    "立即购买": "立即購買",
    "应用到当前店铺": "應用到當前商店",
    "模板介绍": "模板介紹",
    "主题模板特点": "主題模板特色",
    "模版价格": "模板價格",
    "支付方式": "付款方式",
    "未来更新": "未來更新",
    "提供6个月的支持": "提供6個月的支援",
    "由Taoify检查质量": "由Taoify檢查品質",
    "模板规格": "模板規格",
    "高分辨率": "高解析度",
    "是的": "是的",
    "不支持": "不支援",
    "可兼容浏览器": "可相容瀏覽器",
    "布局": "佈局",
    "模版ID": "模板ID",
    "发表时间": "發表時間",
    "关于作者": "關於作者",
    "其他作品": "其他作品",
    "购买成功": "購買成功",
    "购买成功！请在模板中心查看使用。": "購買成功！請在模板中心查看使用。",
    "仅关闭": "僅關閉",
    "查看已购买模版": "查看已購買模板",
    "预览站点暂时不可用，请稍后再试或联系平台": "預覽站點暫時不可用，請稍後再試或聯繫平台",
    "返回": "返回",
    "审核失败": "審核失敗",
    "（审核失败请到原创作平台进行编辑后更新）": "（審核失敗請到原創作平台進行編輯後更新）",
    "失败原因": "失敗原因",
    "申请时间": "申請時間",
    "审核时间": "審核時間",
    "未发布": "未發布",
    "已发布": "已發布",
    "审核通过": "審核通過",
    "当前版本号": "當前版本號",
    "发布模版": "發佈模板",
    "删除当前模版": "刪除當前模板",
    "删除模板": "刪除模板",
    "确定删除该模板吗？删除后不可恢复。": "確定刪除該模板嗎？刪除後不可恢復。",
    "取消": "取消",
    "确认删除": "確認刪除",
    "申请发布模版，TaoifyShop会尽快审核，请在个人中心查看结果。": "申請發佈模板，TaoifyShop會盡快審核，請在個人中心查看結果。",
    "确定": "確定",
    "模板设计师工作台": "模板設計師工作台",
    "把你的设计变成收入": "把你的設計變成收入",
    "你制作的模板可以发布到模版市场，其他卖家购买后你即可获得佣金收益。": "你製作的模板可以發佈到模板市場，其他賣家購買後你即可獲得佣金收益。",
    "发布我的模板": "發佈我的模板",
    "去模版市场看看": "去模板市場看看",
    "个": "個",
    "我的模板": "我的模板",
    "已购模板": "已購模板",
    "模板审核通过上架后，被其他卖家购买即可获得佣金收益": "模板審核通過上架後，被其他賣家購買即可獲得佣金收益",
    "想快速出模板？试试 AI 设计": "想快速出模板？試試 AI 設計",
    "一句话描述店铺风格，AI 自动生成专属模板，省时又省力": "一句話描述店鋪風格，AI 自動生成專屬模板，省時又省力",
    "发布你的设计，赚取佣金": "發布你的設計，賺取佣金",
    "发布模板": "發布模板",
    "全选": "全選",
    "已选": "已選",
    "批量删除": "批量刪除",
    "查看": "查看",
    "发布": "發布",
    "更新": "更新",
    "应用": "應用",
    "无结果": "無結果",
    "已购买模版": "已購買模板",
    "当前店铺": "當前店鋪",
    "当前店铺应用版本": "當前店鋪應用版本",
    "还未购买模版": "還未購買模板",
    "提交后由平台审核": "提交後由平台審核",
    "生成待发布模版，可在个人中心提交发布到模版市场，TaoifyShop会尽快审核，审核通过后将上架到模版市场，其他人购买后，可赚佣金。审核结果请在个人中心的自定义模版中查看，大概需要1~2个工作日。": "生成待發布模板，可在個人中心提交發布到模板市場，TaoifyShop會盡快審核，審核通過後將上架到模板市場，其他人購買後，可賺佣金。審核結果請在個人中心的自定義模板中查看，大概需要1~2個工作日。",
    "选择要发布的模板": "選擇要發布的模板",
    "新发布": "新發布",
    "发布新版本": "發布新版本",
    "暂无未发布模板，请先在工作台制作模板": "暫無未發布模板，請先在工作台製作模板",
    "作品信息": "作品資訊",
    "名称": "名稱",
    "模板名称": "模板名稱",
    "封面图": "封面圖",
    "上传封面": "上傳封面",
    "模板描述": "模板描述",
    "模版亮点": "模板亮點",
    "付费": "付費",
    "标签": "標籤",
    "按Enter键保存和添加更多": "按Enter鍵保存並添加更多",
    "特点": "特點",
    "按Enter键添加特点": "按Enter鍵添加特點",
    "关闭": "關閉",
    "提交": "提交",
    "批量删除模板": "批量刪除模板",
    "确定删除选中的": "確定刪除選中的",
    "个模板吗？删除后不可恢复。": "個模板嗎？刪除後不可恢復。",
    "删除已购模板": "刪除已購模板",
    "确定删除已购模板": "確定刪除已購模板",
    "吗？删除后将无法继续使用。": "嗎？刪除後將無法繼續使用。",
    "立即去设计": "立即去設計",
    "全部自定义模版": "全部自定義模板",
    "待发布": "待發布",
    "待审核": "待審核",
    "审核未通过": "審核未通過",
    "自适应": "自適應",
    "仅支持PC": "僅支持PC",
    "仅支持H5": "僅支持H5",
    "删除成功": "刪除成功",
    "余额提现": "餘額提現",
    "提现明细": "提現明細",
    "可提现金额": "可提現金額",
    "提现到支付宝": "提現到支付寶",
    "提现到银行卡": "提現到銀行卡",
    "购买记录": "購買記錄",
    "查看你购买过的模板与订单": "查看你購買過的模板與訂單",
    "类型": "類型",
    "订单编号": "訂單編號",
    "已支付": "已支付",
    "暂无购买记录": "暫無購買記錄",
    "消费记录": "消費記錄",
    "时间": "時間",
    "详情": "詳情",
    "支出": "支出",
    "收入": "收入",
    "收益明细": "收益明細",
    "已失效": "已失效",
    "待结算": "待結算",
    "已结算": "已結算",
    "提现记录": "提現記錄",
    "模版名称": "模版名稱",
    "在线咨询": "在線諮詢",
    "在线客服暂时没接上，稍后再试一次；着急的话直接发邮件，我们会尽快回。": "在線客服暫時沒接上，稍後再試一次；著急的話直接發郵件，我們會盡快回覆。",
    "重新连接": "重新連接",
    "月": "月",
    "想了解开店、选品、物流？直接问…": "想了解開店、選品、物流？直接問…",
    "拖动调整大小": "拖動調整大小",
    "开店顾问": "開店顧問",
    "人工在线": "人工在線",
    "全天候自动应答": "全天候自動應答",
    "网络异常，请稍后再试": "網絡異常，請稍後再試",
    "AI 顾问": "AI 顧問",
    "待人工确认": "待人工確認",
    "转人工": "轉人工",
    "开店与起步": "開店與起步",
    "注册、选模板、绑域名、第一件商品": "註冊、選模板、綁域名、第一件商品",
    "店铺装修": "商店裝修",
    "模板、组件、配色、手机端排版": "模板、組件、配色、手機端排版",
    "商品与库存": "商品與庫存",
    "采集、改价、规格、库存同步": "採集、改價、規格、庫存同步",
    "采购、打单、发货、轨迹异常": "採購、打單、發貨、軌跡異常",
    "绑账户、余额、提现、服务费": "綁定賬戶、餘額、提現、服務費",
    "营销与 AI": "行銷與 AI",
    "AI 客服、AI 员工、优惠券、邮件": "AI 客服、AI 員工、優惠券、郵件",
    "账号与权限": "帳號與權限",
    "子账号、角色、登录、安全": "子帳號、角色、登錄、安全",
    "API、Webhook、对接自己的系统": "API、Webhook、對接自己的系統",
    "注册开店要准备什么？多久能跑起来？": "註冊開店要準備什麼？多久能運作起來？",
    "一个能收验证码的邮箱或手机号就能注册，不需要先有营业执照。流程是：选套餐、选模板、绑域名、传第一个商品，一般一小时内能在后台跑通一单测试订单。": "一個能接收驗證碼的電子郵箱或手機號就能註冊，不需要先有營業執照。流程是：選套餐、選模板、綁定域名、上傳第一個商品，一般一小時內能在後台跑通一筆測試訂單。",
    "店铺能不能绑自己的域名？需要备案吗？": "店鋪能不能綁定自己的域名？需要備案嗎？",
    "可以。在后台「店铺设置 → 域名」里填你的域名，按提示加两条 DNS 解析，一般十分钟生效，SSL 证书自动签发。服务器在境外，不需要国内备案；自有域名按套餐权限开放。": "可以。在後台「店鋪設置 → 域名」裡填寫你的域名，按照提示添加兩條 DNS 解析，一般十分鐘生效，SSL 證書自動簽發。伺服器在境外，不需要國內備案；自有域名按套餐權限開放。",
    "模板市场里的模板怎么用？换了会不会影响商品和订单？": "模板市場裡的模板怎麼用？換了會不會影響商品和訂單？",
    "模板只改变店铺外观，不动商品、订单和客户数据，随时可以换回来。应用模板后，再在装修页调首页模块和配色，保存发布后前台才生效。": "模板只改變店鋪外觀，不動商品、訂單和客戶數據，隨時可以換回來。應用模板後，再到裝修頁調整首頁模塊和配色，保存發布後前台才生效。",
    "装修改完，前台看还是老样子？": "裝修改完，前台看還是老樣子？",
    "先确认改动是否已经保存并发布；再强制刷新一次前台（Ctrl 或 Cmd 加 Shift 加 R），浏览器可能缓存了旧样式。手机上还要清一下站点缓存。仍然不对，把店铺编号和页面地址发给客服。": "先確認改動是否已經保存並發布；再強制刷新一次前台（Ctrl 或 Cmd 加 Shift 加 R），瀏覽器可能緩存了舊樣式。手機上還要清除一下站點緩存。仍然不對，把店鋪編號和頁面地址發給客服。",
    "怎么把 1688、淘宝的商品搬到店铺里？": "怎麼把 1688、淘寶的商品搬到店鋪裡？",
    "在后台「商品 → 采集」里贴商品链接，选目标分类和加价规则，确认后生成商品草稿；检查图片、规格、库存再上架。带别人店铺 logo 或水印的图，建议换掉再用。": "在後台「商品 → 采集」裡貼商品連結，選目標分類和加價規則，確認後生成商品草稿；檢查圖片、規格、庫存再上架。帶別人店鋪 logo 或水印的圖，建議換掉再用。",
    "商品价格怎么定？汇率和加价率在哪里改？": "商品價格怎麼定？匯率和加價率在哪裡改？",
    "在价格规则里配汇率和加价率，商品价格会按规则自动算；单个商品也可以在编辑页手工改价。改规则只影响之后的价格计算，已经生成的订单金额不变。": "在價格規則裡配匯率和加價率，商品價格會按規則自動算；單個商品也可以在編輯頁手工改價。改規則只影響之後的價格計算，已經生成的訂單金額不變。",
    "客户下单以后，我要做哪些操作？": "客戶下單以後，我要做哪些操作？",
    "订单列表里能看到待采购和待发货。先按订单采购，再录入物流单号发货；单号录入后，客户在店铺前台就能看到轨迹。状态卡在某一环节时，后台会有提示。": "訂單列表裡能看到待採購和待發貨。先按訂單採購，再錄入物流單號發貨；單號錄入後，客戶在店鋪前台就能看到軌跡。狀態卡在某一環節時，後台會有提示。",
    "物流轨迹一直不更新，是丢件了吗？": "物流軌跡一直不更新，是丟件了嗎？",
    "单号录入后通常 24 小时内才有第一条轨迹，节假日会更慢。超过 48 小时没有更新，先核对单号和渠道有没有填错；确认无误就把订单号发给客服，由平台向渠道查件。": "單號錄入後通常 24 小時內才有第一條軌跡，節假日會更慢。超過 48 小時沒有更新，先核對單號和渠道有沒有填錯；確認無誤就把訂單號發給客服，由平台向渠道查件。",
    "客户要退款，钱是从哪里退的？": "客戶要退款，錢是從哪裡退的？",
    "从你绑定的收款账户原路退回，平台不经手这笔钱。在订单详情点「退款」，填金额和原因，客户一般 3 到 5 个工作日收到。已经发货的订单，建议先和客户确认拒收或退回。": "從你綁定的收款賬戶原路退回，平台不經手這筆錢。在訂單詳情點「退款」，填金額和原因，客戶一般 3 到 5 個工作日收到。已經發貨的訂單，建議先和客戶確認拒收或退回。",
    "后台余额怎么充值？提现多久到账？": "後台餘額怎麼充值？提現多久到賬？",
    "充值在「余额」页按提示转账并提交凭证，到账后就能用于采购和扣费。提现提交后按后台显示的结算周期处理，具体时效和手续费以提现页说明为准。": "充值在「餘額」頁按提示轉賬並提交憑證，到賬後就能用於採購和扣費。提現提交後按後台顯示的結算周期處理，具體時效和手續費以提現頁說明為準。",
    "平台服务费和佣金是怎么算的？在哪里看？": "平台服務費和佣金是怎麼算的？在哪裡看？",
    "按订单实付金额和你所在套餐的费率计算，账单在后台的账单与佣金页可以逐单核对。对某笔金额有疑问，带上订单号问客服，能查到具体的计费口径。": "按訂單實付金額和你所在套餐的費率計算，賬單在後台的賬單與佣金頁可以逐單核對。對某筆金額有疑問，帶上訂單號問客服，能查到具體的計費口徑。",
    "AI 客服答错了，怎么调整？": "AI 客服答錯了，怎麼調整？",
    "AI 客服只按你给的知识库和话术回答。答错通常是知识库缺这一条：把标准答案补进去，再实测几次。涉及价格、售后时效这类敏感问题，建议写成明确规则，让它照规则说。": "AI 客服只按你給的知識庫和話術回答。答錯通常是知識庫缺這一條：把標準答案補進去，再實測幾次。涉及價格、售後時效這類敏感問題，建議寫成明確規則，讓它照規則說。",
    "前台能显示多种语言吗？翻译不准能不能自己改？": "前台能顯示多種語言嗎？翻譯不准能不能自己改？",
    "支持 20 种语言，访客进来会按浏览器语言自动显示对应版本。词条在后台语言包里可以直接改，改完前台即时生效；某个语种整段没翻译时，会回退显示英文。": "支持 20 種語言，訪客進來會按瀏覽器語言自動顯示對應版本。詞條在後台語言包裡可以直接改，改完前台即時生效；某個語種整段沒翻譯時，會回退顯示英文。",
    "子账号怎么开？能不能限制他只能看一部分功能？": "子帳號怎麼開？能不能限制他只能看一部分功能？",
    "在「权限管理」里新增管理员并勾选他能访问的菜单，子账号登录后只看到被授权的页面，订单、提现这类敏感操作可以单独关掉。员工离职直接停用账号即可。": "在「權限管理」裡新增管理員並勾選他能訪問的菜單，子帳號登錄後只看到被授權的頁面，訂單、提現這類敏感操作可以單獨關掉。員工離職直接停用帳號即可。",
    "忘记密码 / 换了手机号，怎么找回？": "忘記密碼 / 換了手機號，怎麼找回？",
    "登录页点「忘记密码」，用注册邮箱收验证码重置。邮箱也收不到、或者注册手机号已经停用，就把店铺编号和注册邮箱发给客服，核验后人工处理。": "登錄頁點「忘記密碼」，用註冊郵箱收驗證碼重置。郵箱也收不到、或者註冊手機號已經停用，就把店鋪編號和註冊郵箱發給客服，核驗後人工處理。",
    "能不能对接我自己的 ERP？数据怎么同步？": "能不能對接我自己的 ERP？數據怎麼同步？",
    "可以。平台开放 REST 接口和 Webhook：用 ERP 管货的，只同步库存；用自己系统管订单的，只拉订单。接口按店铺隔离，一个 Token 只能读自己店的数据，先在沙箱环境联调。": "可以。平台開放 REST 接口和 Webhook：用 ERP 管貨的，只同步庫存；用自己的系統管訂單的，只拉訂單。接口按店鋪隔離，一個 Token 只能讀取自己店的數據，先在沙箱環境聯調。",
    "首页": "首頁",
    "功能": "功能",
    "案例": "案例",
    "试用版": "試用版",
    "单店版": "單店版",
    "起步版": "起步版",
    "成长版": "成長版",
    "先免费用 14 天，把店开起来看效果": "先免費用 14 天，把店開起來看效果",
    "一个人做代购，够用就好": "一個人做代購，夠用就好",
    "有团队之后的第一档": "有團隊之後的第一檔",
    "多店、批量铺货、要账期": "多店、批量鋪貨、要賬期"
}
